import { html as runeHtml } from 'rune-ts';
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import { html as fxjsHtml } from 'fxjs/es';
import iconKlass from './Icons.module.scss';

type IconProps = {
  html?: typeof runeHtml | typeof fxjsHtml;
  klass?: string;
};

export const adultIcon = ({ html = runeHtml, klass = iconKlass.adult }: IconProps = {}) => html`
  <div class="${klass}">
    <svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" viewBox="0 0 12 9" fill="none">
      <path
        d="M7.97437 8.22211e-05C9.73218 0.011801 11.3962 1.05477 11.3962 4.1368C11.408 7.01961 10.0369 8.71883 7.90405 8.71883C6.19312 8.71883 5.03296 7.65243 4.85718 6.21102H6.59155C6.73218 6.83211 7.22437 7.20711 7.90405 7.20711C9.06421 7.20711 9.67358 6.17586 9.67358 4.47664H9.60327C9.20483 5.22664 8.3728 5.67196 7.42358 5.67196C5.90015 5.67196 4.77515 4.52352 4.76343 2.94149C4.76343 1.23055 6.05249 -0.0116365 7.97437 8.22211e-05ZM7.98608 1.38289C7.1189 1.38289 6.47437 2.05086 6.48608 2.89461C6.48608 3.72664 7.10718 4.38289 7.97437 4.38289C8.82983 4.38289 9.4978 3.70321 9.4978 2.88289C9.48608 2.0743 8.85327 1.38289 7.98608 1.38289Z"
        fill="currentColor"
      />
      <path
        d="M3.76172 0.117188V8.60156H1.99219V1.79297H1.94531L0 3.01172V1.45312L2.09766 0.117188H3.76172Z"
        fill="currentColor"
      />
    </svg>
  </div>
`;

export const shareIcon = ({ html = runeHtml, klass = '' }: IconProps = {}) => html`
  <svg
    class="${klass}"
    width="100%"
    height="100%"
    viewBox="0 0 21 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M19.3171 10.1106L13.0671 16.3606C12.9797 16.4482 12.8683 16.5078 12.747 16.5319C12.6257 16.5561 12.5 16.5437 12.3857 16.4963C12.2714 16.449 12.1738 16.3688 12.1051 16.2659C12.0365 16.1631 11.9999 16.0421 12 15.9185V12.8114C7.53901 13.0646 4.48042 15.9575 3.62183 16.8739C3.48701 17.0179 3.31021 17.1157 3.11659 17.1534C2.92298 17.1911 2.72241 17.1667 2.54343 17.0838C2.36446 17.0009 2.21619 16.8636 2.11974 16.6916C2.02328 16.5195 1.98355 16.3214 2.0062 16.1255C2.29605 13.6052 3.67651 11.181 5.8937 9.29971C7.73511 7.73721 9.97339 6.7458 12 6.57237V3.41846C11.9999 3.29478 12.0365 3.17384 12.1051 3.07097C12.1738 2.9681 12.2714 2.88792 12.3857 2.84057C12.5 2.79323 12.6257 2.78085 12.747 2.80501C12.8683 2.82916 12.9797 2.88877 13.0671 2.97627L19.3171 9.22627C19.3752 9.28432 19.4213 9.35325 19.4528 9.42912C19.4843 9.505 19.5004 9.58633 19.5004 9.66846C19.5004 9.7506 19.4843 9.83192 19.4528 9.9078C19.4213 9.98367 19.3752 10.0526 19.3171 10.1106Z"
      fill="currentColor"
    />
  </svg>
`;

export const systemIcon = ({ html = runeHtml, klass = '' }: IconProps = {}) => html`
  <svg
    class="${klass}"
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    height="100%"
    viewBox="0 0 16 17"
    fill="none"
  >
    <g id="System Icon" clip-path="url(#clip0_2334_42256)">
      <g id="Vector">
        <path
          d="M14.0802 8.48665C13.7602 8.48665 13.4936 8.74665 13.4936 9.07331V13.76C13.4936 13.8933 13.3469 14.0066 13.1736 14.0066H2.82024C2.6469 14.0066 2.50024 13.8933 2.50024 13.76V9.07331C2.50024 8.75331 2.24024 8.48665 1.91357 8.48665C1.5869 8.48665 1.3269 8.74665 1.3269 9.07331V13.76C1.3269 14.54 1.99357 15.1733 2.81357 15.1733H13.1669C13.9869 15.1733 14.6536 14.54 14.6536 13.76V9.07331C14.6536 8.75331 14.3936 8.48665 14.0669 8.48665H14.0802Z"
          fill="currentColor"
        />
        <path
          d="M7.5869 11.38C7.64024 11.4333 7.7069 11.4733 7.77357 11.5066C7.8469 11.5333 7.92024 11.5533 8.00024 11.5533C8.08024 11.5533 8.15357 11.54 8.2269 11.5066C8.30024 11.48 8.36024 11.4333 8.41357 11.38L10.5869 9.20665C10.8136 8.97998 10.8136 8.60665 10.5869 8.37998C10.3602 8.15331 9.98691 8.15331 9.76024 8.37998L8.5869 9.55331V2.41998C8.5869 2.09998 8.3269 1.83331 8.00024 1.83331C7.67357 1.83331 7.41357 2.09331 7.41357 2.41998V9.56665L6.24024 8.39331C6.01357 8.16665 5.64024 8.16665 5.41357 8.39331C5.1869 8.61998 5.1869 8.99331 5.41357 9.21998L7.5869 11.3933V11.38Z"
          fill="currentColor"
        />
      </g>
    </g>
    <defs>
      <clipPath id="clip0_2334_42256">
        <rect width="16" height="16" fill="white" transform="translate(0 0.5)" />
      </clipPath>
    </defs>
  </svg>
`;
export const mspLogoIconV1 = ({ html = runeHtml, klass = '' }: IconProps = {}) => html`
  <svg
    class="${klass}"
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    height="100%"
    viewBox="0 0 78 40"
    fill="none"
  >
    <g id="Vector">
      <path
        d="M71.7411 26.1642C72.2559 25.5127 72.7441 24.8463 73.2031 24.1636C73.221 24.1369 73.2397 24.1106 73.2575 24.0839C73.2729 24.0609 73.2875 24.0376 73.3027 24.0145C74.0601 22.873 74.7317 21.6839 75.2995 20.4384C75.7826 19.3784 76.1916 18.2782 76.51 17.1293C77.4343 13.7937 77.5212 10.4615 76.208 7.22471C74.233 2.35664 69.8721 0 65.5218 0C61.5639 0 57.6149 1.94883 55.4746 5.73018C55.4336 5.80255 55.3915 5.8743 55.346 5.95104C55.2803 6.06188 55.1197 6.06188 55.054 5.95104C55.0085 5.8743 54.9663 5.80255 54.9254 5.73018C52.7853 1.94932 48.8356 0 44.8782 0C40.5273 0 36.1672 2.35615 34.192 7.22471C32.8788 10.4615 32.9657 13.7937 33.89 17.1293C34.2084 18.2782 34.6174 19.3784 35.1005 20.4384C35.6683 21.6839 36.3399 22.873 37.0973 24.0146C37.1125 24.0376 37.1271 24.0609 37.1425 24.0839C37.1602 24.1106 37.179 24.1369 37.1969 24.1636C37.6558 24.8463 38.1441 25.5127 38.6589 26.1642C43.1721 31.876 48.7704 36.2798 54.9649 39.9517C55.0233 39.9862 55.1072 40 55.1896 40C55.191 40 55.1924 39.9998 55.1937 39.9998L55.1948 40C55.1955 40 55.1961 39.9996 55.1967 39.9996C55.2943 39.9987 55.3889 39.979 55.4351 39.9517C61.6296 36.2798 67.2279 31.876 71.7411 26.1642ZM37.7694 19.5301C37.7267 19.3428 37.6459 19.1703 37.5363 19.0198C37.5295 19.0105 37.5236 19.0004 37.519 18.9898C37.142 18.1284 36.832 17.2607 36.5884 16.3815C36.2646 15.2132 36.0754 14.103 36.0196 13.0421C36.0119 12.8947 36.18 12.8068 36.2947 12.8995C38.161 14.4085 40.968 15.5679 44.2159 16.3576C44.2858 16.3746 44.3373 16.4336 44.3443 16.5052C44.3977 17.0559 44.465 17.6071 44.545 18.1585C44.9084 20.6631 45.5055 22.9275 46.2561 25.0289C46.3016 25.1563 46.1876 25.2836 46.0562 25.2515C44.7536 24.9333 43.5404 24.5458 42.4485 24.0905C42.4356 24.0851 42.4228 24.0798 42.4099 24.0744C40.4224 23.2404 38.8172 21.695 37.8739 19.757C37.8424 19.6923 37.8113 19.6275 37.7805 19.5628C37.7756 19.5523 37.7719 19.5414 37.7694 19.5301ZM47.4349 9.28135C48.1789 5.77881 49.5348 4.6 50.0391 4.6C50.4499 4.6 51.6092 5.47324 52.378 8.06768C52.4084 8.17012 52.4398 8.27148 52.4753 8.38535L52.5241 8.54287C52.8859 9.71729 53.9712 10.5185 55.2 10.5185C56.4288 10.5185 57.5141 9.71729 57.8759 8.54287L57.9247 8.38535C57.9602 8.27148 57.9916 8.17012 58.0219 8.06787C58.7908 5.47324 59.9501 4.6 60.3608 4.6C60.8651 4.6 62.2211 5.77881 62.9651 9.28145C63.2775 10.7521 63.4206 12.3025 63.3974 13.9614C63.3963 14.0433 63.3372 14.1137 63.2565 14.128C60.7691 14.5674 58.0345 14.7991 55.2 14.7991C52.3655 14.7991 49.6309 14.5674 47.1435 14.128C47.0628 14.1137 47.0037 14.0433 47.0026 13.9614C46.9794 12.3025 47.1225 10.7521 47.4349 9.28135ZM55.2 17.5991C57.8101 17.5991 60.4611 17.3959 62.9666 16.9978C63.078 16.9802 63.1751 17.0732 63.161 17.1851C63.1372 17.3741 63.1119 17.5644 63.084 17.7565C62.6871 20.4925 61.9672 23.0962 60.8832 25.7165C60.8829 25.7172 60.8826 25.7178 60.8824 25.7185C60.8321 25.8396 60.7196 25.9236 60.5895 25.9403C58.87 26.1616 57.0587 26.278 55.2 26.278C53.3412 26.278 51.5301 26.1616 49.8105 25.9403C49.6804 25.9236 49.5679 25.8396 49.5176 25.7184C49.5174 25.7178 49.5171 25.7171 49.5168 25.7164C48.4328 23.0962 47.7129 20.4925 47.316 17.7565C47.2881 17.5644 47.2628 17.3741 47.2389 17.1851C47.2248 17.0732 47.322 16.9802 47.4334 16.9978C49.9389 17.3959 52.5899 17.5991 55.2 17.5991ZM73.8116 16.3816C73.568 17.2607 73.258 18.1283 72.881 18.9898C72.8764 19.0004 72.8705 19.0105 72.8637 19.0198C72.7541 19.1702 72.6732 19.3428 72.6305 19.5302C72.628 19.5414 72.6243 19.5524 72.6194 19.5628C72.5888 19.6274 72.5577 19.692 72.5263 19.7565C71.5831 21.6948 69.9778 23.2404 67.9901 24.0744C67.9772 24.0798 67.9644 24.0852 67.9515 24.0905C66.8596 24.5458 65.6465 24.9333 64.3438 25.2515C64.2124 25.2836 64.0984 25.1563 64.1439 25.0289C64.8945 22.9275 65.4916 20.6631 65.855 18.1585C65.935 17.6071 66.0023 17.0559 66.0557 16.5052C66.0627 16.4336 66.1142 16.3746 66.1841 16.3576C69.432 15.5679 72.239 14.4085 74.1053 12.8995C74.22 12.8068 74.3881 12.8947 74.3804 13.0421C74.3246 14.103 74.1354 15.2132 73.8116 16.3816ZM59.2939 29.1563C58.1405 31.4167 56.8302 33.5253 55.3365 35.5077C55.2685 35.598 55.1315 35.598 55.0635 35.5077C53.5699 33.5253 52.2595 31.4166 51.1061 29.1563C51.0455 29.0375 51.1394 28.8985 51.2722 28.9099C52.5525 29.0199 53.8661 29.078 55.2 29.078C56.534 29.078 57.8475 29.0199 59.1278 28.9099C59.2606 28.8985 59.3545 29.0375 59.2939 29.1563ZM47.6878 28.5236C48.3796 30.037 49.1151 31.4498 49.8885 32.7747C49.9826 32.9359 49.7856 33.1079 49.6377 32.9941C47.5303 31.3735 45.6228 29.6792 43.8991 27.8976C43.7777 27.7721 43.8992 27.5675 44.0668 27.6163C45.1701 27.9379 46.3409 28.2095 47.564 28.4276C47.6184 28.4373 47.6648 28.4733 47.6878 28.5236ZM62.836 28.4276C64.0591 28.2095 65.2298 27.9379 66.333 27.6164C66.5007 27.5675 66.6221 27.7721 66.5007 27.8976C64.7771 29.6792 62.8698 31.3734 60.7624 32.9939C60.6145 33.1077 60.4175 32.9357 60.5116 32.7745C61.285 31.4496 62.0204 30.0369 62.7122 28.5236C62.7352 28.4733 62.7816 28.4373 62.836 28.4276ZM73.6134 8.27735C73.6138 8.27827 73.6141 8.2792 73.6145 8.28013C73.6996 8.49029 73.7219 8.72416 73.6659 8.94385C73.3411 10.217 71.5688 11.5726 68.784 12.6452C68.043 12.9306 67.2483 13.1879 66.4119 13.4192C66.3045 13.4488 66.1982 13.3684 66.1967 13.2569C66.1759 11.7231 66.0228 10.2005 65.704 8.69961C65.1823 6.24331 64.3274 4.45662 63.3163 3.31758C63.2318 3.22232 63.2782 3.07013 63.4023 3.04126C64.0818 2.88312 64.7915 2.8 65.5218 2.8C67.2305 2.8 68.8661 3.26641 70.2518 4.14873C71.7607 5.10957 72.8918 6.49863 73.6134 8.27735ZM40.1481 4.14844C41.5336 3.26631 43.1692 2.8 44.8782 2.8C45.6084 2.8 46.318 2.88312 46.9975 3.04126C47.1216 3.07013 47.1681 3.22232 47.0835 3.31757C46.0725 4.45652 45.2178 6.24305 44.696 8.69961C44.3772 10.2005 44.2241 11.7231 44.2033 13.257C44.2017 13.3684 44.0955 13.4488 43.9881 13.4192C43.1517 13.1879 42.357 12.9306 41.616 12.6452C38.8312 11.5726 37.0589 10.217 36.7341 8.94385C36.6781 8.72416 36.7004 8.49029 36.7855 8.28013C36.7859 8.2792 36.7862 8.27828 36.7866 8.27735C37.5083 6.49835 38.6394 5.10918 40.1481 4.14844Z"
        fill="currentColor"
      />
      <path
        d="M20.3312 0C20.139 0 19.974 0.13659 19.9382 0.325336L14.7965 27.387C14.7553 27.6039 14.4447 27.6039 14.4035 27.387L9.26181 0.325336C9.22595 0.13659 9.06097 0 8.86884 0H0.4C0.179086 0 0 0.179086 0 0.4V39.6C0 39.8209 0.179086 40 0.4 40H5.6C5.82091 40 6 39.8209 6 39.6V14.0198C6 13.7782 6.34874 13.7437 6.39612 13.9806L11.5357 39.6784C11.5731 39.8654 11.7372 40 11.9279 40H17.2721C17.4627 40 17.6269 39.8654 17.6643 39.6784L22.8039 13.9806C22.8513 13.7437 23.2 13.7782 23.2 14.0198V39.6C23.2 39.8209 23.3791 40 23.6 40H28.8C29.0209 40 29.2 39.8209 29.2 39.6V0.4C29.2 0.179086 29.0209 0 28.8 0H20.3312Z"
        fill="currentColor"
      />
    </g>
  </svg>
`;

const fillColors = {
  gray: '#6B6B6B',
  blue: '#1C75FF',
  white: '#ffffff',
  gray20: '#D9D9D9',
  gray50: '#A2A2A2',
};

type FanIconProps = IconProps & { color?: keyof typeof fillColors };

export const myFanIconHeart = ({ html = runeHtml, color = 'gray' }: FanIconProps = {}) =>
  html` <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g id="Heart">
      <path
        id="Vector"
        d="M21.5327 7.26C20.6335 5.06 18.6552 4 16.6768 4C14.8783 4 13.0898 4.88 12.1106 6.58C12.0907 6.61 12.0707 6.65 12.0507 6.68C12.0307 6.71 12.0107 6.72 11.9808 6.72C11.9508 6.72 11.9308 6.71 11.9108 6.68C11.8908 6.65 11.8708 6.61 11.8509 6.58C10.8817 4.88 9.08319 4 7.2847 4C5.32634 4 3.348 5.06 2.44876 7.26C1.23977 10.22 2.65858 13.49 4.50703 15.86C8.22391 20.28 11.2514 21.71 11.8808 21.98C11.9608 22.01 12.0407 22.01 12.1206 21.98C12.7501 21.72 15.7676 20.29 19.4944 15.86C21.3329 13.49 22.7617 10.22 21.5527 7.26H21.5327Z"
        fill="${fillColors[color]}"
      />
    </g>
  </svg>`;

export const myFanIconCheck = ({ html = runeHtml, color = 'gray' }: FanIconProps = {}) => html`
  <svg width="17" height="16" viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g id="Input Status Check">
      <path
        id="Union"
        d="M4.37326 7.17485C4.03137 6.83296 3.47705 6.83296 3.13516 7.17485C2.79327 7.51674 2.79327 8.07106 3.13516 8.41295L6.48803 11.7658C6.8014 12.0792 7.30948 12.0792 7.62286 11.7658L13.865 5.52371C14.2069 5.18182 14.2069 4.6275 13.865 4.28561C13.5231 3.94372 12.9688 3.94372 12.6269 4.28561L7.4681 9.44439C7.2402 9.67229 6.87069 9.67229 6.64279 9.44439L4.37326 7.17485Z"
        fill="${fillColors[color]}"
      />
    </g>
  </svg>
`;

export const arrowIcon = ({ html = runeHtml, klass = '' }: IconProps = {}) => html`
  <svg
    class="${klass}"
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    height="100%"
    viewBox="0 0 16 16"
    fill="none"
  >
    <g clip-path="url(#a)">
      <path
        fill="currentColor"
        d="M8.08 13.92a.587.587 0 0 1-.413-1l4.34-4.34h-9.42a.588.588 0 0 1 0-1.173h9.426l-4.34-4.34a.587.587 0 0 1 0-.827.587.587 0 0 1 .827 0l5.333 5.333c.054.054.1.12.127.194a.71.71 0 0 1 .047.206v.02c0 .074-.02.147-.047.207a.606.606 0 0 1-.127.193L8.5 13.727a.592.592 0 0 1-.413.173l-.007.02Z"
      />
    </g>
    <defs>
      <clipPath id="a">
        <path fill="#fff" d="M0 0h16v16H0z" />
      </clipPath>
    </defs>
  </svg>
`;
export const plusIcon = ({ html = runeHtml, klass = '' }: IconProps = {}) => html`
  <svg
    class="${klass}"
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    height="100%"
    viewBox="0 0 24 24"
    fill="none"
  >
    <g clip-path="url(#clip0_11381_99429)">
      <path
        d="M21.12 11.12H12.87V2.88C12.87 2.4 12.48 2 11.99 2C11.5 2 11.11 2.39 11.11 2.88V11.13H2.88C2.4 11.13 2 11.52 2 12.01C2 12.5 2.39 12.89 2.88 12.89H11.13V21.14C11.13 21.62 11.52 22.02 12.01 22.02C12.5 22.02 12.89 21.63 12.89 21.14V12.89H21.14C21.62 12.89 22.02 12.5 22.02 12.01C22.02 11.52 21.63 11.13 21.14 11.13L21.12 11.12Z"
        fill="#141414"
      />
    </g>
    <defs>
      <clipPath id="clip0_11381_99429">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
`;
export const HeartOutlineIcon = ({ html = runeHtml, klass = '' }: IconProps = {}) => html`
  <svg
    class="${klass}"
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    height="100%"
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      d="M16.6968 5.75C18.1656 5.75 19.3745 6.56 19.9341 7.92C21.0232 10.58 19.0548 13.57 18.1356 14.76C15.3779 18.03 13.0499 19.52 12.0107 20.09C10.9716 19.53 8.63356 18.03 5.88587 14.76C4.96664 13.57 3.00829 10.58 4.08738 7.92C4.64691 6.56 5.8559 5.75 7.32466 5.75C8.62357 5.75 9.76262 6.39 10.3721 7.45L10.452 7.58C10.7818 8.13 11.3813 8.47 12.0207 8.47C12.6602 8.47 13.2597 8.13 13.5894 7.58L13.6693 7.45C14.2788 6.38 15.4179 5.75 16.7168 5.75M16.6968 4C14.8983 4 13.1098 4.88 12.1306 6.58C12.1106 6.61 12.0907 6.65 12.0707 6.68C12.0607 6.7 12.0307 6.72 12.0007 6.72C11.9708 6.72 11.9508 6.71 11.9308 6.68C11.9108 6.65 11.8908 6.61 11.8708 6.58C10.9017 4.88 9.10317 4 7.30468 4C5.32634 4 3.348 5.06 2.44876 7.26C1.23977 10.22 2.65858 13.49 4.50703 15.86C8.22391 20.28 11.2514 21.71 11.8808 21.98C11.9208 22 11.9608 22 12.0007 22C12.0407 22 12.0807 22 12.1206 21.98C12.7501 21.72 15.7676 20.29 19.4944 15.86C21.3329 13.49 22.7617 10.22 21.5527 7.26C20.6535 5.06 18.6751 4 16.6968 4Z"
      fill="currentColor"
    />
  </svg>
`;
export const HeartFillIcon = ({ html = runeHtml, klass = '' }: IconProps = {}) => html`
  <svg
    class="${klass}"
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    height="100%"
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      d="M21.5327 7.26C20.6335 5.06 18.6552 4 16.6768 4C14.8783 4 13.0898 4.88 12.1106 6.58C12.0907 6.61 12.0707 6.65 12.0507 6.68C12.0307 6.71 12.0107 6.72 11.9808 6.72C11.9508 6.72 11.9308 6.71 11.9108 6.68C11.8908 6.65 11.8708 6.61 11.8509 6.58C10.8817 4.88 9.08319 4 7.2847 4C5.32634 4 3.348 5.06 2.44876 7.26C1.23977 10.22 2.65858 13.49 4.50703 15.86C8.22391 20.28 11.2514 21.71 11.8808 21.98C11.9608 22.01 12.0407 22.01 12.1206 21.98C12.7501 21.72 15.7676 20.29 19.4944 15.86C21.3329 13.49 22.7617 10.22 21.5527 7.26H21.5327Z"
      fill="currentColor"
    />
  </svg>
`;
export const HomeOutlineIcon = ({ html = runeHtml, klass = '' }: IconProps = {}) => html`
  <svg
    class="${klass}"
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    height="100%"
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      d="M12 3.96L20.25 10.56V20.25H16.25V16.5C16.25 14.16 14.34 12.25 12 12.25C9.66 12.25 7.75 14.16 7.75 16.5V20.25H3.75V10.56L12 3.96ZM12 2C11.78 2 11.56 2.07 11.38 2.22L2.38 9.42C2.14 9.61 2 9.9 2 10.2V21C2 21.55 2.45 22 3 22H8.5C9.05 22 9.5 21.55 9.5 21V16.5C9.5 15.12 10.62 14 12 14C13.38 14 14.5 15.12 14.5 16.5V21C14.5 21.55 14.95 22 15.5 22H21C21.55 22 22 21.55 22 21V10.2C22 9.9 21.86 9.61 21.62 9.42L12.62 2.22C12.44 2.07 12.22 2 12 2Z"
      fill="currentColor"
    />
  </svg>
`;
export const HomeFillIcon = ({ html = runeHtml, klass = '' }: IconProps = {}) => html`
  <svg
    class="${klass}"
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    height="100%"
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      d="M11.38 2.22L2.38 9.42C2.14 9.61 2 9.9 2 10.2V21C2 21.55 2.45 22 3 22H8.5C9.05 22 9.5 21.55 9.5 21V16.5C9.5 15.12 10.62 14 12 14C13.38 14 14.5 15.12 14.5 16.5V21C14.5 21.55 14.95 22 15.5 22H21C21.55 22 22 21.55 22 21V10.2C22 9.9 21.86 9.61 21.62 9.42L12.62 2.22C12.25 1.93 11.74 1.93 11.37 2.22H11.38Z"
      fill="currentColor"
    />
  </svg>
`;
export const UserOutlineIcon = ({ html = runeHtml, klass = '' }: IconProps = {}) => html`
  <svg
    class="${klass}"
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    height="100%"
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      d="M12 3.75C13.3793 3.75 14.4987 4.87 14.4987 6.25C14.4987 7.63 13.3793 8.75 12 8.75C10.6208 8.75 9.50135 7.63 9.50135 6.25C9.50135 4.87 10.6208 3.75 12 3.75ZM12 2C9.65127 2 7.75227 3.9 7.75227 6.25C7.75227 8.6 9.65127 10.5 12 10.5C14.3488 10.5 16.2478 8.6 16.2478 6.25C16.2478 3.9 14.3488 2 12 2Z"
      fill="currentColor"
    />
    <path
      d="M12 13.75C15.958 13.75 19.3062 16.49 20.1158 20.25H3.88428C4.69386 16.49 8.04211 13.75 12 13.75ZM12 12C6.82275 12 2.55498 15.9 2.00526 20.9C1.9453 21.49 2.40506 22 3.00474 22H20.9954C21.585 22 22.0548 21.49 21.9948 20.9C21.4451 15.89 17.1873 12 12.01 12H12Z"
      fill="currentColor"
    />
  </svg>
`;
export const UserFillIcon = ({ html = runeHtml, klass = '' }: IconProps = {}) => html`
  <svg
    class="${klass}"
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    height="100%"
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      d="M12 10.5C14.346 10.5 16.2478 8.59721 16.2478 6.25C16.2478 3.90279 14.346 2 12 2C9.65406 2 7.75227 3.90279 7.75227 6.25C7.75227 8.59721 9.65406 10.5 12 10.5Z"
      fill="currentColor"
    />
    <path
      d="M12 12C6.82275 12 2.55498 15.9 2.00526 20.9C1.9453 21.49 2.40506 22 3.00474 22H20.9954C21.585 22 22.0548 21.49 21.9948 20.9C21.4451 15.89 17.1873 12 12.01 12H12Z"
      fill="currentColor"
    />
  </svg>
`;
export const SearchIcon = ({ html = runeHtml, klass = '' }: IconProps = {}) => html`
  <svg
    class="${klass}"
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    height="100%"
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      d="M21.74 20.5007L17.79 16.5527C19.05 15.0135 19.81 13.0445 19.81 10.9055C19.82 5.998 15.83 2 10.91 2C5.99 2 2 5.998 2 10.9055C2 15.8131 6 19.8111 10.91 19.8111C13.05 19.8111 15.02 19.0515 16.56 17.7921L20.51 21.7401C20.68 21.91 20.91 22 21.13 22C21.35 22 21.58 21.91 21.75 21.7401C22.09 21.4003 22.09 20.8406 21.75 20.5007H21.74ZM3.75 10.9055C3.75 6.95752 6.96 3.74913 10.91 3.74913C14.86 3.74913 18.07 6.95752 18.07 10.9055C18.07 14.8536 14.86 18.062 10.91 18.062C6.96 18.062 3.75 14.8536 3.75 10.9055Z"
      fill="currentColor"
    />
  </svg>
`;
export const CartOutlineIcon = ({ html = runeHtml, klass = '' }: IconProps = {}) => html`
  <svg
    class="${klass}"
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    height="100%"
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      d="M21.8002 6.2701C21.6302 6.0701 21.3902 5.9501 21.1302 5.9501H7.14023L6.18023 2.3501H2.87023C2.39023 2.3501 1.99023 2.7401 1.99023 3.2301C1.99023 3.7201 2.38023 4.1101 2.87023 4.1101H4.83023L7.98023 15.9401C8.01023 16.0401 8.05023 16.1301 8.10023 16.2001C8.13024 16.2401 8.16023 16.2701 8.19023 16.3001C8.22023 16.3401 8.25023 16.3801 8.29023 16.4101C8.33023 16.4401 8.38023 16.4601 8.43023 16.4901C8.47023 16.5101 8.50023 16.5301 8.53023 16.5501C8.62023 16.5801 8.71024 16.6001 8.81024 16.6001H19.4202C19.8402 16.6001 20.2002 16.3001 20.2802 15.8901L21.9702 7.0001C22.0202 6.7401 21.9502 6.4801 21.7802 6.2801L21.8002 6.2701ZM18.7102 14.8401H9.50023L7.60023 7.7001H20.0702L18.7102 14.8401Z"
      fill="currentColor"
    />
    <path
      d="M10.4202 21.6001C11.2984 21.6001 12.0102 20.8882 12.0102 20.0101C12.0102 19.132 11.2984 18.4201 10.4202 18.4201C9.5421 18.4201 8.83023 19.132 8.83023 20.0101C8.83023 20.8882 9.5421 21.6001 10.4202 21.6001Z"
      fill="currentColor"
    />
    <path
      d="M18.0402 21.6001C18.9184 21.6001 19.6302 20.8882 19.6302 20.0101C19.6302 19.132 18.9184 18.4201 18.0402 18.4201C17.1621 18.4201 16.4502 19.132 16.4502 20.0101C16.4502 20.8882 17.1621 21.6001 18.0402 21.6001Z"
      fill="currentColor"
    />
  </svg>
`;
export const CartFillIcon = ({ html = runeHtml, klass = '' }: IconProps = {}) => html`
  <svg
    class="${klass}"
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    height="100%"
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      d="M21.8002 6.2701C21.6302 6.0701 21.3902 5.9501 21.1302 5.9501H7.14023L6.18023 2.3501H2.87023C2.39023 2.3501 1.99023 2.7401 1.99023 3.2301C1.99023 3.7201 2.38023 4.1101 2.87023 4.1101H4.83023L7.98023 15.9401C8.01023 16.0401 8.05023 16.1301 8.10023 16.2001C8.13024 16.2401 8.16023 16.2701 8.19023 16.3001C8.22023 16.3401 8.25023 16.3801 8.29023 16.4101C8.33023 16.4401 8.38023 16.4601 8.43023 16.4901C8.47023 16.5101 8.50023 16.5301 8.53023 16.5501C8.62023 16.5801 8.71024 16.6001 8.81024 16.6001H19.4202C19.8402 16.6001 20.2002 16.3001 20.2802 15.8901L21.9702 7.0001C22.0202 6.7401 21.9502 6.4801 21.7802 6.2801L21.8002 6.2701Z"
      fill="#141414"
    />
    <path
      d="M10.4202 21.6001C11.2984 21.6001 12.0102 20.8882 12.0102 20.0101C12.0102 19.132 11.2984 18.4201 10.4202 18.4201C9.5421 18.4201 8.83023 19.132 8.83023 20.0101C8.83023 20.8882 9.5421 21.6001 10.4202 21.6001Z"
      fill="#141414"
    />
    <path
      d="M18.0402 21.6001C18.9184 21.6001 19.6302 20.8882 19.6302 20.0101C19.6302 19.132 18.9184 18.4201 18.0402 18.4201C17.1621 18.4201 16.4502 19.132 16.4502 20.0101C16.4502 20.8882 17.1621 21.6001 18.0402 21.6001Z"
      fill="#141414"
    />
  </svg>
`;
export const ClockOutlineIcon = ({ html = runeHtml, klass = '' }: IconProps = {}) => html`
  <svg
    class="${klass}"
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    height="100%"
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      d="M12 3.75C16.55 3.75 20.25 7.45 20.25 12C20.25 16.55 16.55 20.25 12 20.25C7.45 20.25 3.75 16.55 3.75 12C3.75 7.45 7.45 3.75 12 3.75ZM12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2Z"
      fill="currentColor"
    />
    <path
      d="M7.76 15.84C7.48 15.84 7.21 15.71 7.04 15.47C6.76 15.07 6.86 14.53 7.25 14.25L11.11 11.54V6.82C11.11 6.34 11.5 5.94 11.99 5.94C12.48 5.94 12.87 6.33 12.87 6.82V12.45L8.26 15.68C8.11 15.79 7.93 15.84 7.76 15.84Z"
      fill="currentColor"
    />
  </svg>
`;
export const ClockFillIcon = ({ html = runeHtml, klass = '' }: IconProps = {}) => html`
  <svg
    class="${klass}"
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    height="100%"
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      d="M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM12.88 12.46L8.27 15.69C8.12 15.8 7.94 15.85 7.77 15.85C7.49 15.85 7.22 15.72 7.05 15.48C6.77 15.08 6.87 14.54 7.26 14.26L11.12 11.55V6.83C11.12 6.35 11.51 5.95 12 5.95C12.49 5.95 12.88 6.34 12.88 6.83V12.46Z"
      fill="currentColor"
    />
  </svg>
`;
export const SmileOutlineIcon = ({ html = runeHtml, klass = '' }: IconProps = {}) => html`
  <svg
    class="${klass}"
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    height="100%"
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      d="M8.75 10.29C9.44036 10.29 10 9.73036 10 9.04C10 8.34964 9.44036 7.79 8.75 7.79C8.05964 7.79 7.5 8.34964 7.5 9.04C7.5 9.73036 8.05964 10.29 8.75 10.29Z"
      fill="currentColor"
    />
    <path
      d="M15.25 10.29C15.9404 10.29 16.5 9.73036 16.5 9.04C16.5 8.34964 15.9404 7.79 15.25 7.79C14.5596 7.79 14 8.34964 14 9.04C14 9.73036 14.5596 10.29 15.25 10.29Z"
      fill="currentColor"
    />
    <path
      d="M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM12 20.25C7.45 20.25 3.75 16.55 3.75 12C3.75 7.45 7.45 3.75 12 3.75C16.55 3.75 20.25 7.45 20.25 12C20.25 16.55 16.55 20.25 12 20.25Z"
      fill="currentColor"
    />
    <path
      d="M15.5 13.02C15.45 13.09 14.17 14.67 12 14.67C9.83 14.67 8.56 13.11 8.5 13.02C8.2 12.64 7.65 12.57 7.27 12.87C6.89 13.17 6.82 13.72 7.11 14.1C7.18 14.19 8.95 16.42 11.99 16.42C15.03 16.42 16.8 14.19 16.87 14.1C17.16 13.72 17.1 13.17 16.72 12.88C16.34 12.58 15.79 12.65 15.49 13.03L15.5 13.02Z"
      fill="currentColor"
    />
  </svg>
`;
export const SmileFillIcon = ({ html = runeHtml, klass = '' }: IconProps = {}) => html`
  <svg
    class="${klass}"
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    height="100%"
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      d="M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM15.25 7.79C15.94 7.79 16.5 8.35 16.5 9.04C16.5 9.73 15.94 10.29 15.25 10.29C14.56 10.29 14 9.73 14 9.04C14 8.35 14.56 7.79 15.25 7.79ZM8.75 7.79C9.44 7.79 10 8.35 10 9.04C10 9.73 9.44 10.29 8.75 10.29C8.06 10.29 7.5 9.73 7.5 9.04C7.5 8.35 8.06 7.79 8.75 7.79ZM16.88 14.09C16.81 14.18 15.04 16.41 12 16.41C8.96 16.41 7.19 14.18 7.12 14.09C6.82 13.71 6.89 13.16 7.28 12.86C7.66 12.56 8.21 12.63 8.51 13.01C8.58 13.09 9.85 14.66 12.01 14.66C14.17 14.66 15.46 13.08 15.51 13.01C15.81 12.63 16.36 12.57 16.74 12.86C17.12 13.16 17.19 13.7 16.89 14.08L16.88 14.09Z"
      fill="currentColor"
    />
  </svg>
`;
export const TextBubbleOutlineIcon = ({ html = runeHtml, klass = '' }: IconProps = {}) => html`
  <svg
    class="${klass}"
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    height="100%"
    viewBox="0 0 24 24"
    fill="none"
  >
    <g clip-path="url(#clip0_132_1417)">
      <path
        d="M6.99977 11.75C7.68977 11.75 8.24977 11.19 8.24977 10.5C8.24977 9.81 7.68977 9.25 6.99977 9.25C6.30977 9.25 5.74977 9.81 5.74977 10.5C5.74977 11.19 6.30977 11.75 6.99977 11.75Z"
        fill="currentColor"
      />
      <path
        d="M11.9998 11.75C12.6898 11.75 13.2498 11.19 13.2498 10.5C13.2498 9.81 12.6898 9.25 11.9998 9.25C11.3098 9.25 10.7498 9.81 10.7498 10.5C10.7498 11.19 11.3098 11.75 11.9998 11.75Z"
        fill="currentColor"
      />
      <path
        d="M16.9998 11.75C17.6898 11.75 18.2498 11.19 18.2498 10.5C18.2498 9.81 17.6898 9.25 16.9998 9.25C16.3098 9.25 15.7498 9.81 15.7498 10.5C15.7498 11.19 16.3098 11.75 16.9998 11.75Z"
        fill="currentColor"
      />
      <path
        d="M15.0098 5.25C17.8998 5.25 20.2498 7.6 20.2498 10.51C20.2498 12.28 19.3498 13.92 17.8598 14.9L17.1398 15.37L17.0798 16.23L16.9898 17.47L15.7298 16.24L15.2198 15.74H8.99977C6.10977 15.74 3.75977 13.39 3.75977 10.48C3.75977 7.57 6.10977 5.24 8.99977 5.24H15.0098M8.99977 3.5C5.14977 3.5 2.00977 6.65 2.00977 10.49C2.00977 14.35 5.15977 17.5 8.99977 17.5H14.5098L17.3798 20.3C17.5198 20.44 17.6998 20.5 17.8698 20.5C18.2098 20.5 18.5498 20.25 18.5698 19.85L18.8198 16.36C20.7298 15.11 22.0098 12.95 22.0098 10.51C22.0098 6.65 18.8598 3.5 15.0198 3.5H8.99977Z"
        fill="currentColor"
      />
    </g>
    <defs>
      <clipPath id="clip0_132_1417">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
`;
export const TextBubbleFillIcon = ({ html = runeHtml, klass = '' }: IconProps = {}) => html`
  <svg
    class="${klass}"
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    height="100%"
    viewBox="0 0 24 24"
    fill="none"
  >
    <g clip-path="url(#clip0_132_1422)">
      <path
        d="M15.0098 3.5H8.99977C5.14977 3.5 2.00977 6.65 2.00977 10.49C2.00977 14.35 5.15977 17.5 8.99977 17.5H14.5098L17.3798 20.3C17.8098 20.72 18.5298 20.44 18.5698 19.85L18.8198 16.36C20.7298 15.11 22.0098 12.95 22.0098 10.51C22.0098 6.65 18.8598 3.5 15.0198 3.5H15.0098ZM6.99977 11.75C6.30977 11.75 5.74977 11.19 5.74977 10.5C5.74977 9.81 6.30977 9.25 6.99977 9.25C7.68977 9.25 8.24977 9.81 8.24977 10.5C8.24977 11.19 7.68977 11.75 6.99977 11.75ZM11.9998 11.75C11.3098 11.75 10.7498 11.19 10.7498 10.5C10.7498 9.81 11.3098 9.25 11.9998 9.25C12.6898 9.25 13.2498 9.81 13.2498 10.5C13.2498 11.19 12.6898 11.75 11.9998 11.75ZM16.9998 11.75C16.3098 11.75 15.7498 11.19 15.7498 10.5C15.7498 9.81 16.3098 9.25 16.9998 9.25C17.6898 9.25 18.2498 9.81 18.2498 10.5C18.2498 11.19 17.6898 11.75 16.9998 11.75Z"
        fill="currentColor"
      />
    </g>
    <defs>
      <clipPath id="clip0_132_1422">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
`;
export const ArrowLeftIcon = ({ html = runeHtml, klass = '' }: IconProps = {}) => html`
  <svg
    class="${klass}"
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    height="100%"
    viewBox="0 0 24 24"
    fill="none"
  >
    <g clip-path="url(#clip0_132_1376)">
      <path
        d="M11.88 20.88C11.66 20.88 11.43 20.79 11.26 20.62L3.26 12.62C3.18 12.54 3.11 12.44 3.07 12.33C3.03 12.23 3.01 12.13 3 12.02V11.99C3 11.88 3.03 11.77 3.07 11.68C3.11 11.57 3.18 11.48 3.26 11.39L11.26 3.38C11.6 3.04 12.16 3.04 12.5 3.38C12.84 3.72 12.84 4.28 12.5 4.62L5.99 11.13H20.13C20.61 11.13 21.01 11.52 21.01 12.01C21.01 12.5 20.62 12.89 20.13 12.89H5.99L12.5 19.4C12.84 19.74 12.84 20.3 12.5 20.64C12.33 20.81 12.1 20.9 11.88 20.9V20.88Z"
        fill="currentColor"
      />
    </g>
    <defs>
      <clipPath id="clip0_132_1376">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
`;
export const ArrowRightIcon = ({ html = runeHtml, klass = '' }: IconProps = {}) => html`
  <svg
    class="${klass}"
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    height="100%"
    viewBox="0 0 24 24"
    fill="none"
  >
    <g clip-path="url(#clip0_132_1051)">
      <path
        d="M12.12 20.88C11.9 20.88 11.67 20.79 11.5 20.62C11.16 20.28 11.16 19.72 11.5 19.38L18.01 12.87H3.88C3.4 12.87 3 12.48 3 11.99C3 11.5 3.39 11.11 3.88 11.11H18.02L11.51 4.6C11.17 4.26 11.17 3.7 11.51 3.36C11.85 3.02 12.41 3.02 12.75 3.36L20.75 11.36C20.83 11.44 20.9 11.54 20.94 11.65C20.98 11.75 21 11.85 21.01 11.96V11.99C21.01 12.1 20.98 12.21 20.94 12.3C20.9 12.41 20.83 12.5 20.75 12.59L12.75 20.59C12.58 20.76 12.35 20.85 12.13 20.85L12.12 20.88Z"
        fill="currentColor"
      />
    </g>
    <defs>
      <clipPath id="clip0_132_1051">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
`;
export const ArrowUpicon = ({ html = runeHtml, klass = '' }: IconProps = {}) => html`
  <svg
    class="${klass}"
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    height="100%"
    viewBox="0 0 24 24"
    fill="none"
  >
    <g clip-path="url(#clip0_132_1379)">
      <path
        d="M12.0002 21C11.5202 21 11.1202 20.61 11.1202 20.12V5.99L4.61023 12.5C4.27023 12.84 3.71023 12.84 3.37023 12.5C3.03023 12.16 3.03023 11.6 3.37023 11.26L11.3802 3.26C11.4602 3.18 11.5602 3.11 11.6702 3.07C11.7702 3.03 11.8702 3.01 11.9802 3.01H12.0202C12.1302 3.01 12.2302 3.03 12.3302 3.07C12.4302 3.11 12.5302 3.18 12.6202 3.26L20.6202 11.26C20.9602 11.6 20.9602 12.16 20.6202 12.5C20.2802 12.84 19.7202 12.84 19.3802 12.5L12.8702 5.99V20.13C12.8702 20.61 12.4802 21.01 11.9902 21.01L12.0002 21Z"
        fill="currentColor"
      />
    </g>
    <defs>
      <clipPath id="clip0_132_1379">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
`;
export const ArrowDownIcon = ({ html = runeHtml, klass = '' }: IconProps = {}) => html`
  <svg
    class="${klass}"
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    height="100%"
    viewBox="0 0 24 24"
    fill="none"
  >
    <g clip-path="url(#clip0_132_1382)">
      <path
        d="M12 21H11.98C11.87 21 11.77 20.98 11.67 20.94C11.57 20.9 11.47 20.83 11.38 20.75L3.38 12.74C3.04 12.4 3.04 11.84 3.38 11.5C3.72 11.16 4.28 11.16 4.62 11.5L11.13 18.01V3.88C11.13 3.4 11.52 3 12.01 3C12.5 3 12.89 3.39 12.89 3.88V18.02L19.4 11.51C19.74 11.17 20.3 11.17 20.64 11.51C20.98 11.85 20.98 12.41 20.64 12.75L12.64 20.75C12.56 20.83 12.46 20.9 12.35 20.94C12.25 20.98 12.15 21 12.04 21H12.02H12Z"
        fill="currentColor"
      />
    </g>
    <defs>
      <clipPath id="clip0_132_1382">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
`;
export const ChevronLeftIcon = ({ html = runeHtml, klass = '' }: IconProps = {}) => html`
  <svg
    class="${klass}"
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    height="100%"
    viewBox="0 0 24 24"
    fill="none"
  >
    <g clip-path="url(#clip0_3862_20527)">
      <path
        d="M16.8776 4.0025C16.8776 4.2225 16.7976 4.4525 16.6176 4.6225L9.23756 12.0025L16.6176 19.3825C16.9576 19.7225 16.9576 20.2825 16.6176 20.6225C16.2776 20.9625 15.7176 20.9625 15.3776 20.6225L7.37756 12.6225C7.03756 12.2825 7.03756 11.7225 7.37756 11.3825L15.3776 3.3825C15.7176 3.0425 16.2776 3.0425 16.6176 3.3825C16.7876 3.5525 16.8776 3.7825 16.8776 4.0025Z"
        fill="currentColor"
      />
    </g>
    <defs>
      <clipPath id="clip0_3862_20527">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
`;
export const ChevronRightIcon = ({ html = runeHtml, klass = '' }: IconProps = {}) => html`
  <svg
    class="${klass}"
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    height="100%"
    viewBox="0 0 24 24"
    fill="none"
  >
    <g clip-path="url(#clip0_3862_20530)">
      <path
        d="M7.12256 20.0025C7.12256 19.7825 7.20256 19.5525 7.38256 19.3825L14.7626 12.0025L7.38256 4.6225C7.04256 4.2825 7.04256 3.7225 7.38256 3.3825C7.72256 3.0425 8.28256 3.0425 8.62256 3.3825L16.6226 11.3825C16.9626 11.7225 16.9626 12.2825 16.6226 12.6225L8.62256 20.6225C8.28256 20.9625 7.72256 20.9625 7.38256 20.6225C7.21256 20.4525 7.12256 20.2225 7.12256 20.0025Z"
        fill="currentColor"
      />
    </g>
    <defs>
      <clipPath id="clip0_3862_20530">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
`;
export const ChevronUpIcon = ({ html = runeHtml, klass = '' }: IconProps = {}) => html`
  <svg
    class="${klass}"
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    height="100%"
    viewBox="0 0 24 24"
    fill="none"
  >
    <g clip-path="url(#clip0_3246_326621)">
      <path
        d="M20 16.88C19.78 16.88 19.55 16.8 19.38 16.62L12 9.24L4.62 16.62C4.28 16.96 3.72 16.96 3.38 16.62C3.04 16.28 3.04 15.72 3.38 15.38L11.38 7.38C11.72 7.04 12.28 7.04 12.62 7.38L20.62 15.38C20.96 15.72 20.96 16.28 20.62 16.62C20.45 16.79 20.22 16.88 20 16.88Z"
        fill="currentColor"
      />
    </g>
    <defs>
      <clipPath id="clip0_3246_326621">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
`;
export const ChevronDownIcon = ({ html = runeHtml, klass = '' }: IconProps = {}) => html`
  <svg
    class="${klass}"
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    height="100%"
    viewBox="0 0 24 24"
    fill="none"
  >
    <g clip-path="url(#clip0_3499_351485)">
      <path
        d="M4 7.12489C4.22 7.12489 4.45 7.20488 4.62 7.38488L12 14.7649L19.38 7.38488C19.72 7.04488 20.28 7.04488 20.62 7.38488C20.96 7.72488 20.96 8.28488 20.62 8.62488L12.62 16.6249C12.28 16.9649 11.72 16.9649 11.38 16.6249L3.38 8.62488C3.04 8.28488 3.04 7.72488 3.38 7.38488C3.55 7.21488 3.78 7.12489 4 7.12489Z"
        fill="currentColor"
      />
    </g>
    <defs>
      <clipPath id="clip0_3499_351485">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
`;
export const EditorialIcon = ({ html = runeHtml, klass = '' }: IconProps = {}) => html`
  <svg
    class="${klass}"
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    height="100%"
    viewBox="0 0 24 24"
    fill="none"
  >
    <g clip-path="url(#clip0_132_32)">
      <path
        d="M5.76 4.03C5.2 3.98 4.71 4.44 4.71 5.03V15.92C4.71 16.44 5.09 16.87 5.58 16.91C9.64 17.26 11.13 19.98 11.13 19.98V7.34C11.13 7.14 11.07 6.96 10.97 6.79C10.52 6.09 9.09 4.33 5.76 4.02V4.03Z"
        fill="currentColor"
      />
      <path
        d="M4.94 17.87H4.21C3.93 17.87 3.71 17.65 3.71 17.37V7.08H3C2.45 7.08 2 7.53 2 8.08V18.98C2 19.53 2.45 19.98 3 19.98H9.87C9.19 19.23 8.07 17.88 4.94 17.88V17.87Z"
        fill="currentColor"
      />
      <path
        d="M18.24 4.03C18.8 3.98 19.29 4.44 19.29 5.03V15.92C19.29 16.44 18.91 16.87 18.42 16.91C14.36 17.26 12.87 19.98 12.87 19.98V7.34C12.87 7.14 12.93 6.96 13.03 6.79C13.48 6.09 14.91 4.33 18.24 4.02V4.03Z"
        fill="currentColor"
      />
      <path
        d="M19.06 17.87H19.79C20.07 17.87 20.29 17.65 20.29 17.37V7.08H21C21.55 7.08 22 7.53 22 8.08V18.98C22 19.53 21.55 19.98 21 19.98H14.13C14.81 19.23 15.93 17.88 19.06 17.88V17.87Z"
        fill="currentColor"
      />
    </g>
    <defs>
      <clipPath id="clip0_132_32">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
`;
export const SaleIcon = ({ html = runeHtml, klass = '' }: IconProps = {}) => html`
  <svg
    class="${klass}"
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    height="100%"
    viewBox="0 0 24 24"
    fill="none"
  >
    <g clip-path="url(#clip0_132_35)">
      <path
        d="M21.71 11.71L12.29 2.29C12.1 2.1 11.85 2 11.58 2H3C2.45 2 2 2.45 2 3V11.59C2 11.86 2.11 12.11 2.29 12.3L11.7 21.71C12.09 22.1 12.72 22.1 13.11 21.71L21.7 13.12C22.09 12.73 22.09 12.1 21.7 11.71H21.71ZM6.25 7.5C5.56 7.5 5 6.94 5 6.25C5 5.56 5.56 5 6.25 5C6.94 5 7.5 5.56 7.5 6.25C7.5 6.94 6.94 7.5 6.25 7.5Z"
        fill="currentColor"
      />
    </g>
    <defs>
      <clipPath id="clip0_132_35">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
`;
export const PopupStoreIcon = ({ html = runeHtml, klass = '' }: IconProps = {}) => html`
  <svg
    class="${klass}"
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    height="100%"
    viewBox="0 0 24 24"
    fill="none"
  >
    <g clip-path="url(#clip0_132_36)">
      <path
        d="M18.8099 7.86C18.7399 7.36 18.3199 7 17.8199 7H15.3699V5.38C15.3699 3.52 13.8499 2 11.9899 2C10.1299 2 8.60991 3.52 8.60991 5.38V7H6.15991C5.65991 7 5.23991 7.37 5.16991 7.86L3.38991 20.86C3.30991 21.46 3.76991 22 4.37991 22H19.5899C20.1999 22 20.6599 21.46 20.5799 20.86L18.7999 7.86H18.8099ZM10.3799 5.38C10.3799 4.48 11.1099 3.76 11.9999 3.76C12.8899 3.76 13.6199 4.49 13.6199 5.38V7H10.3699V5.38H10.3799Z"
        fill="currentColor"
      />
    </g>
    <defs>
      <clipPath id="clip0_132_36">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
`;
export const LaunchIcon = ({ html = runeHtml, klass = '' }: IconProps = {}) => html`
  <svg
    class="${klass}"
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    height="100%"
    viewBox="0 0 14 15"
    fill="none"
  >
    <g clip-path="url(#clip0_10555_6487)">
      <path
        d="M7.92136 13.3333H6.08386C5.80386 13.3333 5.57053 13.1058 5.57053 12.82C5.57053 12.5342 5.79803 12.3067 6.08386 12.3067H7.92136C8.20136 12.3067 8.43469 12.5342 8.43469 12.82C8.43469 13.1058 8.20719 13.3333 7.92136 13.3333Z"
        fill="currentColor"
      />
      <path
        d="M11.6197 7.79166L10.2372 6.86416C10.2372 6.77666 10.2372 6.72416 10.2372 6.72416C10.1905 6.08833 10.0447 5.45833 9.80553 4.86333C9.15219 3.22416 7.97969 2.19749 7.50719 1.82999C7.36719 1.71916 7.19219 1.66083 7.01136 1.66083C6.83053 1.66083 6.65553 1.71916 6.51553 1.82999C6.04303 2.19749 4.87053 3.22416 4.21719 4.86333C3.97803 5.45833 3.83219 6.08249 3.77969 6.72416C3.77969 6.72416 3.77969 6.77666 3.77969 6.86416L2.39719 7.79166C2.13469 7.95499 2.01219 8.21749 2.07636 8.47416L2.57219 11.9158C2.65969 12.2717 3.06219 12.505 3.49386 12.505C3.63969 12.505 3.79136 12.4758 3.93136 12.4233L5.72802 11.3967C5.72802 11.3967 5.75136 11.4025 5.75719 11.4025H8.27719C8.27719 11.4025 8.30053 11.3967 8.30636 11.3967L10.103 12.4233C10.243 12.4817 10.3947 12.505 10.5405 12.505C10.9722 12.505 11.3747 12.2717 11.4622 11.9158L11.958 8.47416C12.0164 8.21749 11.8939 7.96083 11.6372 7.79166H11.6197ZM3.52303 11.4608L3.10303 8.53833L3.87302 8.01916C4.00136 8.7425 4.29302 9.6875 4.92302 10.6617L3.52303 11.4608ZM6.41636 6.32749C6.41636 6.00666 6.67886 5.74416 6.99969 5.74416C7.32053 5.74416 7.58303 6.00666 7.58303 6.32749C7.58303 6.64833 7.32053 6.91083 6.99969 6.91083C6.67886 6.91083 6.41636 6.64833 6.41636 6.32749ZM10.4764 11.4608L9.07636 10.6617C9.70053 9.69333 9.99219 8.7425 10.1264 8.01916L10.8964 8.53833L10.4764 11.4608Z"
        fill="currentColor"
      />
    </g>
    <defs>
      <clipPath id="clip0_10555_6487">
        <rect width="14" height="14" fill="white" transform="translate(0 0.5)" />
      </clipPath>
    </defs>
  </svg>
`;
export const ShareIcon = ({ html = runeHtml, klass = '' }: IconProps = {}) => html`
  <svg
    class="${klass}"
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    height="100%"
    viewBox="0 0 24 24"
    fill="none"
  >
    <g clip-path="url(#clip0_132_960)">
      <path
        d="M19 16C18.14 16 17.38 16.36 16.83 16.94L7.95 12.5C7.98 12.34 8 12.17 8 12C8 11.83 7.98 11.67 7.95 11.5L16.83 7.06C17.38 7.63 18.14 8 19 8C20.66 8 22 6.66 22 5C22 3.34 20.66 2 19 2C17.34 2 16 3.34 16 5C16 5.17 16.02 5.33 16.05 5.5L7.17 9.94C6.62 9.37 5.86 9 5 9C3.34 9 2 10.34 2 12C2 13.66 3.34 15 5 15C5.86 15 6.62 14.64 7.17 14.06L16.05 18.5C16.02 18.66 16 18.83 16 19C16 20.66 17.34 22 19 22C20.66 22 22 20.66 22 19C22 17.34 20.66 16 19 16Z"
        fill="currentColor"
      />
    </g>
    <defs>
      <clipPath id="clip0_132_960">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
`;
export const StarIcon = ({ html = runeHtml, klass = '' }: IconProps = {}) => html`
  <svg
    class="${klass}"
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    height="100%"
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      d="M11.1302 2.98C11.4902 2.26 12.5202 2.26 12.8802 2.98L15.2202 7.71C15.3602 8 15.6402 8.2 15.9502 8.24L21.1702 9C21.9702 9.12 22.2902 10.1 21.7102 10.66L17.9302 14.34C17.7002 14.56 17.6002 14.89 17.6502 15.2L18.5402 20.4C18.6802 21.2 17.8402 21.8 17.1302 21.43L12.4602 18.97C12.1802 18.82 11.8402 18.82 11.5502 18.97L6.88017 21.43C6.17017 21.81 5.33017 21.2 5.47017 20.4L6.36017 15.2C6.41017 14.88 6.31017 14.56 6.08017 14.34L2.30017 10.66C1.72017 10.1 2.04017 9.11 2.84017 9L8.06017 8.24C8.38017 8.19 8.65017 7.99 8.79017 7.71L11.1302 2.98Z"
      fill="currentColor"
    />
  </svg>
`;
export const MenuIcon = ({ html = runeHtml, klass = '' }: IconProps = {}) => html`
  <svg
    class="${klass}"
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    height="100%"
    viewBox="0 0 24 24"
    fill="none"
  >
    <g clip-path="url(#clip0_132_1033)">
      <path
        d="M2.88956 5.88C2.3998 5.88 2 5.49 2 5C2 4.51 2.3998 4.12 2.88956 4.12H21.1104C21.6002 4.12 22 4.51 22 5C22 5.49 21.6002 5.88 21.1104 5.88H2.88956Z"
        fill="currentColor"
      />
      <path
        d="M2.88956 12.88C2.3998 12.88 2 12.49 2 12C2 11.51 2.3998 11.12 2.88956 11.12H21.1104C21.6002 11.12 22 11.51 22 12C22 12.49 21.6002 12.88 21.1104 12.88H2.88956Z"
        fill="currentColor"
      />
      <path
        d="M2.88956 19.88C2.3998 19.88 2 19.49 2 19C2 18.51 2.3998 18.12 2.88956 18.12H21.1104C21.6002 18.12 22 18.51 22 19C22 19.49 21.6002 19.88 21.1104 19.88H2.88956Z"
        fill="currentColor"
      />
    </g>
    <defs>
      <clipPath id="clip0_132_1033">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
`;
export const MinusIcon = ({ html = runeHtml, klass = '' }: IconProps = {}) => html`
  <svg
    class="${klass}"
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    height="100%"
    viewBox="0 0 24 24"
    fill="none"
  >
    <g clip-path="url(#clip0_140_59)">
      <path
        d="M21.0001 12.88H3.00012C2.52012 12.88 2.12012 12.49 2.12012 12C2.12012 11.51 2.51012 11.12 3.00012 11.12H21.0001C21.4801 11.12 21.8801 11.51 21.8801 12C21.8801 12.49 21.4901 12.88 21.0001 12.88Z"
        fill="currentColor"
      />
    </g>
    <defs>
      <clipPath id="clip0_140_59">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
`;
export const ShopIcon = ({ html = runeHtml, klass = '' }: IconProps = {}) => html`
  <svg
    class="${klass}"
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    height="100%"
    viewBox="0 0 24 24"
    fill="none"
  >
    <g clip-path="url(#clip0_741_95008)">
      <path
        d="M19.5 12C18.68 12 17.92 11.75 17.29 11.33C17.11 11.21 16.89 11.21 16.71 11.33C16.08 11.75 15.32 12 14.5 12C13.68 12 12.92 11.75 12.29 11.33C12.11 11.21 11.89 11.21 11.71 11.33C11.08 11.75 10.32 12 9.5 12C8.68 12 7.92 11.75 7.29 11.33C7.11 11.21 6.89 11.21 6.71 11.33C6.08 11.75 5.32 12 4.5 12C3.99 12 3.51 11.92 3.07 11.77V21C3.07 21.55 3.52 22 4.07 22H8.5C9.05 22 9.5 21.55 9.5 21V17.64C9.5 16.33 10.44 15.14 11.74 15.01C13.24 14.86 14.5 16.03 14.5 17.5V21C14.5 21.55 14.95 22 15.5 22H19.93C20.48 22 20.93 21.55 20.93 21V11.77C20.49 11.92 20.01 12 19.5 12Z"
        fill="currentColor"
      />
      <path
        d="M20.02 2.62C19.86 2.24 19.5 2 19.1 2H4.9C4.49 2 4.13 2.25 3.98 2.62C3.12 4.71 2 6.96 2 8C2 9.71 3.13 10.5 4.5 10.5C5.37 10.5 6.13 10.05 6.58 9.38C6.79 9.07 7.21 9.07 7.42 9.38C7.87 10.05 8.64 10.5 9.5 10.5C10.36 10.5 11.13 10.05 11.58 9.38C11.68 9.23 11.84 9.15 12 9.15C12.16 9.15 12.32 9.23 12.42 9.38C12.87 10.05 13.64 10.5 14.5 10.5C15.36 10.5 16.13 10.05 16.58 9.38C16.79 9.07 17.21 9.07 17.42 9.38C17.87 10.05 18.64 10.5 19.5 10.5C20.87 10.5 22 9.71 22 8C22 6.95 20.88 4.71 20.02 2.62Z"
        fill="currentColor"
      />
    </g>
    <defs>
      <clipPath id="clip0_741_95008">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
`;
export const InfoIcon = ({ html = runeHtml, klass = '' }: IconProps = {}) => html`
  <svg
    class="${klass}"
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    height="100%"
    viewBox="0 0 24 24"
    fill="none"
  >
    <g clip-path="url(#clip0_747_45584)">
      <path
        d="M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM13.25 16.88C13.25 17.57 12.69 18.13 12 18.13C11.31 18.13 10.75 17.57 10.75 16.88V11.63C10.75 10.94 11.31 10.38 12 10.38C12.69 10.38 13.25 10.94 13.25 11.63V16.88ZM12 8.38C11.31 8.38 10.75 7.82 10.75 7.13C10.75 6.44 11.31 5.88 12 5.88C12.69 5.88 13.25 6.44 13.25 7.13C13.25 7.82 12.69 8.38 12 8.38Z"
        fill="currentColor"
      />
    </g>
    <defs>
      <clipPath id="clip0_747_45584">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
`;
export const makeInfoIcon = ({ html = runeHtml, klass = '' }: IconProps = {}) => html`
  <svg
    class="${klass}"
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    height="100%"
    viewBox="0 0 24 24"
    fill="none"
  >
    <g clip-path="url(#clip0_747_45584)">
      <path
        d="M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM13.25 16.88C13.25 17.57 12.69 18.13 12 18.13C11.31 18.13 10.75 17.57 10.75 16.88V11.63C10.75 10.94 11.31 10.38 12 10.38C12.69 10.38 13.25 10.94 13.25 11.63V16.88ZM12 8.38C11.31 8.38 10.75 7.82 10.75 7.13C10.75 6.44 11.31 5.88 12 5.88C12.69 5.88 13.25 6.44 13.25 7.13C13.25 7.82 12.69 8.38 12 8.38Z"
        fill="currentColor"
      />
    </g>
    <defs>
      <clipPath id="clip0_747_45584">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
`;
export const FilterIcon = ({ html = runeHtml, klass = '' }: IconProps = {}) => html`
  <svg
    class="${klass}"
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    height="100%"
    viewBox="0 0 24 24"
    fill="none"
  >
    <g clip-path="url(#clip0_855_71658)">
      <path
        d="M2.87998 5.88H13.97C14.35 7.11 15.47 8 16.83 8C18.19 8 19.31 7.1 19.69 5.88H21.14C21.62 5.88 22.02 5.49 22.02 5C22.02 4.51 21.63 4.12 21.14 4.12H19.69C19.31 2.89 18.19 2 16.83 2C15.47 2 14.35 2.9 13.97 4.12H2.87998C2.39998 4.12 1.99998 4.51 1.99998 5C1.99998 5.49 2.38998 5.88 2.87998 5.88Z"
        fill="currentColor"
      />
      <path
        d="M21.12 11.12H9.92998C9.54998 9.89 8.42998 9 7.06998 9C5.70998 9 4.58998 9.9 4.20998 11.12H2.85998C2.37998 11.12 1.97998 11.51 1.97998 12C1.97998 12.49 2.36998 12.88 2.85998 12.88H4.20998C4.58998 14.11 5.70998 15 7.06998 15C8.42998 15 9.54998 14.1 9.92998 12.88H21.12C21.6 12.88 22 12.49 22 12C22 11.51 21.61 11.12 21.12 11.12Z"
        fill="currentColor"
      />
      <path
        d="M16.67 18.12C16.29 16.89 15.17 16 13.81 16C12.45 16 11.33 16.9 10.95 18.12H2.87998C2.39998 18.12 1.99998 18.51 1.99998 19C1.99998 19.49 2.38998 19.88 2.87998 19.88H10.97C11.35 21.11 12.47 22 13.83 22C15.19 22 16.31 21.1 16.69 19.88H21.14C21.62 19.88 22.02 19.49 22.02 19C22.02 18.51 21.63 18.12 21.14 18.12H16.67Z"
        fill="currentColor"
      />
    </g>
    <defs>
      <clipPath id="clip0_855_71658">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
`;
export const SortIcon = ({ html = runeHtml, klass = '' }: IconProps = {}) => html`
  <svg
    class="${klass}"
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    height="100%"
    viewBox="0 0 24 24"
    fill="none"
  >
    <g clip-path="url(#clip0_3231_320149)">
      <path
        d="M20.9998 2H2.99981C2.20981 2 1.73981 2.86 2.14981 3.53L9.29981 13.29C9.42981 13.46 9.48981 13.67 9.48981 13.88V22L14.4898 19.37V13.88C14.4898 13.67 14.5598 13.46 14.6798 13.29L21.8298 3.53C22.2498 2.86 21.7698 2 20.9798 2H20.9998Z"
        fill="currentColor"
      />
    </g>
    <defs>
      <clipPath id="clip0_3231_320149">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
`;
export const PhotoIcon = ({ html = runeHtml, klass = '' }: IconProps = {}) => html`
  <svg
    class="${klass}"
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    height="100%"
    viewBox="0 0 24 24"
    fill="none"
  >
    <g clip-path="url(#clip0_4726_211242)">
      <path
        d="M16 10C17.1046 10 18 9.10457 18 8C18 6.89543 17.1046 6 16 6C14.8954 6 14 6.89543 14 8C14 9.10457 14.8954 10 16 10Z"
        fill="currentColor"
      />
      <path
        d="M20 2H4C2.9 2 2 2.9 2 4V20C2 21.1 2.9 22 4 22H20C20.41 22 20.8 21.87 21.12 21.66C21.33 21.52 21.52 21.33 21.66 21.12C21.88 20.8 22 20.42 22 20V4C22 2.9 21.1 2 20 2ZM18.61 12.47C17.85 11.73 16.65 11.7 15.86 12.41L14.52 13.62C14.12 13.99 13.49 13.96 13.12 13.56L9.33 9.52C8.55 8.69 7.23 8.68 6.44 9.49L3.75 12.26V4C3.75 3.86 3.86 3.75 4 3.75H20C20.14 3.75 20.25 3.86 20.25 4V14.08L18.61 12.47Z"
        fill="currentColor"
      />
    </g>
    <defs>
      <clipPath id="clip0_4726_211242">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
`;
export const KebabIcon = ({ html = runeHtml, klass = '' }: IconProps = {}) => html`
  <svg
    class="${klass}"
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    height="100%"
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      d="M12 5.88C12.8284 5.88 13.5 5.20843 13.5 4.38C13.5 3.55157 12.8284 2.88 12 2.88C11.1716 2.88 10.5 3.55157 10.5 4.38C10.5 5.20843 11.1716 5.88 12 5.88Z"
      fill="currentColor"
    />
    <path
      d="M12 13.5C12.8284 13.5 13.5 12.8284 13.5 12C13.5 11.1716 12.8284 10.5 12 10.5C11.1716 10.5 10.5 11.1716 10.5 12C10.5 12.8284 11.1716 13.5 12 13.5Z"
      fill="currentColor"
    />
    <path
      d="M12 21.12C12.8284 21.12 13.5 20.4484 13.5 19.62C13.5 18.7916 12.8284 18.12 12 18.12C11.1716 18.12 10.5 18.7916 10.5 19.62C10.5 20.4484 11.1716 21.12 12 21.12Z"
      fill="currentColor"
    />
  </svg>
`;
export const MeatballsIcon = ({ html = runeHtml, klass = '' }: IconProps = {}) => html`
  <svg
    class="${klass}"
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    height="100%"
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      d="M19.6199 13.5C20.4483 13.5 21.1199 12.8284 21.1199 12C21.1199 11.1716 20.4483 10.5 19.6199 10.5C18.7915 10.5 18.1199 11.1716 18.1199 12C18.1199 12.8284 18.7915 13.5 19.6199 13.5Z"
      fill="currentColor"
    />
    <path
      d="M11.9999 13.5C12.8283 13.5 13.4999 12.8284 13.4999 12C13.4999 11.1716 12.8283 10.5 11.9999 10.5C11.1715 10.5 10.4999 11.1716 10.4999 12C10.4999 12.8284 11.1715 13.5 11.9999 13.5Z"
      fill="currentColor"
    />
    <path
      d="M4.37988 13.5C5.20831 13.5 5.87988 12.8284 5.87988 12C5.87988 11.1716 5.20831 10.5 4.37988 10.5C3.55146 10.5 2.87988 11.1716 2.87988 12C2.87988 12.8284 3.55146 13.5 4.37988 13.5Z"
      fill="currentColor"
    />
  </svg>
`;
export const OutlinkIcon = ({ html = runeHtml, klass = '' }: IconProps = {}) => html`
  <svg
    class="${klass}"
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    height="100%"
    viewBox="0 0 24 24"
    fill="none"
  >
    <g clip-path="url(#clip0_2950_392407)">
      <path
        d="M16.88 13.25C16.4 13.25 16 13.64 16 14.13V20.13C16 20.2 15.94 20.25 15.88 20.25H3.88C3.81 20.25 3.76 20.19 3.76 20.13V8.13C3.76 8.06 3.82 8.01 3.88 8.01H9.88C10.36 8.01 10.76 7.62 10.76 7.13C10.76 6.64 10.37 6.25 9.88 6.25H3.88C2.85 6.25 2 7.09 2 8.13V20.13C2 21.16 2.84 22.01 3.88 22.01H15.88C16.91 22.01 17.76 21.17 17.76 20.13V14.13C17.76 13.65 17.37 13.25 16.88 13.25Z"
        fill="currentColor"
      />
      <path
        d="M21.99 2.84C21.99 2.74 21.97 2.63 21.93 2.54C21.89 2.45 21.84 2.38 21.77 2.31C21.76 2.29 21.75 2.27 21.74 2.26C21.72 2.24 21.7 2.24 21.68 2.22C21.61 2.16 21.54 2.11 21.46 2.07C21.35 2.03 21.24 2 21.12 2H15.12C14.64 2 14.24 2.39 14.24 2.88C14.24 3.37 14.63 3.76 15.12 3.76H19.01L11.38 11.39C11.04 11.73 11.04 12.29 11.38 12.63C11.55 12.8 11.78 12.89 12 12.89C12.22 12.89 12.45 12.81 12.62 12.63L20.25 5V8.89C20.25 9.37 20.64 9.77 21.13 9.77C21.62 9.77 22.01 9.38 22.01 8.89V2.88C22.01 2.88 22.01 2.86 22.01 2.85L21.99 2.84Z"
        fill="currentColor"
      />
    </g>
    <defs>
      <clipPath id="clip0_2950_392407">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
`;
export const EditorAddIcon = ({ html = runeHtml, klass = '' }: IconProps = {}) => html`
  <svg
    class="${klass}"
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    height="100%"
    viewBox="0 0 20 20"
    fill="none"
  >
    <g clip-path="url(#clip0_802_122317)">
      <path
        d="M17.2807 9.28871H10.6873V2.7033C10.6873 2.31968 10.3756 2 9.98402 2C9.59241 2 9.28072 2.31169 9.28072 2.7033V9.2967H2.7033C2.31968 9.2967 2 9.60839 2 10C2 10.3916 2.31169 10.7033 2.7033 10.7033H9.2967V17.2967C9.2967 17.6803 9.60839 18 10 18C10.3916 18 10.7033 17.6883 10.7033 17.2967V10.7033H17.2967C17.6803 10.7033 18 10.3916 18 10C18 9.60839 17.6883 9.2967 17.2967 9.2967L17.2807 9.28871Z"
        fill="currentColor"
      />
    </g>
    <defs>
      <clipPath id="clip0_802_122317">
        <rect width="20" height="20" fill="white" />
      </clipPath>
    </defs>
  </svg>
`;
export const EditorExitIcon = ({ html = runeHtml, klass = '' }: IconProps = {}) => html`
  <svg
    class="${klass}"
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    height="100%"
    viewBox="0 0 20 20"
    fill="none"
  >
    <g clip-path="url(#clip0_3657_203628)">
      <path
        d="M10.9087 10.0018L16.3107 4.59236C16.5631 4.33958 16.5631 3.93514 16.3107 3.68958C16.0583 3.43681 15.6544 3.43681 15.4019 3.68958L10 9.09181L4.59806 3.68958C4.34563 3.43681 3.94175 3.43681 3.68932 3.68958C3.43689 3.94236 3.43689 4.34681 3.68932 4.59236L9.09126 10.0018L3.68932 15.4113C3.43689 15.664 3.43689 16.0685 3.68932 16.314C3.81193 16.4368 3.97781 16.5018 4.14369 16.5018C4.30957 16.5018 4.46824 16.4368 4.59806 16.314L10 10.9118L15.4019 16.314C15.5246 16.4368 15.6904 16.5018 15.8563 16.5018C16.0222 16.5018 16.1809 16.4368 16.3107 16.314C16.5631 16.0613 16.5631 15.6568 16.3107 15.4113L10.9087 10.0018Z"
        fill="currentColor"
      />
    </g>
    <defs>
      <clipPath id="clip0_3657_203628">
        <rect width="20" height="20" fill="white" />
      </clipPath>
    </defs>
  </svg>
`;
export const EditorMinusIcon = ({ html = runeHtml, klass = '' }: IconProps = {}) => html`
  <svg
    class="${klass}"
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    height="100%"
    viewBox="0 0 20 20"
    fill="none"
  >
    <g clip-path="url(#clip0_802_155148)">
      <path
        d="M17.2875 10.7334H2.71255C2.32389 10.7334 2 10.4084 2 10.0001C2 9.59176 2.31579 9.26676 2.71255 9.26676H17.2875C17.6761 9.26676 18 9.59176 18 10.0001C18 10.4084 17.6842 10.7334 17.2875 10.7334Z"
        fill="currentColor"
      />
    </g>
    <defs>
      <clipPath id="clip0_802_155148">
        <rect width="20" height="20" fill="white" />
      </clipPath>
    </defs>
  </svg>
`;
export const EditorTextIcon = ({ html = runeHtml, klass = '' }: IconProps = {}) => html`
  <svg
    class="${klass}"
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    height="100%"
    viewBox="0 0 20 20"
    fill="none"
  >
    <path
      d="M16.6665 2.04166H3.33317C2.4165 2.04166 1.6665 2.79166 1.6665 3.70833V13.7083C1.6665 14.625 2.4165 15.375 3.33317 15.375H7.58317V17.125C7.58317 17.8 8.33317 18.1917 8.8915 17.8083L12.4248 15.375H16.6748C17.5915 15.375 18.3415 14.625 18.3415 13.7083V3.70833C18.3415 2.79166 17.5915 2.04166 16.6748 2.04166H16.6665ZM13.0915 6.225H10.7332V11.9167C10.7332 12.3167 10.4082 12.65 9.99984 12.65C9.5915 12.65 9.2665 12.325 9.2665 11.9167V6.225H6.90817C6.50817 6.225 6.17484 5.9 6.17484 5.49166C6.17484 5.08333 6.49984 4.75833 6.90817 4.75833H13.0915C13.4915 4.75833 13.8248 5.08333 13.8248 5.49166C13.8248 5.9 13.4998 6.225 13.0915 6.225Z"
      fill="currentColor"
    />
  </svg>
`;
export const EditorTableIcon = ({ html = runeHtml, klass = '' }: IconProps = {}) => html`
  <svg
    class="${klass}"
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    height="100%"
    viewBox="0 0 20 20"
    fill="none"
  >
    <path
      d="M15.8332 2.91666H4.1665C2.78317 2.91666 1.6665 4.03333 1.6665 5.41666V14.5833C1.6665 15.9667 2.78317 17.0833 4.1665 17.0833H15.8332C17.2165 17.0833 18.3332 15.9667 18.3332 14.5833V5.41666C18.3332 4.03333 17.2165 2.91666 15.8332 2.91666ZM16.8748 14.5833C16.8748 15.1583 16.4082 15.625 15.8332 15.625H16.3415H7.6415V10.725H16.8748V14.575V14.5833ZM16.8748 9.26666H7.6415V4.36666H16.3415H15.8332C16.4082 4.36666 16.8748 4.83333 16.8748 5.40833V9.25833V9.26666Z"
      fill="currentColor"
    />
  </svg>
`;
export const EditorURLIcon = ({ html = runeHtml, klass = '' }: IconProps = {}) => html`
  <svg
    class="${klass}"
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    height="100%"
    viewBox="0 0 20 20"
    fill="none"
  >
    <path
      d="M9.1417 12.45C8.20003 12.45 7.25837 12.0917 6.55003 11.3833C5.85837 10.6917 5.47503 9.775 5.47503 8.79167C5.47503 7.80833 5.85837 6.89167 6.55003 6.2L10.0084 2.74167C11.4334 1.31667 13.7584 1.31667 15.1917 2.74167C16.6167 4.175 16.6167 6.49167 15.1917 7.925L14.8917 8.225C14.6084 8.50833 14.1417 8.50833 13.8584 8.225C13.575 7.94167 13.575 7.475 13.8584 7.19167L14.1584 6.89167C15.0167 6.03333 15.0167 4.63333 14.1584 3.775C13.3 2.91667 11.9 2.91667 11.0417 3.775L7.58337 7.23333C7.1667 7.65 6.93337 8.2 6.93337 8.79167C6.93337 9.38333 7.1667 9.93333 7.58337 10.35C8.3917 11.1583 9.70003 11.2083 10.5667 10.475C10.875 10.2167 11.3334 10.25 11.5917 10.5583C11.85 10.8667 11.8167 11.325 11.5084 11.5833C10.8334 12.1583 9.98337 12.4417 9.15003 12.4417L9.1417 12.45Z"
      fill="currentColor"
    />
    <path
      d="M7.40837 18.3333C6.43337 18.3333 5.50837 17.95 4.8167 17.2583C4.12503 16.5667 3.7417 15.65 3.7417 14.6667C3.7417 13.6833 4.12503 12.7667 4.8167 12.075L5.1167 11.775C5.40003 11.4917 5.8667 11.4917 6.15003 11.775C6.43337 12.0583 6.43337 12.525 6.15003 12.8083L5.85003 13.1083C5.43337 13.525 5.20003 14.0833 5.20003 14.6667C5.20003 15.25 5.43337 15.8083 5.85003 16.225C6.68337 17.0583 8.13337 17.0583 8.9667 16.225L12.425 12.7667C13.2834 11.9083 13.2834 10.5083 12.425 9.65C11.6167 8.84167 10.3084 8.79167 9.4417 9.525C9.13337 9.78333 8.67503 9.75 8.4167 9.44167C8.15837 9.13333 8.1917 8.675 8.50003 8.41667C9.9417 7.19167 12.1167 7.28333 13.4584 8.625C14.8834 10.05 14.8834 12.375 13.4584 13.8083L10 17.2667C9.30837 17.9583 8.3917 18.3417 7.40837 18.3417V18.3333Z"
      fill="currentColor"
    />
  </svg>
`;
export const EditorImageIcon = ({ html = runeHtml, klass = '' }: IconProps = {}) => html`
  <svg
    class="${klass}"
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    height="100%"
    viewBox="0 0 20 20"
    fill="none"
  >
    <path
      d="M4.37484 12.9167V5.83333H3.33317C2.4165 5.83333 1.6665 6.58333 1.6665 7.5V16.6667C1.6665 17.5833 2.4165 18.3333 3.33317 18.3333H12.4998C13.4165 18.3333 14.1665 17.5833 14.1665 16.6667V15.625H7.08317C5.58317 15.625 4.37484 14.4083 4.37484 12.9167Z"
      fill="currentColor"
    />
    <path
      d="M5.83317 3.33333V12.5C5.83317 13.4167 6.58317 14.1667 7.49984 14.1667H16.6665C17.5832 14.1667 18.3332 13.4167 18.3332 12.5V3.33333C18.3332 2.41667 17.5832 1.66667 16.6665 1.66667H7.49984C6.58317 1.66667 5.83317 2.41667 5.83317 3.33333ZM12.0832 4.58333C12.8665 4.58333 13.4998 5.21667 13.4998 6C13.4998 6.78333 12.8665 7.41667 12.0832 7.41667C11.2998 7.41667 10.6665 6.78333 10.6665 6C10.6665 5.21667 11.2998 4.58333 12.0832 4.58333ZM15.0832 11.25H9.08317C8.88317 11.25 8.73317 11.0833 8.74984 10.8833C8.93317 9.21667 10.3582 7.91667 12.0832 7.91667C13.8082 7.91667 15.2332 9.21667 15.4165 10.8833C15.4415 11.075 15.2832 11.25 15.0832 11.25Z"
      fill="currentColor"
    />
  </svg>
`;
export const EditorVideoIcon = ({ html = runeHtml, klass = '' }: IconProps = {}) => html`
  <svg
    class="${klass}"
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    height="100%"
    viewBox="0 0 20 20"
    fill="none"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M3.33317 3.23333C2.4165 3.23333 1.6665 3.98333 1.6665 4.9V15.1083C1.6665 16.025 2.4165 16.775 3.33317 16.775H16.6665C17.5832 16.775 18.3332 16.025 18.3332 15.1083V4.9C18.3332 3.98333 17.5832 3.23333 16.6665 3.23333H3.33317ZM12.9165 10.725C13.4748 10.4083 13.4748 9.6 12.9165 9.28333L9.1665 7.11666C8.60817 6.8 7.9165 7.2 7.9165 7.84166V12.175C7.9165 12.8167 8.60817 13.2167 9.1665 12.9L12.9165 10.7333V10.725Z"
      fill="currentColor"
    />
  </svg>
`;
export const EditorTableAddIcon = ({ html = runeHtml, klass = '' }: IconProps = {}) => html`
  <svg
    class="${klass}"
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    height="100%"
    viewBox="0 0 20 20"
    fill="none"
  >
    <path
      d="M14.2665 9.26667H10.7248V5.725C10.7248 5.325 10.3998 4.99167 9.9915 4.99167C9.58317 4.99167 9.25817 5.31667 9.25817 5.725V9.26667H5.7165C5.3165 9.26667 4.98317 9.59167 4.98317 10C4.98317 10.4083 5.30817 10.7333 5.7165 10.7333H9.25817V14.275C9.25817 14.675 9.58317 15.0083 9.9915 15.0083C10.3998 15.0083 10.7248 14.6833 10.7248 14.275V10.7333H14.2665C14.6665 10.7333 14.9998 10.4083 14.9998 10C14.9998 9.59167 14.6748 9.26667 14.2665 9.26667Z"
      fill="currentColor"
    />
    <path
      d="M18.3332 6.66667V3.33333C18.3332 2.41667 17.5832 1.66667 16.6665 1.66667H3.33317C2.4165 1.66667 1.6665 2.41667 1.6665 3.33333V6.66667C1.6665 7.58333 2.4165 8.33333 3.33317 8.33333H4.33317C4.7165 8.01667 5.19984 7.81667 5.73317 7.81667H7.8165V5.73333C7.8165 4.525 8.79984 3.55 9.99984 3.55C11.1998 3.55 12.1832 4.53333 12.1832 5.73333V7.81667H14.2665C14.7998 7.81667 15.2832 8.01667 15.6665 8.33333H16.6665C17.5832 8.33333 18.3332 7.58333 18.3332 6.66667Z"
      fill="currentColor"
    />
    <path
      d="M12.1832 12.1833V13.1167H16.6665C16.7832 13.1167 16.8748 13.2083 16.8748 13.325V16.6583C16.8748 16.775 16.7832 16.8667 16.6665 16.8667H3.33317C3.2165 16.8667 3.12484 16.775 3.12484 16.6583V13.325C3.12484 13.2083 3.2165 13.1167 3.33317 13.1167H7.8165V12.1833H5.73317C5.19984 12.1833 4.7165 11.9833 4.33317 11.6667H3.33317C2.4165 11.6667 1.6665 12.4167 1.6665 13.3333V16.6667C1.6665 17.5833 2.4165 18.3333 3.33317 18.3333H16.6665C17.5832 18.3333 18.3332 17.5833 18.3332 16.6667V13.3333C18.3332 12.4167 17.5832 11.6667 16.6665 11.6667H15.6665C15.2832 11.9833 14.7998 12.1833 14.2665 12.1833H12.1832Z"
      fill="currentColor"
    />
  </svg>
`;
export const EditorRemoveIcon = ({ html = runeHtml, klass = '' }: IconProps = {}) => html`
  <svg
    class="${klass}"
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    height="100%"
    viewBox="0 0 20 20"
    fill="none"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M13.3333 2.91667L12.4666 1.95833C12.3083 1.775 12.025 1.66667 11.725 1.66667H8.2833C7.9833 1.66667 7.69997 1.775 7.54163 1.95833L6.67497 2.91667H3.34163C2.8833 2.91667 2.5083 3.29167 2.5083 3.75C2.5083 4.20833 2.8833 4.58333 3.34163 4.58333H16.675C17.1333 4.58333 17.5083 4.20833 17.5083 3.75C17.5083 3.29167 17.1333 2.91667 16.675 2.91667H13.3333Z"
      fill="currentColor"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M4.99997 17.4167C4.99997 17.925 5.4083 18.3333 5.9083 18.3333H14.0833C14.5833 18.3333 14.9916 17.925 14.9916 17.4167L15.9 6.18333H4.09163L4.99997 17.4167ZM11.1666 9.5C11.1666 9.1 11.4916 8.76667 11.9 8.76667C12.3083 8.76667 12.6333 9.09167 12.6333 9.5V15.5417C12.6333 15.9417 12.3083 16.275 11.9 16.275C11.4916 16.275 11.1666 15.95 11.1666 15.5417V9.5ZM7.37497 9.5C7.37497 9.1 7.69997 8.76667 8.1083 8.76667C8.51663 8.76667 8.84163 9.09167 8.84163 9.5V15.5417C8.84163 15.9417 8.51663 16.275 8.1083 16.275C7.69997 16.275 7.37497 15.95 7.37497 15.5417V9.5Z"
      fill="currentColor"
    />
  </svg>
`;
export const EditorBoldIcon = ({ html = runeHtml, klass = '' }: IconProps = {}) => html`
  <svg
    class="${klass}"
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    height="100%"
    viewBox="0 0 20 20"
    fill="none"
  >
    <path
      d="M12.7584 8.78333C13.3167 8.125 13.6667 7.28333 13.6667 6.35833C13.6667 4.28333 11.9834 2.6 9.9084 2.6H4.59173C4.19173 2.6 3.8584 2.925 3.8584 3.33333C3.8584 3.74167 4.1834 4.06667 4.59173 4.06667H5.20006V15.9417H4.59173C4.19173 15.9417 3.8584 16.2667 3.8584 16.675C3.8584 17.0833 4.1834 17.4083 4.59173 17.4083H11.7584C14.1667 17.4083 16.1251 15.45 16.1251 13.0417C16.1251 10.975 14.6834 9.25 12.7501 8.8L12.7584 8.78333ZM6.66673 4.06667H9.91673C11.1834 4.06667 12.2167 5.1 12.2167 6.36667C12.2167 7.63333 11.1834 8.66666 9.91673 8.66666H6.66673V4.06667ZM11.7667 15.9333H6.66673V10.1167H11.7667C13.3667 10.1167 14.6751 11.425 14.6751 13.025C14.6751 14.625 13.3667 15.9333 11.7667 15.9333Z"
      fill="currentColor"
    />
  </svg>
`;
export const EditorUnderlineIcon = ({ html = runeHtml, klass = '' }: IconProps = {}) => html`
  <svg
    class="${klass}"
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    height="100%"
    viewBox="0 0 20 20"
    fill="none"
  >
    <g clip-path="url(#clip0_3752_376298)">
      <path
        d="M16.6668 15.9418H3.33343C2.93343 15.9418 2.6001 16.2668 2.6001 16.6751C2.6001 17.0834 2.9251 17.4084 3.33343 17.4084H16.6668C17.0668 17.4084 17.4001 17.0834 17.4001 16.6751C17.4001 16.2668 17.0751 15.9418 16.6668 15.9418Z"
        fill="currentColor"
      />
      <path
        d="M3.86676 4.06676H4.69176V8.7501C4.69176 11.6834 7.0751 14.0668 10.0084 14.0668C12.9418 14.0668 15.3251 11.6834 15.3251 8.7501V4.06676H16.1501C16.5501 4.06676 16.8834 3.74176 16.8834 3.33343C16.8834 2.9251 16.5584 2.6001 16.1501 2.6001H13.8751C13.4751 2.6001 13.1418 2.9251 13.1418 3.33343C13.1418 3.74176 13.4668 4.05843 13.8584 4.05843V8.7501C13.8584 10.8751 12.1251 12.6001 10.0084 12.6001C7.89176 12.6001 6.15843 10.8751 6.15843 8.7501V4.05843C6.55843 4.05843 6.8751 3.73343 6.8751 3.33343C6.8751 2.93343 6.5501 2.6001 6.14176 2.6001H3.86676C3.46676 2.6001 3.13343 2.9251 3.13343 3.33343C3.13343 3.74176 3.45843 4.06676 3.86676 4.06676Z"
        fill="currentColor"
      />
    </g>
    <defs>
      <clipPath id="clip0_3752_376298">
        <rect width="20" height="20" fill="white" />
      </clipPath>
    </defs>
  </svg>
`;
export const EditorItalicIcon = ({ html = runeHtml, klass = '' }: IconProps = {}) => html`
  <svg
    class="${klass}"
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    height="100%"
    viewBox="0 0 20 20"
    fill="none"
  >
    <g clip-path="url(#clip0_3752_376301)">
      <path
        d="M14.5669 2.6001H11.7085C11.3085 2.6001 10.9752 2.9251 10.9752 3.33343C10.9752 3.74176 11.3002 4.06676 11.7085 4.06676H12.2752L6.09186 15.9501H5.43353C5.03353 15.9501 4.7002 16.2751 4.7002 16.6834C4.7002 17.0918 5.0252 17.4168 5.43353 17.4168H8.29186C8.69186 17.4168 9.0252 17.0918 9.0252 16.6834C9.0252 16.2751 8.7002 15.9501 8.29186 15.9501H7.73353L13.9169 4.06676H14.5669C14.9669 4.06676 15.3002 3.74176 15.3002 3.33343C15.3002 2.9251 14.9752 2.6001 14.5669 2.6001Z"
        fill="currentColor"
      />
    </g>
    <defs>
      <clipPath id="clip0_3752_376301">
        <rect width="20" height="20" fill="white" />
      </clipPath>
    </defs>
  </svg>
`;
export const EditorHeadIcon = ({ html = runeHtml, klass = '' }: IconProps = {}) => html`
  <svg
    class="${klass}"
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    height="100%"
    viewBox="0 0 20 20"
    fill="none"
  >
    <g clip-path="url(#clip0_3848_203194)">
      <path
        d="M14.4182 3.41818C14.0154 3.41818 13.6891 3.74452 13.6891 4.14735V9.27084H7.28353V4.14735C7.28353 3.74452 6.9572 3.41818 6.55436 3.41818C6.15153 3.41818 5.8252 3.74452 5.8252 4.14735V15.8527C5.8252 16.2555 6.15153 16.5818 6.55436 16.5818C6.9572 16.5818 7.28353 16.2555 7.28353 15.8527V10.7292H13.6891V15.8527C13.6891 16.2555 14.0154 16.5818 14.4182 16.5818C14.8211 16.5818 15.1474 16.2555 15.1474 15.8527V4.14735C15.1474 3.74452 14.8211 3.41818 14.4182 3.41818Z"
        fill="currentColor"
      />
    </g>
    <defs>
      <clipPath id="clip0_3848_203194">
        <rect width="20" height="20" fill="white" />
      </clipPath>
    </defs>
  </svg>
`;
export const EditorHead2Icon = ({ html = runeHtml, klass = '' }: IconProps = {}) => html`
  <svg
    class="${klass}"
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    height="100%"
    viewBox="0 0 20 20"
    fill="none"
  >
    <g clip-path="url(#clip0_3752_377883)">
      <path
        d="M10.708 5.0751C10.308 5.0751 9.97464 5.4001 9.97464 5.80843V10.5168H4.05798V5.80843C4.05798 5.40843 3.73298 5.0751 3.32464 5.0751C2.91631 5.0751 2.59131 5.4001 2.59131 5.80843V16.6834C2.59131 17.0834 2.91631 17.4168 3.32464 17.4168C3.73298 17.4168 4.05798 17.0918 4.05798 16.6834V11.9751H9.97464V16.6834C9.97464 17.0834 10.2996 17.4168 10.708 17.4168C11.1163 17.4168 11.4413 17.0918 11.4413 16.6834V5.8001C11.4413 5.4001 11.1163 5.06676 10.708 5.06676V5.0751Z"
        fill="currentColor"
      />
      <path
        d="M16.6663 7.93343H15.1913C15.5913 7.58343 15.983 7.2251 16.208 6.98343C16.8163 6.33343 17.3996 5.71676 17.3996 4.7501C17.3996 3.88343 16.783 2.6001 15.083 2.6001C13.683 2.6001 13.0163 3.66676 12.8663 4.23343C12.758 4.6251 12.9913 5.0251 13.3746 5.1251C13.7663 5.23343 14.1663 5.0001 14.2746 4.61676C14.2746 4.59176 14.433 4.05843 15.083 4.05843C15.858 4.05843 15.9413 4.54176 15.9413 4.7501C15.9413 5.1001 15.7246 5.36676 15.1496 5.98343C14.6746 6.49176 13.2496 7.6751 12.7413 8.09176C12.4996 8.28343 12.4163 8.60843 12.5163 8.9001C12.6163 9.19176 12.8913 9.38343 13.1996 9.38343H16.6663C17.0663 9.38343 17.3996 9.05843 17.3996 8.6501C17.3996 8.24176 17.0746 7.91676 16.6663 7.91676V7.93343Z"
        fill="currentColor"
      />
    </g>
    <defs>
      <clipPath id="clip0_3752_377883">
        <rect width="20" height="20" fill="white" />
      </clipPath>
    </defs>
  </svg>
`;
export const EditorHead3Icon = ({ html = runeHtml, klass = '' }: IconProps = {}) => html`
  <svg
    class="${klass}"
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    height="100%"
    viewBox="0 0 20 20"
    fill="none"
  >
    <g clip-path="url(#clip0_3752_377880)">
      <path
        d="M10.7085 5.0751C10.3085 5.0751 9.97513 5.4001 9.97513 5.80843V10.5168H4.05846V5.80843C4.05846 5.40843 3.73346 5.0751 3.32513 5.0751C2.9168 5.0751 2.5918 5.4001 2.5918 5.80843V16.6834C2.5918 17.0834 2.9168 17.4168 3.32513 17.4168C3.73346 17.4168 4.05846 17.0918 4.05846 16.6834V11.9751H9.97513V16.6834C9.97513 17.0834 10.3001 17.4168 10.7085 17.4168C11.1168 17.4168 11.4418 17.0918 11.4418 16.6834V5.8001C11.4418 5.4001 11.1168 5.06676 10.7085 5.06676V5.0751Z"
        fill="currentColor"
      />
      <path
        d="M16.6501 5.98343C17.0168 5.53343 17.1501 5.00843 17.1501 4.60843C17.1501 3.60843 16.4085 2.6001 14.9918 2.6001C13.7501 2.6001 13.0835 3.35843 12.8751 3.80843C12.7085 4.1751 12.8751 4.60843 13.2418 4.7751C13.6168 4.94176 14.0418 4.7751 14.2085 4.40843C14.2085 4.40843 14.3918 4.05843 14.9918 4.05843C15.6418 4.05843 15.6918 4.4751 15.6918 4.60843C15.6918 4.9751 15.4751 5.40843 14.4335 5.40843C14.0335 5.40843 13.7001 5.73343 13.7001 6.14176C13.7001 6.5501 14.0251 6.8751 14.4335 6.8751C15.9335 6.8751 15.9335 7.33343 15.9335 7.6751C15.9335 8.20843 15.4501 8.4501 15.1001 8.4501C14.8751 8.4501 14.1168 8.40843 13.8501 7.83343C13.6835 7.46676 13.2501 7.30843 12.8835 7.48343C12.5168 7.6501 12.3585 8.08343 12.5335 8.4501C12.9585 9.36676 13.9168 9.90843 15.1001 9.90843C16.2835 9.90843 17.3918 9.0751 17.3918 7.6751C17.3918 7.09176 17.2251 6.4501 16.6501 6.0001V5.98343Z"
        fill="currentColor"
      />
    </g>
    <defs>
      <clipPath id="clip0_3752_377880">
        <rect width="20" height="20" fill="white" />
      </clipPath>
    </defs>
  </svg>
`;
export const EditorButtonIcon = ({ html = runeHtml, klass = '' }: IconProps = {}) => html`
  <svg
    class="${klass}"
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    height="100%"
    viewBox="0 0 20 20"
    fill="none"
  >
    <path
      d="M16.8335 10.5583C16.6335 10.35 16.2919 10.4333 16.1669 10.6916C15.4335 12.2833 13.0335 13.325 9.82519 13.325C6.61686 13.325 4.21686 12.2833 3.48353 10.6916C3.36686 10.4333 3.0252 10.35 2.81686 10.5583C2.41686 10.9583 2.2002 11.4 2.2002 11.8666V14.275C2.2002 16.1166 5.61686 17.6083 9.82519 17.6083C14.0335 17.6083 17.4502 16.1166 17.4502 14.275V11.8666C17.4502 11.4 17.2252 10.9583 16.8335 10.5583Z"
      fill="currentColor"
    />
    <path
      d="M14.7169 3.9583C14.6669 3.89163 14.6085 3.81663 14.5419 3.74997C14.3502 3.54997 14.0835 3.36663 13.7752 3.19997C13.4585 3.0333 13.0919 2.89163 12.6835 2.76663C11.8669 2.52497 10.8752 2.3833 9.81686 2.3833C6.98353 2.3833 4.69186 3.3833 4.69186 4.62497C4.69186 5.86663 6.98353 6.86663 9.81686 6.86663C10.8752 6.86663 11.8669 6.72497 12.6835 6.4833C13.0919 6.36663 13.4585 6.21663 13.7752 6.04997C14.0919 5.8833 14.3502 5.69997 14.5419 5.49997C14.6085 5.4333 14.6669 5.36663 14.7169 5.29163C14.8169 5.14997 14.8835 5.0083 14.9169 4.8583C14.9335 4.7833 14.9419 4.7083 14.9419 4.62497C14.9419 4.54163 14.9335 4.47497 14.9169 4.39163C14.8835 4.24163 14.8169 4.09163 14.7169 3.9583Z"
      fill="currentColor"
    />
    <path
      d="M5.01686 7.24997C4.8752 7.16663 4.7002 7.2583 4.7002 7.42497V9.62497C4.7002 10.8666 6.99186 11.8666 9.82519 11.8666C12.6585 11.8666 14.9502 10.8666 14.9502 9.62497V7.42497C14.9502 7.2583 14.7752 7.16663 14.6335 7.24997C13.4669 7.92497 11.8002 8.32497 9.81686 8.32497C7.83353 8.32497 6.16686 7.92497 5.0002 7.24997H5.01686Z"
      fill="currentColor"
    />
  </svg>
`;
export const EditorProductIcon = ({ html = runeHtml, klass = '' }: IconProps = {}) => html`
  <svg
    class="${klass}"
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    height="100%"
    viewBox="0 0 20 20"
    fill="none"
  >
    <path
      d="M17.7739 9.77091L10.2351 2.23209C10.083 2.08003 9.88296 2 9.66687 2H2.8003C2.36014 2 2 2.36014 2 2.8003V9.67488C2 9.89096 2.08803 10.091 2.23209 10.2431L9.76291 17.7739C10.075 18.086 10.5792 18.086 10.8913 17.7739L17.7659 10.8993C18.078 10.5872 18.078 10.083 17.7659 9.77091H17.7739ZM5.40128 6.40165C4.84907 6.40165 4.4009 5.95348 4.4009 5.40128C4.4009 4.84907 4.84907 4.4009 5.40128 4.4009C5.95348 4.4009 6.40165 4.84907 6.40165 5.40128C6.40165 5.95348 5.95348 6.40165 5.40128 6.40165Z"
      fill="#141414"
    />
  </svg>
`;
export const WikiRestoreIcon = ({ html = runeHtml, klass = '' }: IconProps = {}) => html`
  <svg
    class="${klass}"
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    height="100%"
    viewBox="0 0 16 16"
    fill="none"
  >
    <g clip-path="url(#clip0_1101_80960)">
      <path
        d="M7.99999 1.33334C6.19999 1.33334 4.49999 2.06667 3.25999 3.32V1.92C3.25999 1.6 2.99999 1.33334 2.67333 1.33334C2.34666 1.33334 2.08666 1.59334 2.08666 1.92V4.96C2.08666 5.28 2.34666 5.54667 2.67333 5.54667H5.71333C6.03333 5.54667 6.29999 5.28667 6.29999 4.96C6.29999 4.63334 6.03999 4.37334 5.71333 4.37334H3.87333C4.90666 3.2 6.40666 2.5 7.99333 2.5C11.0267 2.5 13.4933 4.96667 13.4933 8C13.4933 11.0333 11.0267 13.5 7.99333 13.5C4.95999 13.5 2.49999 11.0333 2.49999 8C2.49999 7.68 2.23999 7.41334 1.91333 7.41334C1.58666 7.41334 1.32666 7.67334 1.32666 8C1.32666 11.6733 4.31999 14.6667 7.99333 14.6667C11.6667 14.6667 14.66 11.6733 14.66 8C14.66 4.32667 11.6733 1.33334 7.99999 1.33334Z"
        fill="currentColor"
      />
    </g>
    <defs>
      <clipPath id="clip0_1101_80960">
        <rect width="16" height="16" fill="white" />
      </clipPath>
    </defs>
  </svg>
`;
export const WikiEditIcon = ({ html = runeHtml, klass = '' }: IconProps = {}) => html`
  <svg
    class="${klass}"
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    height="100%"
    viewBox="0 0 16 16"
    fill="none"
  >
    <g clip-path="url(#clip0_1128_230489)">
      <path
        d="M1.35346 13.7267L1.84679 11.3667C1.88012 11.22 1.95346 11.08 2.06012 10.9733L11.4735 1.56C11.7801 1.25334 12.2735 1.25334 12.5735 1.56L14.4401 3.42667C14.7468 3.73334 14.7468 4.22667 14.4401 4.52667L5.02012 13.9467C4.91346 14.0533 4.78012 14.1267 4.62679 14.16L2.27346 14.6533C1.72679 14.7667 1.24012 14.28 1.35346 13.7333V13.7267Z"
        fill="currentColor"
      />
    </g>
    <defs>
      <clipPath id="clip0_1128_230489">
        <rect width="16" height="16" fill="white" />
      </clipPath>
    </defs>
  </svg>
`;
export const WikiReportIcon = ({ html = runeHtml, klass = '' }: IconProps = {}) => html`
  <svg
    class="${klass}"
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    height="100%"
    viewBox="0 0 16 16"
    fill="none"
  >
    <g clip-path="url(#clip0_1596_145341)">
      <path
        d="M13.1667 13H2.83333C2.3731 13 2 13.3731 2 13.8333C2 14.2936 2.3731 14.6667 2.83333 14.6667H13.1667C13.6269 14.6667 14 14.2936 14 13.8333C14 13.3731 13.6269 13 13.1667 13Z"
        fill="currentColor"
      />
      <path
        d="M8 1.33334C5.4 1.33334 3.29333 3.44 3.29333 6.04V11.1667C3.29333 11.5333 3.59333 11.8333 3.96 11.8333H12.04C12.4067 11.8333 12.7067 11.5333 12.7067 11.1667V6.04C12.7067 3.44 10.6 1.33334 8 1.33334ZM8 3.58667C6.64667 3.58667 5.54667 4.68667 5.54667 6.04C5.54667 6.36 5.28667 6.62667 4.96 6.62667C4.63333 6.62667 4.37333 6.36667 4.37333 6.04C4.37333 4.04 6 2.42 7.99333 2.42C8.31333 2.42 8.58 2.68 8.58 3.00667C8.58 3.33334 8.32 3.59334 7.99333 3.59334L8 3.58667Z"
        fill="currentColor"
      />
    </g>
    <defs>
      <clipPath id="clip0_1596_145341">
        <rect width="16" height="16" fill="white" />
      </clipPath>
    </defs>
  </svg>
`;
export const WikiRemoveIcon = ({ html = runeHtml, klass = '' }: IconProps = {}) => html`
  <svg
    class="${klass}"
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    height="100%"
    viewBox="0 0 16 16"
    fill="none"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M10.6668 2.3334L9.9735 1.56673C9.84684 1.42006 9.62017 1.3334 9.38017 1.3334H6.62684C6.38684 1.3334 6.16017 1.42006 6.0335 1.56673L5.34017 2.3334H2.6735C2.30684 2.3334 2.00684 2.6334 2.00684 3.00006C2.00684 3.36673 2.30684 3.66673 2.6735 3.66673H13.3402C13.7068 3.66673 14.0068 3.36673 14.0068 3.00006C14.0068 2.6334 13.7068 2.3334 13.3402 2.3334H10.6668Z"
      fill="currentColor"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M4.00017 13.9334C4.00017 14.3401 4.32684 14.6667 4.72684 14.6667H11.2668C11.6668 14.6667 11.9935 14.3401 11.9935 13.9334L12.7202 4.94673H3.2735L4.00017 13.9334ZM8.9335 7.60006C8.9335 7.28006 9.1935 7.0134 9.52017 7.0134C9.84684 7.0134 10.1068 7.2734 10.1068 7.60006V12.4334C10.1068 12.7534 9.84684 13.0201 9.52017 13.0201C9.1935 13.0201 8.9335 12.7601 8.9335 12.4334V7.60006ZM5.90017 7.60006C5.90017 7.28006 6.16017 7.0134 6.48684 7.0134C6.8135 7.0134 7.0735 7.2734 7.0735 7.60006V12.4334C7.0735 12.7534 6.8135 13.0201 6.48684 13.0201C6.16017 13.0201 5.90017 12.7601 5.90017 12.4334V7.60006Z"
      fill="currentColor"
    />
  </svg>
`;
export const DeliveryIcon = ({ html = runeHtml, klass = '' }: IconProps = {}) => html`
  <svg
    class="${klass}"
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    height="100%"
    viewBox="0 0 24 24"
    fill="none"
  >
    <g clip-path="url(#clip0_1054_194544)">
      <path
        d="M3.02006 6.33L11.5101 2.13C11.8501 1.96 12.2501 1.95 12.6001 2.11L15.6001 3.48L5.84006 8.31V13.11C5.84006 13.23 5.91006 13.34 6.02006 13.39L7.97006 14.35C8.18006 14.45 8.43006 14.3 8.43006 14.07V9.45L18.1501 4.64L20.9601 5.93C21.4101 6.14 21.7001 6.59 21.7001 7.08V16.53C21.7001 17.01 21.4301 17.45 20.9901 17.67L12.5201 21.86C12.1701 22.04 11.7501 22.04 11.3901 21.86L3.02006 17.73C2.59006 17.52 2.31006 17.07 2.31006 16.59V7.47C2.31006 6.99 2.58006 6.55 3.02006 6.33Z"
        fill="currentColor"
      />
    </g>
    <defs>
      <clipPath id="clip0_1054_194544">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
`;
export const ChangeIcon = ({ html = runeHtml, klass = '' }: IconProps = {}) => html`
  <svg
    class="${klass}"
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    height="100%"
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      d="M2.88 8.38H19.02L17.01 10.39C16.67 10.73 16.67 11.29 17.01 11.63C17.18 11.8 17.41 11.89 17.63 11.89C17.85 11.89 18.08 11.81 18.25 11.63L21.75 8.13C21.75 8.13 21.77 8.1 21.78 8.08C21.84 8.01 21.9 7.93 21.94 7.85C21.98 7.75 22 7.65 22 7.55C22 7.54 22 7.53 22 7.52C22 7.51 22 7.5 22 7.49C22 7.39 21.98 7.28 21.94 7.19C21.9 7.1 21.85 7.03 21.78 6.96C21.77 6.94 21.76 6.92 21.75 6.91L18.25 3.41C17.91 3.07 17.35 3.07 17.01 3.41C16.67 3.75 16.67 4.31 17.01 4.65L19.02 6.66H2.88C2.4 6.66 2 7.05 2 7.54C2 8.03 2.39 8.42 2.88 8.42V8.38Z"
      fill="currentColor"
    />
    <path
      d="M21.12 15.62H4.99L7 13.61C7.34 13.27 7.34 12.71 7 12.37C6.66 12.03 6.1 12.03 5.76 12.37L2.26 15.87C2.26 15.87 2.24 15.9 2.23 15.92C2.17 15.99 2.11 16.07 2.07 16.15C2.03 16.25 2.01 16.35 2.01 16.45C2.01 16.46 2.01 16.47 2.01 16.48C2.01 16.49 2.01 16.5 2.01 16.51C2.01 16.61 2.03 16.72 2.07 16.81C2.11 16.9 2.16 16.97 2.23 17.04C2.24 17.06 2.25 17.08 2.26 17.09L5.76 20.59C5.93 20.76 6.16 20.85 6.38 20.85C6.6 20.85 6.83 20.77 7 20.59C7.34 20.25 7.34 19.69 7 19.35L4.99 17.34H21.13C21.61 17.34 22.01 16.95 22.01 16.46C22.01 15.97 21.62 15.58 21.13 15.58L21.12 15.62Z"
      fill="currentColor"
    />
  </svg>
`;
export const CopyIcon = ({ html = runeHtml, klass = '' }: IconProps = {}) => html`
  <svg
    class="${klass}"
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    height="100%"
    viewBox="0 0 24 24"
    fill="none"
  >
    <g clip-path="url(#clip0_1577_136224)">
      <path
        d="M21 2H9C8.45 2 8 2.45 8 3V6.25H16.75C17.3 6.25 17.75 6.7 17.75 7.25V16H21C21.55 16 22 15.55 22 15V3C22 2.45 21.55 2 21 2Z"
        fill="currentColor"
      />
      <path
        d="M15 8H3C2.44772 8 2 8.44772 2 9V21C2 21.5523 2.44772 22 3 22H15C15.5523 22 16 21.5523 16 21V9C16 8.44772 15.5523 8 15 8Z"
        fill="currentColor"
      />
    </g>
    <defs>
      <clipPath id="clip0_1577_136224">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
`;
export const ReplyIcon = ({ html = runeHtml, klass = '' }: IconProps = {}) => html`
  <svg
    class="${klass}"
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    height="100%"
    viewBox="0 0 24 24"
    fill="none"
  >
    <path d="M8.7 15.3V7.5H7.5V15.3V16.5H8.7H16.5V15.3H8.7Z" fill="currentColor" />
  </svg>
`;
export const AlertIcon = ({ html = runeHtml, klass = '' }: IconProps = {}) => html`
  <svg
    class="${klass}"
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    height="100%"
    viewBox="0 0 24 24"
    fill="none"
  >
    <g clip-path="url(#clip0_874_138176)">
      <path
        d="M9.48994 19.11C9.25994 19.11 9.08994 19.31 9.11994 19.54C9.32994 20.95 10.5399 22.01 11.9999 22.01C13.4599 22.01 14.6699 20.95 14.8799 19.54C14.9099 19.31 14.7399 19.11 14.5099 19.11H9.48994Z"
        fill="currentColor"
      />
      <path
        d="M20.1599 16.85C19.5799 15.59 18.0199 14.28 18.0199 11.12V10.04C18.0199 7.44 16.3799 5.22 14.0799 4.37C14.0799 4.28 14.0999 4.2 14.0999 4.11C14.0999 2.95 13.1599 2 11.9999 2C10.8399 2 9.89994 2.94 9.89994 4.11C9.89994 4.2 9.89994 4.29 9.91994 4.37C7.61994 5.22 5.97994 7.44 5.97994 10.04V11.12C5.97994 14.29 4.41994 15.6 3.83994 16.85C3.53994 17.5 4.01994 18.24 4.72994 18.24H19.2699C19.9799 18.24 20.4599 17.5 20.1599 16.85Z"
        fill="currentColor"
      />
    </g>
    <defs>
      <clipPath id="clip0_874_138176">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
`;
export const TriangleUpIcon = ({ html = runeHtml, klass = '' }: IconProps = {}) => html`
  <svg
    class="${klass}"
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    height="100%"
    viewBox="0 0 6 6"
    fill="none"
  >
    <path d="M3 0.5L0 5.5H6L3 0.5Z" fill="#D92A0F" />
  </svg>
`;
export const TriangleDownIcon = ({ html = runeHtml, klass = '' }: IconProps = {}) => html`
  <svg
    class="${klass}"
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    height="100%"
    viewBox="0 0 6 6"
    fill="none"
  >
    <path d="M3 5.5L6 0.5L0 0.5L3 5.5Z" fill="#1C75FF" />
  </svg>
`;
export const BlinkIcon = ({ html = runeHtml, klass = '' }: IconProps = {}) => html`
  <svg
    class="${klass}"
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    height="100%"
    viewBox="0 0 28 28"
    fill="none"
  >
    <g clip-path="url(#clip0_8839_5972)">
      <path
        d="M16.859 11.0835C13.884 9.71852 11.5273 6.70852 10.454 2.91686C10.2323 2.14686 9.41565 2.14686 9.19398 2.91686C8.12065 6.70852 5.76398 9.71852 2.78898 11.0835C2.18232 11.3635 2.18232 12.4135 2.78898 12.6935C5.76398 14.0585 8.12065 17.0685 9.19398 20.8602C9.41565 21.6302 10.2323 21.6302 10.454 20.8602C11.5273 17.0685 13.884 14.0585 16.859 12.6935C17.4657 12.4135 17.4657 11.3635 16.859 11.0835Z"
        fill="#1C75FF"
      />
      <path
        d="M25.4107 19.7402C23.7073 18.9585 22.3657 17.2319 21.7473 15.0735C21.619 14.6302 21.1523 14.6302 21.024 15.0735C20.4057 17.2435 19.064 18.9585 17.3607 19.7402C17.0107 19.9035 17.0107 20.4985 17.3607 20.6619C19.064 21.4435 20.4057 23.1702 21.024 25.3285C21.1523 25.7719 21.619 25.7719 21.7473 25.3285C22.3657 23.1585 23.7073 21.4435 25.4107 20.6619C25.7607 20.4985 25.7607 19.9035 25.4107 19.7402Z"
        fill="#1C75FF"
      />
    </g>
    <defs>
      <clipPath id="clip0_8839_5972">
        <rect width="28" height="28" fill="white" />
      </clipPath>
    </defs>
  </svg>
`;
export const CrossIcon = ({ html = runeHtml, klass = '' }: IconProps = {}) => html`
  <svg
    class="${klass}"
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    height="100%"
    viewBox="0 0 80 80"
    fill="none"
  >
    <rect x="30.833" width="18.3333" height="80" fill="currentColor" />
    <rect y="30.8333" width="80" height="18.3333" fill="currentColor" />
  </svg>
`;
export const CameraIcon = ({ html = runeHtml, klass = '' }: IconProps = {}) => html`
  <svg
    class="${klass}"
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    height="100%"
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      d="M18.28 6.31C17.91 6.31 17.57 6.11 17.4 5.78L16.37 3.84C16.2 3.51 15.86 3.31 15.49 3.31H8.53002C8.16002 3.31 7.82002 3.51 7.65002 3.84L6.62002 5.78C6.45002 6.11 6.11002 6.31 5.74002 6.31H3.02002C2.47002 6.31 2.02002 6.76 2.02002 7.31V19.31C2.02002 19.86 2.47002 20.31 3.02002 20.31H21.02C21.57 20.31 22.02 19.86 22.02 19.31V7.31C22.02 6.76 21.57 6.31 21.02 6.31H18.28ZM17 13.31C17 13.83 16.92 14.33 16.78 14.8C16.63 15.27 16.42 15.71 16.15 16.11C15.79 16.64 15.33 17.1 14.8 17.46C14 18 13.04 18.31 12 18.31C10.96 18.31 10 18 9.20002 17.46C8.67002 17.1 8.21002 16.64 7.85002 16.11C7.58002 15.71 7.37002 15.27 7.22002 14.8C7.07002 14.33 7.00002 13.83 7.00002 13.31C7.00002 12.27 7.31002 11.31 7.85002 10.51C8.21002 9.98 8.67002 9.52 9.20002 9.16C10 8.62 10.96 8.31 12 8.31C13.04 8.31 14 8.62 14.8 9.16C15.33 9.52 15.79 9.98 16.15 10.51C16.69 11.31 17 12.27 17 13.31ZM19 10.31C18.45 10.31 18 9.86 18 9.31C18 8.76 18.45 8.31 19 8.31C19.55 8.31 20 8.76 20 9.31C20 9.86 19.55 10.31 19 10.31Z"
      fill="currentColor"
    />
    <path
      d="M12 16.56C13.7949 16.56 15.25 15.1049 15.25 13.31C15.25 11.5151 13.7949 10.06 12 10.06C10.2051 10.06 8.75002 11.5151 8.75002 13.31C8.75002 15.1049 10.2051 16.56 12 16.56Z"
      fill="currentColor"
    />
  </svg>
`;
export const GiftIcon = ({ html = runeHtml, klass = '' }: IconProps = {}) => html`
  <svg
    class="${klass}"
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    height="100%"
    viewBox="0 0 24 24"
    fill="none"
  >
    <g clip-path="url(#clip0_2904_123886)">
      <path
        d="M12.8891 21.5H20.002C21.1009 21.5 22 20.6009 22 19.5021V11.6803H12.8891V21.5Z"
        fill="currentColor"
      />
      <path
        d="M20.002 6.51577H17.4446C18.0739 5.60673 18.0539 4.38801 17.2847 3.48896C16.7253 2.83964 15.9061 2.5 15.0669 2.5C14.4476 2.5 13.8282 2.6898 13.3087 3.0694C12.7592 3.47897 12.3297 3.96845 12 4.48791C11.6703 3.96845 11.2507 3.47897 10.6913 3.0694C10.1718 2.6898 9.55245 2.5 8.93307 2.5C8.1039 2.5 7.27472 2.83964 6.71528 3.48896C5.94605 4.38801 5.92607 5.59674 6.55544 6.51577H3.998C2.8991 6.51577 2 7.41483 2 8.51367V9.93218H21.98V8.51367C21.98 7.41483 21.0809 6.51577 19.982 6.51577H20.002ZM14.3477 4.47792C14.5475 4.32808 14.8072 4.24816 15.0669 4.24816C15.4166 4.24816 15.7562 4.38801 15.956 4.62776C16.1359 4.83754 16.1558 5.04732 16.1459 5.18717C16.1259 5.39695 15.996 5.59674 15.7962 5.74658C15.4066 6.03628 14.4775 6.33596 12.989 6.43586C13.2388 5.73659 13.6484 4.98738 14.3477 4.47792ZM8.06394 4.62776C8.26374 4.38801 8.6034 4.24816 8.95305 4.24816C9.22278 4.24816 9.47253 4.32808 9.67233 4.47792C10.3716 4.98738 10.7912 5.74658 11.031 6.43586C9.53247 6.33596 8.61339 6.02629 8.22378 5.74658C8.02398 5.59674 7.89411 5.39695 7.87413 5.18717C7.85415 5.04732 7.87413 4.83754 8.06394 4.62776Z"
        fill="currentColor"
      />
      <path
        d="M2.01998 19.5021C2.01998 20.6009 2.91908 21.5 4.01798 21.5H11.1309V11.6803H2.01998V19.5021Z"
        fill="currentColor"
      />
    </g>
    <defs>
      <clipPath id="clip0_2904_123886">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
`;
export const FileIcon = ({ html = runeHtml, klass = '' }: IconProps = {}) => html`
  <svg
    class="${klass}"
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    height="100%"
    viewBox="0 0 24 24"
    fill="none"
  >
    <g clip-path="url(#clip0_4851_196681)">
      <path d="M3 2.05H21C21.55 2.05 22 2.5 22 3.05V8.05H2V3.05C2 2.5 2.45 2.05 3 2.05Z" fill="black" />
      <path
        d="M3 9.8V21C3 21.55 3.45 22 4 22H20C20.55 22 21 21.55 21 21V9.8H3ZM16 14.55C16 15.03 15.61 15.43 15.12 15.43H8.87C8.39 15.43 7.99 15.04 7.99 14.55V13.8C7.99 13.32 8.38 12.92 8.87 12.92H15.12C15.6 12.92 16 13.31 16 13.8V14.55Z"
        fill="currentColor"
      />
    </g>
    <defs>
      <clipPath id="clip0_4851_196681">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
`;
export const DigitalIcon = ({ html = runeHtml, klass = '' }: IconProps = {}) => html`
  <svg
    class="${klass}"
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    height="100%"
    viewBox="0 0 24 24"
    fill="none"
  >
    <g clip-path="url(#clip0_3246_320253)">
      <path
        d="M17.25 2H6.75C5.65 2 4.75 2.9 4.75 4V20C4.75 21.1 5.65 22 6.75 22H17.25C18.35 22 19.25 21.1 19.25 20V4C19.25 2.9 18.35 2 17.25 2ZM12 20.25C11.31 20.25 10.75 19.69 10.75 19C10.75 18.31 11.31 17.75 12 17.75C12.69 17.75 13.25 18.31 13.25 19C13.25 19.69 12.69 20.25 12 20.25ZM16.38 5.5H7.62C7.14 5.5 6.74 5.11 6.74 4.62C6.74 4.13 7.13 3.74 7.62 3.74H16.37C16.85 3.74 17.25 4.13 17.25 4.62C17.25 5.11 16.86 5.5 16.37 5.5H16.38Z"
        fill="currentColor"
      />
    </g>
    <defs>
      <clipPath id="clip0_3246_320253">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
`;
export const LocationIcon = ({ html = runeHtml, klass = '' }: IconProps = {}) => html`
  <svg
    class="${klass}"
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    height="100%"
    viewBox="0 0 24 24"
    fill="none"
  >
    <g clip-path="url(#clip0_3735_348235)">
      <path
        d="M19.6101 9.61C19.6101 5.41 16.2001 2 12.0001 2C7.80014 2 4.39014 5.41 4.39014 9.61C4.39014 9.67 4.39014 9.72 4.39014 9.78C4.39014 9.87 4.39014 9.96 4.39014 10.06C4.39014 16.82 9.74014 20.75 11.4701 21.84C11.8001 22.05 12.2101 22.05 12.5301 21.84C14.2601 20.75 19.6101 16.82 19.6101 10.06C19.6101 9.96 19.6101 9.87 19.6101 9.78C19.6101 9.72 19.6101 9.67 19.6101 9.61ZM12.0001 14.28C9.40014 14.28 7.29014 12.17 7.29014 9.57C7.29014 6.97 9.40014 4.86 12.0001 4.86C14.6001 4.86 16.7101 6.97 16.7101 9.57C16.7101 12.17 14.6001 14.28 12.0001 14.28Z"
        fill="currentColor"
      />
    </g>
    <defs>
      <clipPath id="clip0_3735_348235">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
`;
export const MShopDefaultIcon = ({ html = runeHtml, klass = '' }: IconProps = {}) => {
  return html`
    <svg
      class="${klass}"
      xmlns="http://www.w3.org/2000/svg"
      width="100%"
      height="100%"
      viewBox="0 0 24 24"
      fill="none"
    >
      <g clip-path="url(#clip0_705_98856)">
        <path
          d="M21.54 6.25C20.7 4.18 18.8 2.89 16.57 2.89C14.69 2.89 12.95 3.84 12 5.39C11.05 3.84 9.31002 2.89 7.43002 2.89C5.21002 2.89 3.30002 4.18 2.46002 6.25C1.90002 7.63 1.85002 9.12 2.32002 10.8C2.46002 11.3 2.64002 11.81 2.87002 12.3C3.12002 12.85 3.42002 13.39 3.78002 13.93L3.82002 13.98C4.03002 14.29 4.25002 14.59 4.48002 14.88C6.33002 17.22 8.71002 19.23 11.77 21.05C11.83 21.09 11.91 21.11 12 21.11C12.05 21.11 12.15 21.11 12.23 21.05C15.29 19.24 17.68 17.22 19.52 14.88C19.75 14.59 19.97 14.29 20.18 13.98L20.22 13.91C20.57 13.38 20.88 12.84 21.12 12.29C21.35 11.8 21.53 11.29 21.67 10.79C22.14 9.11 22.09 7.62 21.53 6.24L21.54 6.25ZM16.37 15.78C15.94 16.2 15.48 16.61 15 17C15.18 16.66 15.35 16.31 15.52 15.96C15.81 15.91 16.09 15.85 16.37 15.78ZM14.31 14.39C12.81 14.58 11.2 14.58 9.70002 14.39C9.24002 13.26 8.93002 12.14 8.76002 10.97V10.95C10.85 11.26 13.16 11.26 15.25 10.95V10.97C15.08 12.14 14.77 13.26 14.31 14.39ZM8.48002 15.96C8.64002 16.31 8.82002 16.66 9.00002 17C8.52002 16.6 8.06002 16.19 7.63002 15.78C7.91002 15.85 8.19002 15.91 8.48002 15.96ZM14.27 5.43C14.38 5.46 14.89 5.88 15.19 7.31C15.32 7.9 15.38 8.52 15.38 9.18C13.26 9.54 10.74 9.54 8.62002 9.18C8.62002 8.51 8.68002 7.9 8.81002 7.31C9.11002 5.88 9.62002 5.46 9.70002 5.43C9.79002 5.45 10.21 5.76 10.51 6.79L10.58 7C10.77 7.63 11.35 8.05 12.01 8.05C12.67 8.05 13.24 7.63 13.44 7L13.51 6.79C13.81 5.77 14.24 5.45 14.29 5.43H14.27ZM7.10002 6.94C6.98002 7.52 6.90002 8.14 6.88002 8.78C6.59002 8.69 6.32002 8.6 6.07002 8.51C4.95002 8.08 4.18002 7.52 4.06002 7.04C4.05002 7 4.06002 6.95 4.07002 6.9C4.37002 6.16 4.84002 5.58 5.46002 5.19C6.20002 4.72 7.13002 4.54 8.02002 4.68C7.61002 5.24 7.29002 6.01 7.09002 6.94H7.10002ZM6.95002 10.6C6.97002 10.81 7.00002 11.01 7.03002 11.22C7.17002 12.17 7.39002 13.09 7.69002 14C7.24002 13.88 6.82002 13.74 6.43002 13.57C5.61002 13.23 4.94002 12.59 4.55002 11.78L4.52002 11.72C4.49002 11.61 4.45002 11.51 4.40002 11.45C4.24002 11.08 4.10002 10.7 4.00002 10.33C3.90002 9.97 3.83002 9.62 3.79002 9.29C4.57002 9.83 5.65002 10.28 6.96002 10.6H6.95002ZM16.97 11.22C17 11.01 17.03 10.81 17.05 10.6C18.35 10.27 19.44 9.82 20.22 9.29C20.18 9.63 20.11 9.98 20.01 10.33C19.91 10.7 19.77 11.08 19.63 11.42C19.56 11.52 19.51 11.62 19.5 11.7L19.46 11.78C19.06 12.59 18.4 13.23 17.56 13.58C17.18 13.74 16.76 13.88 16.31 14C16.62 13.08 16.83 12.17 16.97 11.22ZM20.16 6.81L19.93 6.9C19.93 6.9 19.95 7 19.94 7.04C19.82 7.51 19.05 8.08 17.93 8.51C17.68 8.61 17.41 8.7 17.12 8.78C17.1 8.14 17.03 7.52 16.9 6.94C16.7 6.01 16.38 5.23 15.97 4.67C16.86 4.53 17.79 4.71 18.53 5.18C19.15 5.58 19.62 6.15 19.92 6.89L20.15 6.8L20.16 6.81ZM12 18.53C11.47 17.8 10.99 17.04 10.55 16.22C11.52 16.29 12.48 16.29 13.44 16.22C13 17.04 12.53 17.8 11.99 18.53H12Z"
          fill="currentColor"
        />
      </g>
      <defs>
        <clipPath id="clip0_705_98856">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  `;
};
export const MShopThinIcon = ({ html = runeHtml, klass = '' }: IconProps = {}) => html`
  <svg
    class="${klass}"
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    height="100%"
    viewBox="0 0 24 24"
    fill="none"
  >
    <g clip-path="url(#clip0_3246_224426)">
      <path
        d="M19.52 14.8C19.75 14.5 19.98 14.2 20.18 13.89C20.18 13.89 20.2 13.87 20.2 13.85C20.2 13.84 20.21 13.83 20.22 13.82C20.56 13.3 20.87 12.76 21.13 12.19C21.35 11.71 21.54 11.21 21.68 10.69C22.1 9.17 22.14 7.66 21.54 6.19C20.64 3.98 18.66 2.91 16.68 2.91C14.88 2.91 13.09 3.8 12.11 5.51C12.09 5.54 12.07 5.58 12.05 5.61C12.02 5.66 11.95 5.66 11.92 5.61C11.9 5.58 11.88 5.54 11.86 5.51C10.89 3.79 9.08999 2.91 7.28999 2.91C5.30999 2.91 3.32999 3.98 2.42999 6.19C1.82999 7.66 1.86999 9.18 2.28999 10.69C2.42999 11.21 2.61999 11.71 2.83999 12.19C3.09999 12.76 3.39999 13.3 3.74999 13.82C3.74999 13.83 3.75999 13.84 3.76999 13.85C3.76999 13.86 3.78999 13.87 3.78999 13.89C3.99999 14.2 4.21999 14.5 4.44999 14.8C6.49999 17.4 9.04999 19.4 11.86 21.07C11.89 21.09 11.92 21.09 11.96 21.09C12 21.09 12.05 21.09 12.07 21.07C14.89 19.4 17.43 17.4 19.48 14.8H19.52ZM4.07999 11.79C4.05999 11.7 4.01999 11.63 3.96999 11.56C3.96999 11.56 3.96999 11.56 3.96999 11.55C3.79999 11.16 3.65999 10.76 3.54999 10.36C3.39999 9.83 3.31999 9.32 3.28999 8.84C3.28999 8.77 3.35999 8.73 3.41999 8.78C4.26999 9.47 5.53999 9.99 7.01999 10.35C7.04999 10.35 7.07999 10.38 7.07999 10.42C7.09999 10.67 7.12999 10.92 7.16999 11.17C7.33999 12.31 7.60999 13.34 7.94999 14.29C7.96999 14.35 7.91999 14.41 7.85999 14.39C7.26999 14.25 6.71999 14.07 6.21999 13.86C6.21999 13.86 6.20999 13.86 6.19999 13.86C5.29999 13.48 4.56999 12.78 4.13999 11.9C4.12999 11.87 4.10999 11.84 4.09999 11.81C4.09999 11.81 4.09999 11.81 4.09999 11.8L4.07999 11.79ZM8.46999 7.13C8.80999 5.54 9.41999 5 9.64999 5C9.83999 5 10.36 5.4 10.71 6.58C10.72 6.63 10.74 6.67 10.75 6.72L10.77 6.79C10.93 7.32 11.43 7.69 11.99 7.69C12.55 7.69 13.04 7.33 13.21 6.79L13.23 6.72C13.25 6.67 13.26 6.62 13.27 6.58C13.62 5.4 14.15 5 14.33 5C14.56 5 15.18 5.54 15.51 7.13C15.65 7.8 15.72 8.5 15.71 9.26C15.71 9.3 15.68 9.33 15.65 9.34C14.52 9.54 13.28 9.65 11.99 9.65C10.7 9.65 9.45999 9.54 8.32999 9.34C8.28999 9.34 8.26999 9.3 8.26999 9.26C8.25999 8.51 8.31999 7.8 8.46999 7.13ZM12 10.91C13.19 10.91 14.39 10.82 15.53 10.64C15.58 10.64 15.62 10.67 15.62 10.73C15.61 10.82 15.6 10.9 15.58 10.99C15.4 12.23 15.07 13.42 14.58 14.61C14.56 14.67 14.51 14.7 14.45 14.71C13.67 14.81 12.85 14.86 12 14.86C11.15 14.86 10.33 14.81 9.54999 14.71C9.48999 14.71 9.43999 14.66 9.41999 14.61C8.92999 13.42 8.59999 12.24 8.41999 10.99C8.40999 10.9 8.39999 10.82 8.37999 10.73C8.37999 10.68 8.41999 10.64 8.46999 10.64C9.60999 10.82 10.81 10.91 12 10.91ZM20.46 10.36C20.35 10.76 20.21 11.15 20.04 11.55C20.04 11.55 20.04 11.55 20.04 11.56C19.99 11.63 19.95 11.71 19.93 11.79V11.8C19.92 11.83 19.9 11.86 19.89 11.89C19.46 12.77 18.73 13.47 17.83 13.85C17.83 13.85 17.82 13.85 17.81 13.85C17.31 14.06 16.76 14.23 16.17 14.38C16.11 14.39 16.06 14.34 16.08 14.28C16.42 13.32 16.69 12.3 16.86 11.16C16.9 10.91 16.93 10.66 16.95 10.41C16.95 10.38 16.98 10.35 17.01 10.34C18.49 9.98 19.76 9.45 20.61 8.77C20.66 8.73 20.74 8.77 20.74 8.83C20.71 9.31 20.63 9.82 20.48 10.35L20.46 10.36ZM13.86 16.16C13.34 17.19 12.74 18.15 12.06 19.05C12.03 19.09 11.97 19.09 11.94 19.05C11.26 18.15 10.67 17.19 10.14 16.16C10.11 16.11 10.16 16.04 10.22 16.05C10.8 16.1 11.4 16.13 12.01 16.13C12.62 16.13 13.21 16.1 13.8 16.05C13.86 16.05 13.9 16.11 13.88 16.16H13.86ZM8.58999 15.87C8.89999 16.56 9.23999 17.2 9.58999 17.8C9.62999 17.87 9.53999 17.95 9.47999 17.9C8.51999 17.16 7.65999 16.39 6.86999 15.58C6.80999 15.52 6.86999 15.43 6.94999 15.45C7.44999 15.6 7.97999 15.72 8.53999 15.82C8.55999 15.82 8.58999 15.84 8.59999 15.86L8.58999 15.87ZM15.47 15.83C16.03 15.73 16.56 15.61 17.06 15.46C17.14 15.44 17.19 15.53 17.14 15.59C16.36 16.4 15.49 17.17 14.53 17.91C14.46 17.96 14.37 17.88 14.42 17.81C14.77 17.21 15.11 16.57 15.42 15.88C15.43 15.86 15.45 15.84 15.48 15.84L15.47 15.83ZM20.37 6.67C20.41 6.77 20.42 6.87 20.39 6.97C20.24 7.55 19.44 8.16 18.17 8.65C17.83 8.78 17.47 8.9 17.09 9C17.04 9.01 16.99 8.98 16.99 8.93C16.99 8.23 16.91 7.54 16.77 6.86C16.53 5.74 16.14 4.93 15.68 4.41C15.64 4.37 15.66 4.3 15.72 4.28C16.03 4.21 16.35 4.17 16.68 4.17C17.46 4.17 18.2 4.38 18.83 4.78C19.52 5.22 20.03 5.85 20.36 6.66L20.37 6.67ZM5.15999 4.79C5.78999 4.39 6.52999 4.18 7.30999 4.18C7.63999 4.18 7.95999 4.22 8.26999 4.29C8.32999 4.3 8.34999 4.37 8.30999 4.42C7.84999 4.94 7.45999 5.75 7.21999 6.87C7.07999 7.55 7.00999 8.24 6.99999 8.94C6.99999 8.99 6.94999 9.03 6.89999 9.01C6.51999 8.9 6.15999 8.79 5.81999 8.66C4.54999 8.17 3.74999 7.56 3.59999 6.98C3.56999 6.88 3.57999 6.77 3.61999 6.68C3.94999 5.87 4.45999 5.24 5.14999 4.8L5.15999 4.79Z"
        fill="currentColor"
      />
    </g>
    <defs>
      <clipPath id="clip0_3246_224426">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
`;
export const OfficialIcon = ({ html = runeHtml, klass = '' }: IconProps = {}) => html`
  <svg
    class="${klass}"
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    height="100%"
    viewBox="0 0 24 24"
    fill="none"
  >
    <g clip-path="url(#clip0_10144_88972)">
      <path
        d="M20.6 9.59C19.83 9.15 18.85 8.77 17.72 8.48C17.87 9.61 17.95 10.79 17.95 12C17.95 13.21 17.87 14.39 17.72 15.52C18.85 15.23 19.83 14.85 20.6 14.41C21.46 13.92 22 13 22 12.02C22 12.02 22 12.02 22 12.01C22 12 22 12.01 22 12C22 11.01 21.46 10.1 20.6 9.61V9.59Z"
        fill="#141414"
      />
      <path
        d="M6.6 6.6C6.81 5.63 7.08 4.73 7.4 3.92C7.55 3.54 7.71 3.2 7.87 2.88C5.66 3.88 3.88 5.66 2.88 7.87C3.19 7.71 3.54 7.55 3.92 7.4C4.73 7.08 5.63 6.81 6.6 6.6Z"
        fill="#141414"
      />
      <path
        d="M8.1 8.1C7.91 9.31 7.8 10.62 7.8 12C7.8 13.38 7.91 14.69 8.1 15.9C9.31 16.09 10.62 16.2 12 16.2C13.38 16.2 14.69 16.09 15.9 15.9C16.09 14.69 16.2 13.38 16.2 12C16.2 10.62 16.09 9.31 15.9 8.1C14.69 7.91 13.38 7.8 12 7.8C10.62 7.8 9.31 7.91 8.1 8.1Z"
        fill="#141414"
      />
      <path
        d="M17.4 17.4C17.19 18.37 16.92 19.27 16.6 20.08C16.45 20.46 16.29 20.8 16.13 21.12C18.34 20.12 20.12 18.34 21.12 16.13C20.81 16.29 20.46 16.45 20.08 16.6C19.27 16.92 18.37 17.19 17.4 17.4Z"
        fill="#141414"
      />
      <path
        d="M6.6 17.4C5.63 17.19 4.73 16.92 3.92 16.6C3.54 16.45 3.2 16.29 2.88 16.13C3.88 18.34 5.66 20.12 7.87 21.12C7.71 20.81 7.55 20.46 7.4 20.08C7.08 19.27 6.81 18.37 6.6 17.4Z"
        fill="#141414"
      />
      <path
        d="M8.48 17.72C8.77 18.85 9.15 19.83 9.59 20.6C10.08 21.46 11 22 11.98 22C11.98 22 11.98 22 11.99 22C12 22 11.99 22 12 22C12.99 22 13.9 21.46 14.39 20.6C14.83 19.83 15.21 18.85 15.5 17.72C14.37 17.87 13.19 17.95 11.98 17.95C10.77 17.95 9.59 17.87 8.46 17.72H8.48Z"
        fill="#141414"
      />
      <path
        d="M6.28 8.48C5.15 8.77 4.17 9.15 3.4 9.59C2.54 10.08 2 11 2 11.98C2 11.98 2 11.98 2 11.99C2 12 2 11.99 2 12C2 12.99 2.54 13.9 3.4 14.39C4.17 14.83 5.15 15.21 6.28 15.5C6.13 14.37 6.05 13.19 6.05 11.98C6.05 10.77 6.13 9.59 6.28 8.46V8.48Z"
        fill="#141414"
      />
      <path
        d="M15.52 6.28C15.23 5.15 14.85 4.17 14.41 3.4C13.92 2.54 13 2 12.02 2C12.02 2 12.02 2 12.01 2C12 2 12.01 2 12 2C11.01 2 10.1 2.54 9.61 3.4C9.17 4.17 8.79 5.15 8.5 6.28C9.63 6.13 10.81 6.05 12.02 6.05C13.23 6.05 14.41 6.13 15.54 6.28H15.52Z"
        fill="#141414"
      />
      <path
        d="M17.4 6.6C18.37 6.81 19.27 7.08 20.08 7.4C20.46 7.55 20.8 7.71 21.12 7.87C20.12 5.66 18.34 3.88 16.13 2.88C16.29 3.19 16.45 3.54 16.6 3.92C16.92 4.73 17.19 5.63 17.4 6.6Z"
        fill="#141414"
      />
    </g>
    <defs>
      <clipPath id="clip0_10144_88972">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
`;
export const YoutubeIcon = ({ html = runeHtml, klass = '' }: IconProps = {}) => html`
  <svg
    class="${klass}"
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    height="100%"
    viewBox="0 0 24 24"
    fill="none"
  >
    <g clip-path="url(#clip0_3246_320738)">
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M19.81 5.42C20.67 5.65 21.35 6.33 21.58 7.19C22 8.75 22 12 22 12C22 12 22 15.25 21.58 16.81C21.35 17.67 20.67 18.35 19.81 18.58C18.25 19 12 19 12 19C12 19 5.75 19 4.19 18.58C3.33 18.35 2.65 17.67 2.42 16.81C2 15.25 2 12 2 12C2 12 2 8.75 2.42 7.19C2.65 6.33 3.33 5.65 4.19 5.42C5.75 5 12 5 12 5C12 5 18.25 5 19.81 5.42ZM15 12L10 9V15L15 12Z"
        fill="currentColor"
      />
    </g>
    <defs>
      <clipPath id="clip0_3246_320738">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
`;
export const BlogIcon = ({ html = runeHtml, klass = '' }: IconProps = {}) => html`
  <svg
    class="${klass}"
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    height="100%"
    viewBox="0 0 24 24"
    fill="none"
  >
    <g clip-path="url(#clip0_3246_320740)">
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M13.1502 9.93C12.9302 9.93 12.7402 10.01 12.5802 10.18C12.4202 10.35 12.3402 10.55 12.3402 10.78C12.3402 11.01 12.4202 11.22 12.5802 11.38C12.7402 11.54 12.9302 11.63 13.1502 11.63C13.3702 11.63 13.5702 11.55 13.7302 11.38C13.8902 11.21 13.9702 11.01 13.9702 10.78C13.9702 10.55 13.8902 10.34 13.7302 10.18C13.5702 10.01 13.3702 9.93 13.1502 9.93ZM6.23023 9.93C6.01023 9.93 5.82023 10.01 5.66023 10.18C5.50023 10.35 5.42023 10.55 5.42023 10.78C5.42023 11.01 5.50023 11.22 5.66023 11.38C5.82023 11.55 6.01023 11.63 6.23023 11.63C6.45023 11.63 6.65023 11.55 6.81023 11.38C6.97023 11.21 7.05023 11.01 7.05023 10.78C7.05023 10.55 6.97023 10.34 6.81023 10.18C6.65023 10.02 6.45023 9.93 6.23023 9.93ZM17.1902 10.18C17.3502 10.02 17.5402 9.93 17.7602 9.93C17.9902 9.93 18.1802 10.01 18.3402 10.18C18.5002 10.35 18.5802 10.55 18.5802 10.78C18.5802 11.01 18.5002 11.22 18.3402 11.38C18.1802 11.55 17.9802 11.63 17.7602 11.63C17.5402 11.63 17.3502 11.55 17.1902 11.38C17.0302 11.21 16.9502 11.01 16.9502 10.78C16.9502 10.55 17.0302 10.34 17.1902 10.18Z"
        fill="currentColor"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M19.8202 3.56C21.0202 3.56 22.0002 4.57 22.0002 5.8V14.88C22.0002 16.11 21.0202 17.12 19.8202 17.12H13.6502C13.6502 17.12 12.3702 20.44 11.9302 20.44C11.4902 20.44 10.3102 17.12 10.3102 17.12H4.17023C2.97023 17.12 1.99023 16.11 1.99023 14.88V5.8C1.99023 4.57 2.97023 3.56 4.17023 3.56H19.8202ZM9.14023 12.4H10.3402V9.19C10.2402 7.1 8.57023 7 8.57023 7V8.3C8.57023 8.3 9.15023 8.4 9.15023 9.15V12.4H9.14023ZM19.7402 11.93C19.7402 12.85 19.5702 13.42 19.1702 13.81C18.6902 14.28 18.0102 14.31 17.4402 14.22V13.27C17.9202 13.32 18.5702 13 18.5702 12.36V12.12H18.5602C18.2902 12.5 17.9002 12.64 17.3802 12.64C16.9002 12.64 16.4802 12.46 16.2002 12.12C15.9202 11.78 15.7702 11.32 15.7702 10.75C15.7702 10.11 15.9302 9.6 16.2402 9.22C16.5602 8.84 17.0002 8.67 17.5202 8.67C17.9802 8.67 18.2702 8.79 18.5602 9.05H18.5702V8.76H19.7402V11.94V11.93ZM15.0302 11.41C14.9302 11.65 14.7802 11.86 14.5902 12.04C14.4002 12.22 14.1802 12.36 13.9302 12.46C13.6802 12.56 13.4202 12.61 13.1502 12.61C12.8802 12.61 12.6202 12.56 12.3802 12.46C12.1302 12.36 11.9202 12.22 11.7202 12.04C11.5202 11.85 11.3702 11.64 11.2702 11.4C11.1702 11.17 11.1202 10.92 11.1202 10.66C11.1202 10.4 11.1702 10.15 11.2702 9.92C11.3702 9.69 11.5202 9.47 11.7202 9.28C11.9102 9.1 12.1302 8.96 12.3802 8.86C12.6202 8.76 12.8802 8.71 13.1502 8.71C13.4202 8.71 13.6902 8.76 13.9302 8.86C14.1802 8.96 14.3902 9.1 14.5902 9.28C14.7802 9.46 14.9302 9.67 15.0302 9.91C15.1302 10.15 15.1802 10.39 15.1802 10.66C15.1802 10.93 15.1302 11.17 15.0302 11.41ZM7.81023 11.94C7.50023 12.3 7.03023 12.45 6.51023 12.45C6.04024 12.45 5.70023 12.31 5.45023 12.11H5.43023V12.37H4.26023V7.12H5.43023V9.13H5.45023C5.77023 8.85 6.19023 8.76 6.69023 8.74C7.12023 8.72 7.56023 9 7.82023 9.31C8.08023 9.62 8.28023 10.12 8.28023 10.66C8.28023 11.25 8.13023 11.59 7.82023 11.95L7.81023 11.94Z"
        fill="currentColor"
      />
    </g>
    <defs>
      <clipPath id="clip0_3246_320740">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
`;
export const InstagramIcon = ({ html = runeHtml, klass = '' }: IconProps = {}) => html`
  <svg
    class="${klass}"
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    height="100%"
    viewBox="0 0 24 24"
    fill="none"
  >
    <g clip-path="url(#clip0_10144_88960)">
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M8.26 3H15.73C18.64 3 20.99 5.36 20.99 8.26V15.73C20.99 18.64 18.63 20.99 15.73 20.99H8.26C5.35 20.99 3 18.63 3 15.73V8.26C3 5.35 5.36 3 8.26 3ZM15.74 4.7H8.27C6.3 4.7 4.7 6.3 4.7 8.27V15.74C4.7 17.71 6.3 19.31 8.27 19.31H15.74C17.71 19.31 19.31 17.71 19.31 15.74V8.27C19.31 6.3 17.71 4.7 15.74 4.7Z"
        fill="currentColor"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M16.58 11.97C16.58 9.42 14.51 7.35 11.96 7.35C9.41 7.35 7.34 9.42 7.34 11.97C7.34 14.52 9.41 16.59 11.96 16.59C14.51 16.59 16.58 14.52 16.58 11.97ZM9.04 11.97C9.04 10.36 10.35 9.05 11.96 9.05C13.57 9.05 14.88 10.36 14.88 11.97C14.88 13.58 13.57 14.89 11.96 14.89C10.35 14.89 9.04 13.58 9.04 11.97Z"
        fill="currentColor"
      />
      <path
        d="M16.79 8.3C17.392 8.3 17.88 7.81199 17.88 7.21C17.88 6.60801 17.392 6.12 16.79 6.12C16.188 6.12 15.7 6.60801 15.7 7.21C15.7 7.81199 16.188 8.3 16.79 8.3Z"
        fill="currentColor"
      />
    </g>
    <defs>
      <clipPath id="clip0_10144_88960">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
`;
export const XIcon = ({ html = runeHtml, klass = '' }: IconProps = {}) => html`
  <svg
    class="${klass}"
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    height="100%"
    viewBox="0 0 24 24"
    fill="none"
  >
    <g clip-path="url(#clip0_3246_320774)">
      <path
        d="M13.64 10.61L19.28 4.52999L20.12 3.57999H18.58L12.93 9.66999L8.36 3.57999H3L9.97 12.87L3.84 19.47L3 20.42H4.54L10.68 13.81L15.64 20.42H21.01L13.65 10.61H13.64ZM7.79 4.73999L18.68 19.26H16.21L5.32 4.73999H7.79Z"
        fill="currentColor"
      />
    </g>
    <defs>
      <clipPath id="clip0_3246_320774">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
`;
export const FacebookIcon = ({ html = runeHtml, klass = '' }: IconProps = {}) => html`
  <svg
    class="${klass}"
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    height="100%"
    viewBox="0 0 24 24"
    fill="none"
  >
    <g clip-path="url(#clip0_3246_320781)">
      <path
        d="M14.8998 5.86C13.7898 5.86 13.4698 6.35 13.4698 7.44V9.24H16.4298L16.1298 12.15H13.4598V20.99H9.89977V12.15H7.50977V9.24H9.89977V7.49C9.89977 4.55 11.0898 3 14.3998 3C15.1198 3 15.9598 3.05 16.4698 3.12V5.86"
        fill="currentColor"
      />
    </g>
    <defs>
      <clipPath id="clip0_3246_320781">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
`;
export const TiktokIcon = ({ html = runeHtml, klass = '' }: IconProps = {}) => html`
  <svg
    class="${klass}"
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    height="100%"
    viewBox="0 0 24 24"
    fill="none"
  >
    <g clip-path="url(#clip0_3246_320791)">
      <path
        d="M17.8601 6.85C17.7401 6.79 17.6201 6.72 17.5101 6.64C17.1801 6.42 16.8701 6.16 16.6001 5.87C15.9201 5.09 15.6701 4.31 15.5701 3.75C15.4901 3.29 15.5201 3 15.5301 3H12.4401V14.95C12.4401 15.11 12.4401 15.27 12.4401 15.43C12.4401 15.45 12.4401 15.47 12.4401 15.49C12.4401 15.49 12.4401 15.51 12.4401 15.52C12.3701 16.4 11.8801 17.18 11.1201 17.61C10.7301 17.83 10.2901 17.95 9.84011 17.95C8.40011 17.95 7.23011 16.78 7.23011 15.33C7.23011 13.88 8.40011 12.71 9.84011 12.71C10.1101 12.71 10.3801 12.75 10.6401 12.84V9.69C9.05011 9.48 7.45011 9.95 6.22011 10.98C5.69011 11.44 5.24011 12 4.90011 12.61C4.77011 12.83 4.28011 13.74 4.22011 15.21C4.18011 16.04 4.43011 16.91 4.55011 17.26C4.62011 17.48 4.92011 18.19 5.39011 18.8C5.77011 19.28 6.22011 19.71 6.73011 20.06C8.23011 21.08 9.89011 21.01 9.89011 21.01C10.1801 21 11.1401 21.01 12.2301 20.49C13.4401 19.92 14.1301 19.06 14.1301 19.06C14.5701 18.55 14.9201 17.97 15.1701 17.34C15.4501 16.6 15.5401 15.72 15.5401 15.37V9.03L16.0801 9.38C16.0801 9.38 16.8001 9.84 17.9201 10.14C18.7301 10.35 19.8101 10.4 19.8101 10.4V7.33C19.4301 7.37 18.6601 7.25 17.8701 6.86L17.8601 6.85Z"
        fill="currentColor"
      />
    </g>
    <defs>
      <clipPath id="clip0_3246_320791">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
`;
export const AfreecaTvIcon = ({ html = runeHtml, klass = '' }: IconProps = {}) => html`
  <svg
    class="${klass}"
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    height="100%"
    viewBox="0 0 18 22"
    fill="none"
  >
    <path
      d="M13.8406 0.849035C14.0161 1.20338 13.8393 1.61509 13.4655 1.74391L9.58184 3.50828C9.125 3.7147 8.81653 3.67521 8.37819 3.48165L5.86801 2.2934C5.51985 2.0989 5.47729 1.62306 5.69945 1.34532C5.93443 1.06536 6.35682 1.0217 6.62264 1.27252L8.55497 2.82636C8.7652 2.99952 8.98439 3.00808 9.15771 2.96923C9.22878 2.9533 9.28732 2.92217 9.38264 2.86857L12.9298 0.590747C13.2575 0.404765 13.6734 0.511365 13.8406 0.849035Z"
      fill="currentColor"
    />
    <mask
      id="mask0_7507_115156"
      style="mask-type:luminance"
      maskUnits="userSpaceOnUse"
      x="0"
      y="3"
      width="18"
      height="19"
    >
      <path
        d="M0.601897 18.4102C0.2037 16.4668 0 14.4539 0 12.3933C0 10.7941 0.102796 9.22044 0.365383 7.69239C0.431057 7.31013 0.561164 6.93173 0.561164 6.93173C0.836625 6.0567 1.4845 5.4501 2.30925 5.07595C2.30925 5.07595 2.7268 4.86745 3.66364 4.6203C6.20838 3.94902 8.9371 3.96881 8.9371 3.96881L9.06038 3.96876C10.8571 3.97376 12.6005 4.20418 14.2672 4.62579C14.2672 4.62579 15.235 4.88903 15.6846 5.08872C15.6846 5.08872 17.0828 5.63935 17.4522 6.92495C17.4659 6.9727 17.5825 7.36917 17.626 7.65616C17.8604 9.20139 18 10.7819 18 12.3942C18 14.4616 17.7913 16.4803 17.3942 18.4304C17.3934 18.4347 17.3926 18.4389 17.3917 18.4432C17.1724 19.5053 16.342 20.3435 15.2845 20.5752C15.2515 20.5819 15.2185 20.5883 15.1856 20.5948C13.1851 20.9919 11.1168 21.2007 8.99965 21.2007C6.89128 21.2007 4.83136 20.9936 2.83854 20.5997C2.79267 20.5907 2.74674 20.5817 2.70091 20.5725C2.05967 20.4283 1.50296 20.0609 1.11689 19.5561C1.11689 19.5561 0.760023 19.1819 0.601897 18.4102Z"
        fill="white"
      />
    </mask>
    <g mask="url(#mask0_7507_115156)">
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M15.4062 4.23757C18.0582 4.83853 18.5285 6.0012 18.8028 8.0392C19.0731 10.0468 19.0518 12.4584 19.0511 12.5298C19.0518 12.6011 19.0731 15.0127 18.8028 17.0203C18.5285 19.0583 18.0582 20.221 15.4062 20.8219C13.41 21.2743 11.8727 21.3233 10.5938 21.3642C10.3406 21.3722 10.0975 21.38 9.86299 21.3905C9.56076 21.4041 9.25906 21.4041 8.95683 21.3905C8.72232 21.38 8.47923 21.3722 8.22602 21.3642C6.94708 21.3233 5.4098 21.2743 3.41361 20.8219C0.761637 20.221 0.291332 19.0583 0.0170095 17.0203C-0.253256 15.0127 -0.231925 12.6011 -0.231233 12.5298C-0.231392 12.5134 -0.23264 12.3735 -0.231193 12.1434C0.248398 12.6944 0.865691 13.0984 1.54728 13.2162C3.48615 13.5514 5.23988 12.5547 5.82609 10.5976C6.41819 8.6209 5.84113 6.89028 3.76977 6.25384C2.44938 5.84816 1.16596 6.22383 0.20732 6.97385C0.547545 5.58117 1.26362 4.72478 3.41361 4.23757C5.80501 3.69571 7.5378 3.58935 8.95683 3.52576C9.25906 3.51225 9.56076 3.51225 9.86299 3.52576C11.282 3.58935 13.0148 3.69571 15.4062 4.23757ZM0.20732 6.97385C-0.252949 7.33396 -0.638349 7.78037 -0.917025 8.26804C-1.5799 9.42823 -1.16858 11.0666 -0.231193 12.1434C-0.22634 11.3719 -0.191178 9.58568 0.0170095 8.0392C0.0689353 7.65343 0.127883 7.29902 0.20732 6.97385ZM12.0923 9.73973C12.0731 9.03678 12.0659 8.34302 12.0807 7.64571C12.1008 6.6959 12.7914 6.32646 12.7914 6.32646C13.2509 6.05263 13.8602 6.00655 14.397 6.24683C15.2171 6.61399 16.2755 7.17536 16.2755 7.17536C16.8841 7.50417 17.3958 7.7832 18.0334 8.19995L18.042 8.20431C18.0753 8.22227 18.1073 8.24162 18.1387 8.26162C18.8187 8.69446 19.0584 9.58557 18.6693 10.3058C18.5429 10.54 18.3647 10.7284 18.1568 10.8648L18.152 10.8681C17.9388 11.0099 17.7352 11.1494 17.5337 11.2875L17.5336 11.2875C17.1645 11.5405 16.8023 11.7887 16.3999 12.0379C15.3957 12.6599 14.7657 12.9498 14.7657 12.9498C14.3177 13.2004 13.5538 13.3063 13.0263 13.0355C12.2288 12.626 12.1967 11.677 12.1967 11.677C12.1967 11.677 12.1239 10.9005 12.0923 9.73973ZM13.1619 15.3496C11.1486 17.2223 6.78356 17.224 4.82494 15.3512C4.6688 15.2 4.41561 15.2072 4.26719 15.3656C4.11446 15.5211 4.12228 15.7729 4.27768 15.9232C6.53997 18.0797 11.3819 18.0829 13.6966 15.9268C13.8601 15.7784 13.8678 15.5283 13.721 15.3688C13.5715 15.2089 13.3231 15.1991 13.1619 15.3496ZM11.5513 12.2252L11.5514 12.229L11.5514 12.2292C11.5521 12.2484 11.5528 12.2676 11.5528 12.287C11.5528 13.0464 10.9999 13.6763 10.2747 13.797C10.1936 13.8105 10.1103 13.8179 10.0254 13.8181H7.95681C7.82264 13.8177 7.69263 13.8001 7.5687 13.7674C6.91291 13.5943 6.42935 12.9972 6.42935 12.287C6.42935 12.2688 6.43 12.2507 6.43065 12.2326L6.43078 12.229C6.43142 12.2121 6.43241 12.1954 6.43355 12.1786L6.43989 12.1097L6.70931 9.16251L6.72381 9.00409C6.73128 8.95227 6.74129 8.90125 6.75385 8.85122C6.90237 8.25892 7.39573 7.80351 8.00823 7.71097C8.08028 7.70008 8.15402 7.69439 8.229 7.69389H9.75319C9.83995 7.69444 9.92487 7.70245 10.0076 7.71685C10.6051 7.82088 11.0836 8.27095 11.2288 8.85324C11.2443 8.91546 11.2558 8.97925 11.2635 9.04423L11.271 9.12742L11.5402 12.0935L11.5509 12.2112C11.5512 12.2159 11.5512 12.2206 11.5513 12.2252Z"
        fill="currentColor"
      />
      <path
        d="M14.91 10.949C15.623 10.949 16.2009 10.371 16.2009 9.65808C16.2009 8.94514 15.623 8.36719 14.91 8.36719C14.1971 8.36719 13.6191 8.94514 13.6191 9.65808C13.6191 10.371 14.1971 10.949 14.91 10.949Z"
        fill="currentColor"
      />
      <path
        d="M2.89344 10.949C3.60638 10.949 4.18433 10.371 4.18433 9.65808C4.18433 8.94514 3.60638 8.36719 2.89344 8.36719C2.18049 8.36719 1.60254 8.94514 1.60254 9.65808C1.60254 10.371 2.18049 10.949 2.89344 10.949Z"
        fill="currentColor"
      />
    </g>
  </svg>
`;
export const ChzzkIcon = ({ html = runeHtml, klass = '' }: IconProps = {}) => html`
  <svg
    class="${klass}"
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    height="100%"
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      d="M3 21C5.71243 17.3794 8.39166 13.8032 11.1166 10.166H4.64699C4.72498 10.0385 4.75855 9.97212 4.80271 9.91312C6.47756 7.67509 8.15185 5.43665 9.83432 3.20398C9.90646 3.10825 10.055 3.00902 10.1685 3.00838C12.2117 2.99687 14.2549 3.00025 16.2981 3.0012C16.327 3.00122 16.3559 3.01092 16.4345 3.02501C15.7921 3.88627 15.1642 4.72794 14.4986 5.62033H21C18.3105 9.21072 15.6655 12.7417 12.9732 16.3358H20.2567V21H3Z"
      fill="currentColor"
    />
  </svg>
`;
export const DefaultWebSiteIcon = ({ html = runeHtml, klass = '' }: IconProps = {}) => html`
  <svg
    class="${klass}"
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    height="100%"
    viewBox="0 0 24 24"
    fill="none"
  >
    <g clip-path="url(#clip0_7507_125355)">
      <path
        d="M20.6 10.09C19.83 9.65 18.85 9.27 17.72 8.98C17.87 10.11 17.95 11.29 17.95 12.5C17.95 13.71 17.87 14.89 17.72 16.02C18.85 15.73 19.83 15.35 20.6 14.91C21.46 14.42 22 13.5 22 12.52C22 12.52 22 12.52 22 12.51C22 12.5 22 12.51 22 12.5C22 11.51 21.46 10.6 20.6 10.11V10.09Z"
        fill="currentColor"
      />
      <path
        d="M6.6 7.1C6.81 6.13 7.08 5.23 7.4 4.42C7.55 4.04 7.71 3.7 7.87 3.38C5.66 4.38 3.88 6.16 2.88 8.37C3.19 8.21 3.54 8.05 3.92 7.9C4.73 7.58 5.63 7.31 6.6 7.1Z"
        fill="currentColor"
      />
      <path
        d="M8.1 8.6C7.91 9.81 7.8 11.12 7.8 12.5C7.8 13.88 7.91 15.19 8.1 16.4C9.31 16.59 10.62 16.7 12 16.7C13.38 16.7 14.69 16.59 15.9 16.4C16.09 15.19 16.2 13.88 16.2 12.5C16.2 11.12 16.09 9.81 15.9 8.6C14.69 8.41 13.38 8.3 12 8.3C10.62 8.3 9.31 8.41 8.1 8.6Z"
        fill="currentColor"
      />
      <path
        d="M17.4 17.9C17.19 18.87 16.92 19.77 16.6 20.58C16.45 20.96 16.29 21.3 16.13 21.62C18.34 20.62 20.12 18.84 21.12 16.63C20.81 16.79 20.46 16.95 20.08 17.1C19.27 17.42 18.37 17.69 17.4 17.9Z"
        fill="currentColor"
      />
      <path
        d="M6.6 17.9C5.63 17.69 4.73 17.42 3.92 17.1C3.54 16.95 3.2 16.79 2.88 16.63C3.88 18.84 5.66 20.62 7.87 21.62C7.71 21.31 7.55 20.96 7.4 20.58C7.08 19.77 6.81 18.87 6.6 17.9Z"
        fill="currentColor"
      />
      <path
        d="M8.48 18.22C8.77 19.35 9.15 20.33 9.59 21.1C10.08 21.96 11 22.5 11.98 22.5C11.98 22.5 11.98 22.5 11.99 22.5C12 22.5 11.99 22.5 12 22.5C12.99 22.5 13.9 21.96 14.39 21.1C14.83 20.33 15.21 19.35 15.5 18.22C14.37 18.37 13.19 18.45 11.98 18.45C10.77 18.45 9.59 18.37 8.46 18.22H8.48Z"
        fill="currentColor"
      />
      <path
        d="M6.28 8.98C5.15 9.27 4.17 9.65 3.4 10.09C2.54 10.58 2 11.5 2 12.48C2 12.48 2 12.48 2 12.49C2 12.5 2 12.49 2 12.5C2 13.49 2.54 14.4 3.4 14.89C4.17 15.33 5.15 15.71 6.28 16C6.13 14.87 6.05 13.69 6.05 12.48C6.05 11.27 6.13 10.09 6.28 8.96V8.98Z"
        fill="currentColor"
      />
      <path
        d="M15.52 6.78C15.23 5.65 14.85 4.67 14.41 3.9C13.92 3.04 13 2.5 12.02 2.5C12.02 2.5 12.02 2.5 12.01 2.5C12 2.5 12.01 2.5 12 2.5C11.01 2.5 10.1 3.04 9.61 3.9C9.17 4.67 8.79 5.65 8.5 6.78C9.63 6.63 10.81 6.55 12.02 6.55C13.23 6.55 14.41 6.63 15.54 6.78H15.52Z"
        fill="currentColor"
      />
      <path
        d="M17.4 7.1C18.37 7.31 19.27 7.58 20.08 7.9C20.46 8.05 20.8 8.21 21.12 8.37C20.12 6.16 18.34 4.38 16.13 3.38C16.29 3.69 16.45 4.04 16.6 4.42C16.92 5.23 17.19 6.13 17.4 7.1Z"
        fill="currentColor"
      />
    </g>
    <defs>
      <clipPath id="clip0_7507_125355">
        <rect width="24" height="24" fill="white" transform="translate(0 0.5)" />
      </clipPath>
    </defs>
  </svg>
`;
export const InputCheckIcon = ({ html = runeHtml, klass = '' }: IconProps = {}) => html`
  <svg
    class="${klass}"
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    height="100%"
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      d="M5.80964 10.7624C5.2968 10.2496 4.46533 10.2496 3.9525 10.7624C3.43966 11.2753 3.43966 12.1067 3.9525 12.6196L8.9818 17.6489C9.45186 18.1189 10.214 18.1189 10.684 17.6489L20.0472 8.28571C20.56 7.77288 20.56 6.94141 20.0472 6.42857C19.5344 5.91574 18.7029 5.91574 18.1901 6.42857L10.4519 14.1667C10.11 14.5086 9.55579 14.5086 9.21394 14.1667L5.80964 10.7624Z"
      fill="#141414"
    />
  </svg>
`;
export const FacebookCircleActiveIcon = ({ html = runeHtml, klass = '' }: IconProps = {}) => html`
  <svg
    class="${klass}"
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    height="100%"
    viewBox="0 0 52 52"
    fill="none"
  >
    <rect width="52" height="52" rx="26" fill="#0866FF" />
    <path
      d="M27.5856 39.5V27.184H31.7187L32.3368 22.3844H27.5856V19.3209C27.5856 17.9316 27.9726 16.9829 29.9639 16.9829H32.5061V12.6832C31.2751 12.5549 30.0379 12.4939 28.8003 12.5005C25.1401 12.5005 22.6194 14.731 22.6194 18.8452V22.3844H18.4863V27.184H22.6194V39.5H27.5856Z"
      fill="white"
    />
  </svg>
`;
export const FacebookCircleDisabledIcon = ({ html = runeHtml, klass = '' }: IconProps = {}) => html`
  <svg
    class="${klass}"
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    height="100%"
    viewBox="0 0 52 52"
    fill="none"
  >
    <rect width="52" height="52" rx="26" fill="#E7E7E7" />
    <path
      d="M27.5856 39.5V27.184H31.7187L32.3368 22.3844H27.5856V19.3209C27.5856 17.9316 27.9726 16.9829 29.9639 16.9829H32.5061V12.6832C31.2751 12.5549 30.0379 12.4939 28.8003 12.5005C25.1401 12.5005 22.6194 14.731 22.6194 18.8452V22.3844H18.4863V27.184H22.6194V39.5H27.5856Z"
      fill="white"
    />
  </svg>
`;
export const KakaoCircleActiveIcon = ({ html = runeHtml, klass = '' }: IconProps = {}) => html`
  <svg
    class="${klass}"
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    height="100%"
    viewBox="0 0 52 52"
    fill="none"
  >
    <rect width="52" height="52" rx="26" fill="#FFDC00" />
    <path
      d="M26.0002 13C34.378 13 41.1683 18.2924 41.1683 24.8228C41.1683 31.3517 34.378 36.6441 26.0016 36.6441C25.1676 36.6445 24.3343 36.5914 23.5071 36.4852L17.14 40.6496C16.4163 41.0323 16.1606 40.9904 16.4582 40.053L17.7466 34.7403C13.5866 32.6314 10.835 28.977 10.835 24.8228C10.835 18.2939 17.6238 13 26.0016 13M34.5354 24.6422L36.6587 22.5853C36.7813 22.4581 36.8496 22.2883 36.8494 22.1116C36.8492 21.935 36.7804 21.7653 36.6576 21.6384C36.5348 21.5114 36.3675 21.4371 36.1909 21.4311C36.0144 21.425 35.8424 21.4877 35.7112 21.606L32.9263 24.3013V22.074C32.9263 21.8932 32.8545 21.7198 32.7266 21.5919C32.5987 21.4641 32.4253 21.3922 32.2445 21.3922C32.0637 21.3922 31.8903 21.4641 31.7624 21.5919C31.6346 21.7198 31.5627 21.8932 31.5627 22.074V25.7674C31.5372 25.8728 31.5372 25.9827 31.5627 26.0881V28.1667C31.5627 28.3475 31.6346 28.5209 31.7624 28.6488C31.8903 28.7766 32.0637 28.8484 32.2445 28.8484C32.4253 28.8484 32.5987 28.7766 32.7266 28.6488C32.8545 28.5209 32.9263 28.3475 32.9263 28.1667V26.1979L33.5431 25.6013L35.6057 28.5379C35.6572 28.6112 35.7227 28.6737 35.7983 28.7217C35.8739 28.7697 35.9583 28.8024 36.0466 28.8178C36.1348 28.8332 36.2252 28.8311 36.3127 28.8116C36.4001 28.7921 36.4829 28.7555 36.5562 28.704C36.6295 28.6525 36.6919 28.5871 36.74 28.5114C36.788 28.4358 36.8207 28.3514 36.8361 28.2632C36.8515 28.1749 36.8494 28.0845 36.8299 27.9971C36.8104 27.9096 36.7738 27.8269 36.7223 27.7536L34.5354 24.6422ZM30.2627 27.4213H28.1538V22.0957C28.1458 21.9205 28.0705 21.7551 27.9437 21.634C27.8168 21.5129 27.6482 21.4453 27.4728 21.4453C27.2974 21.4453 27.1288 21.5129 27.0019 21.634C26.8751 21.7551 26.7998 21.9205 26.7917 22.0957V28.1031C26.7917 28.4787 27.0951 28.7849 27.4721 28.7849H30.2627C30.4436 28.7849 30.617 28.7131 30.7448 28.5852C30.8727 28.4573 30.9445 28.2839 30.9445 28.1031C30.9445 27.9223 30.8727 27.7489 30.7448 27.621C30.617 27.4932 30.4436 27.4213 30.2627 27.4213ZM21.8026 25.8454L22.808 23.3783L23.7295 25.844L21.8026 25.8454ZM25.447 26.5489L25.4498 26.5258C25.4495 26.354 25.3839 26.1888 25.2664 26.0636L23.7555 22.0191C23.6922 21.8264 23.5715 21.6576 23.4097 21.5352C23.2479 21.4129 23.0526 21.3428 22.8498 21.3344C22.6457 21.3335 22.446 21.3948 22.2775 21.5102C22.1091 21.6255 21.9797 21.7894 21.9066 21.9801L19.506 27.8662C19.4376 28.0336 19.4385 28.2214 19.5085 28.3881C19.5786 28.5548 19.7119 28.6869 19.8793 28.7553C20.0468 28.8237 20.2345 28.8227 20.4012 28.7527C20.5679 28.6827 20.7 28.5493 20.7684 28.3819L21.248 27.2076H24.238L24.6684 28.3631C24.6978 28.4495 24.7442 28.5291 24.8049 28.5972C24.8655 28.6653 24.9393 28.7206 25.0217 28.7597C25.1041 28.7988 25.1936 28.8209 25.2847 28.8248C25.3759 28.8287 25.4669 28.8143 25.5523 28.7824C25.6378 28.7505 25.716 28.7018 25.7823 28.6391C25.8486 28.5764 25.9016 28.5011 25.9383 28.4175C25.9749 28.334 25.9944 28.2439 25.9956 28.1527C25.9968 28.0615 25.9797 27.9709 25.9453 27.8864L25.447 26.5489ZM20.6471 22.1029C20.6471 21.9223 20.5754 21.7491 20.4479 21.6213C20.3203 21.4935 20.1473 21.4215 19.9667 21.4211H15.2795C15.0987 21.4211 14.9253 21.4929 14.7974 21.6208C14.6696 21.7487 14.5977 21.9221 14.5977 22.1029C14.5977 22.2837 14.6696 22.4571 14.7974 22.585C14.9253 22.7128 15.0987 22.7847 15.2795 22.7847H16.9551V28.1811C16.9551 28.3619 17.0269 28.5353 17.1548 28.6632C17.2826 28.7911 17.456 28.8629 17.6368 28.8629C17.8177 28.8629 17.9911 28.7911 18.1189 28.6632C18.2468 28.5353 18.3186 28.3619 18.3186 28.1811V22.7847H19.9653C20.1461 22.7847 20.3195 22.7128 20.4474 22.585C20.5752 22.4571 20.6471 22.2837 20.6471 22.1029Z"
      fill="#141414"
    />
  </svg>
`;
export const KakaoCircleDisabledIcon = ({ html = runeHtml, klass = '' }: IconProps = {}) => html`
  <svg
    class="${klass}"
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    height="100%"
    viewBox="0 0 52 52"
    fill="none"
  >
    <rect width="52" height="52" rx="26" fill="#E7E7E7" />
    <path
      d="M26.0002 13C34.378 13 41.1683 18.2924 41.1683 24.8228C41.1683 31.3517 34.378 36.6441 26.0016 36.6441C25.1676 36.6445 24.3343 36.5914 23.5071 36.4852L17.14 40.6496C16.4163 41.0323 16.1606 40.9904 16.4582 40.053L17.7466 34.7403C13.5866 32.6314 10.835 28.977 10.835 24.8228C10.835 18.2939 17.6238 13 26.0016 13M34.5354 24.6422L36.6587 22.5853C36.7813 22.4581 36.8496 22.2883 36.8494 22.1116C36.8492 21.935 36.7804 21.7653 36.6576 21.6384C36.5348 21.5114 36.3675 21.4371 36.1909 21.4311C36.0144 21.425 35.8424 21.4877 35.7112 21.606L32.9263 24.3013V22.074C32.9263 21.8932 32.8545 21.7198 32.7266 21.5919C32.5987 21.4641 32.4253 21.3922 32.2445 21.3922C32.0637 21.3922 31.8903 21.4641 31.7624 21.5919C31.6346 21.7198 31.5627 21.8932 31.5627 22.074V25.7674C31.5372 25.8728 31.5372 25.9827 31.5627 26.0881V28.1667C31.5627 28.3475 31.6346 28.5209 31.7624 28.6488C31.8903 28.7766 32.0637 28.8484 32.2445 28.8484C32.4253 28.8484 32.5987 28.7766 32.7266 28.6488C32.8545 28.5209 32.9263 28.3475 32.9263 28.1667V26.1979L33.5431 25.6013L35.6057 28.5379C35.6572 28.6112 35.7227 28.6737 35.7983 28.7217C35.8739 28.7697 35.9583 28.8024 36.0466 28.8178C36.1348 28.8332 36.2252 28.8311 36.3127 28.8116C36.4001 28.7921 36.4829 28.7555 36.5562 28.704C36.6295 28.6525 36.6919 28.5871 36.74 28.5114C36.788 28.4358 36.8207 28.3514 36.8361 28.2632C36.8515 28.1749 36.8494 28.0845 36.8299 27.9971C36.8104 27.9096 36.7738 27.8269 36.7223 27.7536L34.5354 24.6422ZM30.2627 27.4213H28.1538V22.0957C28.1458 21.9205 28.0705 21.7551 27.9437 21.634C27.8168 21.5129 27.6482 21.4453 27.4728 21.4453C27.2974 21.4453 27.1288 21.5129 27.0019 21.634C26.8751 21.7551 26.7998 21.9205 26.7917 22.0957V28.1031C26.7917 28.4787 27.0951 28.7849 27.4721 28.7849H30.2627C30.4436 28.7849 30.617 28.7131 30.7448 28.5852C30.8727 28.4573 30.9445 28.2839 30.9445 28.1031C30.9445 27.9223 30.8727 27.7489 30.7448 27.621C30.617 27.4932 30.4436 27.4213 30.2627 27.4213ZM21.8026 25.8454L22.808 23.3783L23.7295 25.844L21.8026 25.8454ZM25.447 26.5489L25.4498 26.5258C25.4495 26.354 25.3839 26.1888 25.2664 26.0636L23.7555 22.0191C23.6922 21.8264 23.5715 21.6576 23.4097 21.5352C23.2479 21.4129 23.0526 21.3428 22.8498 21.3344C22.6457 21.3335 22.446 21.3948 22.2775 21.5102C22.1091 21.6255 21.9797 21.7894 21.9066 21.9801L19.506 27.8662C19.4376 28.0336 19.4385 28.2214 19.5085 28.3881C19.5786 28.5548 19.7119 28.6869 19.8793 28.7553C20.0468 28.8237 20.2345 28.8227 20.4012 28.7527C20.5679 28.6827 20.7 28.5493 20.7684 28.3819L21.248 27.2076H24.238L24.6684 28.3631C24.6978 28.4495 24.7442 28.5291 24.8049 28.5972C24.8655 28.6653 24.9393 28.7206 25.0217 28.7597C25.1041 28.7988 25.1936 28.8209 25.2847 28.8248C25.3759 28.8287 25.4669 28.8143 25.5523 28.7824C25.6378 28.7505 25.716 28.7018 25.7823 28.6391C25.8486 28.5764 25.9016 28.5011 25.9383 28.4175C25.9749 28.334 25.9944 28.2439 25.9956 28.1527C25.9968 28.0615 25.9797 27.9709 25.9453 27.8864L25.447 26.5489ZM20.6471 22.1029C20.6471 21.9223 20.5754 21.7491 20.4479 21.6213C20.3203 21.4935 20.1473 21.4215 19.9667 21.4211H15.2795C15.0987 21.4211 14.9253 21.4929 14.7974 21.6208C14.6696 21.7487 14.5977 21.9221 14.5977 22.1029C14.5977 22.2837 14.6696 22.4571 14.7974 22.585C14.9253 22.7128 15.0987 22.7847 15.2795 22.7847H16.9551V28.1811C16.9551 28.3619 17.0269 28.5353 17.1548 28.6632C17.2826 28.7911 17.456 28.8629 17.6368 28.8629C17.8177 28.8629 17.9911 28.7911 18.1189 28.6632C18.2468 28.5353 18.3186 28.3619 18.3186 28.1811V22.7847H19.9653C20.1461 22.7847 20.3195 22.7128 20.4474 22.585C20.5752 22.4571 20.6471 22.2837 20.6471 22.1029Z"
      fill="white"
    />
  </svg>
`;
export const NaverCircleActiveIcon = ({ html = runeHtml, klass = '' }: IconProps = {}) => html`
  <svg
    class="${klass}"
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    height="100%"
    viewBox="0 0 52 52"
    fill="none"
  >
    <rect width="52" height="52" rx="26" fill="#03C75A" />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M30.4 14V26.8452L21.6486 14H14V38H21.6V25.1548L30.3514 38H38V33.4314V14H30.4Z"
      fill="white"
    />
  </svg>
`;
export const NaverCircleDisabledIcon = ({ html = runeHtml, klass = '' }: IconProps = {}) => html`
  <svg
    class="${klass}"
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    height="100%"
    viewBox="0 0 52 52"
    fill="none"
  >
    <rect width="52" height="52" rx="26" fill="#E7E7E7" />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M30.4 14V26.8452L21.6486 14H14V38H21.6V25.1548L30.3514 38H38V33.4314V14H30.4Z"
      fill="white"
    />
  </svg>
`;
export const GoogleCircleActiveIcon = ({ html = runeHtml, klass = '' }: IconProps = {}) => html`
  <svg
    class="${klass}"
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    height="100%"
    viewBox="0 0 52 52"
    fill="none"
  >
    <rect width="52" height="52" rx="26" fill="#F5F5F5" />
    <path
      d="M39.5969 23.2842H38.48V23.2267H26V28.7733H33.8367C32.6934 32.0022 29.6212 34.32 26 34.32C21.4052 34.32 17.68 30.5947 17.68 26C17.68 21.4053 21.4052 17.68 26 17.68C28.1209 17.68 30.0504 18.4801 31.5196 19.787L35.4418 15.8649C32.9652 13.5567 29.6524 12.1333 26 12.1333C18.3421 12.1333 12.1333 18.3421 12.1333 26C12.1333 33.6579 18.3421 39.8667 26 39.8667C33.6578 39.8667 39.8666 33.6579 39.8666 26C39.8666 25.0702 39.771 24.1627 39.5969 23.2842Z"
      fill="#FFC107"
    />
    <path
      d="M13.7321 19.5458L18.288 22.8869C19.5208 19.8349 22.5063 17.68 26 17.68C28.1209 17.68 30.0504 18.4801 31.5196 19.787L35.4418 15.8649C32.9652 13.5567 29.6524 12.1333 26 12.1333C20.6738 12.1333 16.0548 15.1403 13.7321 19.5458Z"
      fill="#FF3D00"
    />
    <path
      d="M26 39.8667C29.5817 39.8667 32.8362 38.4959 35.2969 36.2669L31.0051 32.6352C29.5662 33.7295 27.8078 34.3214 26 34.32C22.3932 34.32 19.3308 32.0202 18.1771 28.8108L13.6552 32.2948C15.9501 36.7855 20.6107 39.8667 26 39.8667Z"
      fill="#4CAF50"
    />
    <path
      d="M39.5969 23.2842H38.48V23.2267H26V28.7733H33.8367C33.2898 30.31 32.3047 31.6529 31.0031 32.6359L31.0051 32.6352L35.2969 36.2669C34.9932 36.5428 39.8666 32.9333 39.8666 26C39.8666 25.0702 39.771 24.1627 39.5969 23.2842Z"
      fill="#1976D2"
    />
  </svg>
`;
export const GoogleCircleDisabledIcon = ({ html = runeHtml, klass = '' }: IconProps = {}) => html`
  <svg
    class="${klass}"
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    height="100%"
    viewBox="0 0 52 52"
    fill="none"
  >
    <rect width="52" height="52" rx="26" fill="#E7E7E7" />
    <path
      d="M39.5969 23.2842H38.48V23.2267H26V28.7733H33.8367C32.6934 32.0022 29.6212 34.32 26 34.32C21.4052 34.32 17.68 30.5947 17.68 26C17.68 21.4053 21.4052 17.68 26 17.68C28.1209 17.68 30.0504 18.4801 31.5196 19.787L35.4418 15.8649C32.9652 13.5567 29.6524 12.1333 26 12.1333C18.3421 12.1333 12.1333 18.3421 12.1333 26C12.1333 33.6579 18.3421 39.8667 26 39.8667C33.6578 39.8667 39.8666 33.6579 39.8666 26C39.8666 25.0702 39.771 24.1627 39.5969 23.2842Z"
      fill="white"
    />
    <path
      d="M13.7321 19.5458L18.288 22.8869C19.5208 19.8349 22.5063 17.68 26 17.68C28.1209 17.68 30.0504 18.4801 31.5196 19.787L35.4418 15.8649C32.9652 13.5567 29.6524 12.1333 26 12.1333C20.6738 12.1333 16.0548 15.1403 13.7321 19.5458Z"
      fill="white"
    />
    <path
      d="M26 39.8667C29.5817 39.8667 32.8362 38.4959 35.2969 36.2669L31.0051 32.6352C29.5662 33.7295 27.8078 34.3214 26 34.32C22.3932 34.32 19.3308 32.0202 18.1771 28.8108L13.6552 32.2948C15.9501 36.7855 20.6107 39.8667 26 39.8667Z"
      fill="white"
    />
    <path
      d="M39.5969 23.2842H38.48V23.2267H26V28.7733H33.8367C33.2898 30.31 32.3047 31.6529 31.0031 32.6359L31.0051 32.6352L35.2969 36.2669C34.9932 36.5428 39.8666 32.9333 39.8666 26C39.8666 25.0702 39.771 24.1627 39.5969 23.2842Z"
      fill="white"
    />
  </svg>
`;
export const AppleCircleActiveIcon = ({ html = runeHtml, klass = '' }: IconProps = {}) => html`
  <svg
    class="${klass}"
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    height="100%"
    viewBox="0 0 52 52"
    fill="none"
  >
    <rect width="52" height="52" rx="26" fill="#F5F5F5" />
    <path
      d="M36.2206 20.5452C36.0582 20.6712 33.191 22.2868 33.191 25.8792C33.191 30.0344 36.8394 31.5044 36.9486 31.5408C36.9318 31.6304 36.369 33.554 35.025 35.514C33.8266 37.2388 32.575 38.9608 30.671 38.9608C28.767 38.9608 28.277 37.8548 26.079 37.8548C23.937 37.8548 23.1754 38.9972 21.4338 38.9972C19.6922 38.9972 18.477 37.4012 17.0798 35.4412C15.4614 33.1396 14.1538 29.564 14.1538 26.1704C14.1538 20.7272 17.693 17.8404 21.1762 17.8404C23.027 17.8404 24.5698 19.0556 25.7318 19.0556C26.8378 19.0556 28.5626 17.7676 30.6682 17.7676C31.4662 17.7676 34.3334 17.8404 36.2206 20.5452ZM29.6686 15.4632C30.5394 14.43 31.1554 12.9964 31.1554 11.5628C31.1554 11.364 31.1386 11.1624 31.1022 11C29.6854 11.0532 27.9998 11.9436 26.9834 13.1224C26.1854 14.0296 25.4406 15.4632 25.4406 16.9164C25.4406 17.1348 25.477 17.3532 25.4938 17.4232C25.5834 17.44 25.729 17.4596 25.8746 17.4596C27.1458 17.4596 28.7446 16.6084 29.6686 15.4632Z"
      fill="#141414"
    />
  </svg>
`;
export const AppleCircleDisabledIcon = ({ html = runeHtml, klass = '' }: IconProps = {}) => html`
  <svg
    class="${klass}"
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    height="100%"
    viewBox="0 0 52 52"
    fill="none"
  >
    <rect width="52" height="52" rx="26" fill="#E7E7E7" />
    <path
      d="M36.2206 20.5452C36.0582 20.6712 33.191 22.2868 33.191 25.8792C33.191 30.0344 36.8394 31.5044 36.9486 31.5408C36.9318 31.6304 36.369 33.554 35.025 35.514C33.8266 37.2388 32.575 38.9608 30.671 38.9608C28.767 38.9608 28.277 37.8548 26.079 37.8548C23.937 37.8548 23.1754 38.9972 21.4338 38.9972C19.6922 38.9972 18.477 37.4012 17.0798 35.4412C15.4614 33.1396 14.1538 29.564 14.1538 26.1704C14.1538 20.7272 17.693 17.8404 21.1762 17.8404C23.027 17.8404 24.5698 19.0556 25.7318 19.0556C26.8378 19.0556 28.5626 17.7676 30.6682 17.7676C31.4662 17.7676 34.3334 17.8404 36.2206 20.5452ZM29.6686 15.4632C30.5394 14.43 31.1554 12.9964 31.1554 11.5628C31.1554 11.364 31.1386 11.1624 31.1022 11C29.6854 11.0532 27.9998 11.9436 26.9834 13.1224C26.1854 14.0296 25.4406 15.4632 25.4406 16.9164C25.4406 17.1348 25.477 17.3532 25.4938 17.4232C25.5834 17.44 25.729 17.4596 25.8746 17.4596C27.1458 17.4596 28.7446 16.6084 29.6686 15.4632Z"
      fill="white"
    />
  </svg>
`;
export const SubwayIcon = ({ html = runeHtml, klass = '' }: IconProps = {}) => html`
  <svg
    class="${klass}"
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    height="100%"
    viewBox="0 0 24 24"
    fill="none"
  >
    <g clip-path="url(#clip0_4100_201255)">
      <path
        d="M17.47 19.89L19.36 21.47V22H4.63002V21.47L6.52002 19.89H4.63002C4.07002 19.89 3.54002 19.67 3.14002 19.27C2.75002 18.88 2.52002 18.34 2.52002 17.78V6.21C2.52002 5.09 2.96002 4.02 3.75002 3.23C4.54002 2.44 5.61002 2 6.73002 2H17.26C18.38 2 19.45 2.44 20.24 3.23C21.03 4.02 21.47 5.09 21.47 6.21V17.79C21.47 18.35 21.25 18.88 20.85 19.28C20.46 19.67 19.92 19.9 19.36 19.9H17.47V19.89ZM10.95 11.47V4.1H6.74002C6.18002 4.1 5.65002 4.32 5.25002 4.72C4.85002 5.12 4.63002 5.65 4.63002 6.21V11.47H10.95ZM13.05 11.47H19.37V6.21C19.37 5.65 19.15 5.12 18.75 4.72C18.36 4.33 17.82 4.1 17.26 4.1H13.05V11.47ZM7.26002 17.79C7.68002 17.79 8.08002 17.62 8.38002 17.33C8.68002 17.03 8.84002 16.63 8.84002 16.21C8.84002 15.79 8.67002 15.39 8.38002 15.09C8.08002 14.79 7.68002 14.63 7.26002 14.63C6.84002 14.63 6.44002 14.8 6.14002 15.09C5.84002 15.39 5.68002 15.79 5.68002 16.21C5.68002 16.63 5.85002 17.03 6.14002 17.33C6.44002 17.63 6.84002 17.79 7.26002 17.79ZM16.74 17.79C17.16 17.79 17.56 17.62 17.86 17.33C18.16 17.03 18.32 16.63 18.32 16.21C18.32 15.79 18.15 15.39 17.86 15.09C17.56 14.79 17.16 14.63 16.74 14.63C16.32 14.63 15.92 14.8 15.62 15.09C15.32 15.39 15.16 15.79 15.16 16.21C15.16 16.63 15.33 17.03 15.62 17.33C15.92 17.63 16.32 17.79 16.74 17.79Z"
        fill="currentColor"
      />
    </g>
    <defs>
      <clipPath id="clip0_4100_201255">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
`;
export const BusIcon = ({ html = runeHtml, klass = '' }: IconProps = {}) => html`
  <svg
    class="${klass}"
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    height="100%"
    viewBox="0 0 24 24"
    fill="none"
  >
    <g clip-path="url(#clip0_4100_201254)">
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M5.54016 4.44C5.54016 4.28 5.67016 4.15 5.83016 4.15H18.1602C18.3202 4.15 18.4502 4.28 18.4502 4.44V10.54H5.54016V4.44ZM20.6102 17.46C20.6102 18.61 19.8202 19.57 18.7502 19.84V20.58C18.7502 20.96 18.6002 21.32 18.3302 21.59C18.0602 21.86 17.7002 22.01 17.3202 22.01C16.9402 22.01 16.5802 21.86 16.3102 21.59C16.0402 21.32 15.8902 20.96 15.8902 20.58V19.91H8.13016V20.58C8.13016 20.96 7.98016 21.32 7.71016 21.59C7.44016 21.86 7.08016 22.01 6.70016 22.01C6.32016 22.01 5.96016 21.86 5.69016 21.59C5.42016 21.32 5.27016 20.96 5.27016 20.58V19.84C4.74016 19.71 4.27016 19.4 3.93016 18.97C3.59016 18.54 3.41016 18.01 3.41016 17.46V4.44C3.41016 3.09 4.51016 2 5.85016 2H18.1802C19.5302 2 20.6202 3.09 20.6202 4.44V17.45L20.6102 17.46ZM7.70016 16.28C8.08016 16.28 8.44016 16.13 8.71016 15.86C8.98016 15.59 9.13016 15.23 9.13016 14.85C9.13016 14.47 8.98016 14.11 8.71016 13.84C8.44016 13.57 8.08016 13.42 7.70016 13.42C7.32016 13.42 6.96016 13.57 6.69016 13.84C6.42016 14.11 6.27016 14.47 6.27016 14.85C6.27016 15.23 6.42016 15.59 6.69016 15.86C6.96016 16.13 7.32016 16.28 7.70016 16.28ZM16.3002 16.28C16.6802 16.28 17.0402 16.13 17.3102 15.86C17.5802 15.59 17.7302 15.23 17.7302 14.85C17.7302 14.47 17.5802 14.11 17.3102 13.84C17.0402 13.57 16.6802 13.42 16.3002 13.42C15.9202 13.42 15.5602 13.57 15.2902 13.84C15.0202 14.11 14.8702 14.47 14.8702 14.85C14.8702 15.23 15.0202 15.59 15.2902 15.86C15.5602 16.13 15.9202 16.28 16.3002 16.28Z"
        fill="currentColor"
      />
    </g>
    <defs>
      <clipPath id="clip0_4100_201254">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
`;
export const PagePrevIcon = ({ html = runeHtml, klass = '' }: IconProps = {}) => html`
  <svg
    class="${klass}"
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    height="100%"
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      d="M14.5 16.1029C14.5 15.9901 14.459 15.8723 14.3667 15.7851L10.5841 12.0024L14.3667 8.21977C14.541 8.0455 14.541 7.75846 14.3667 7.58419C14.1925 7.40992 13.9054 7.40992 13.7312 7.58419L9.6307 11.6847C9.45643 11.8589 9.45643 12.146 9.6307 12.3202L13.7312 16.4207C13.9054 16.595 14.1925 16.595 14.3667 16.4207C14.4539 16.3336 14.5 16.2157 14.5 16.1029Z"
      fill="currentColor"
    />
  </svg>
`;
export const PageFirstIcon = ({ html = runeHtml, klass = '' }: IconProps = {}) => html`
  <svg
    class="${klass}"
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    height="100%"
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      d="M17 16.1028C17 15.99 16.959 15.8721 16.8667 15.785L13.0841 12.0023L16.8667 8.21964C17.041 8.04537 17.041 7.75834 16.8667 7.58407C16.6925 7.4098 16.4054 7.4098 16.2312 7.58407L12.1307 11.6845C11.9564 11.8588 11.9564 12.1458 12.1307 12.3201L16.2312 16.4206C16.4054 16.5948 16.6925 16.5948 16.8667 16.4206C16.9539 16.3334 17 16.2155 17 16.1028Z"
      fill="currentColor"
    />
    <path
      d="M12 16.1028C12 15.99 11.959 15.8721 11.8667 15.785L8.08406 12.0023L11.8667 8.21964C12.041 8.04537 12.041 7.75834 11.8667 7.58407C11.6925 7.4098 11.4054 7.4098 11.2312 7.58407L7.1307 11.6845C6.95643 11.8588 6.95643 12.1458 7.1307 12.3201L11.2312 16.4206C11.4054 16.5948 11.6925 16.5948 11.8667 16.4206C11.9539 16.3334 12 16.2155 12 16.1028Z"
      fill="currentColor"
    />
  </svg>
`;
export const PageNextIcon = ({ html = runeHtml, klass = '' }: IconProps = {}) => html`
  <svg
    class="${klass}"
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    height="100%"
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      d="M9.5 16.1029C9.5 15.9901 9.541 15.8723 9.63326 15.7851L13.4159 12.0024L9.63326 8.21977C9.45899 8.0455 9.45899 7.75846 9.63326 7.58419C9.80753 7.40992 10.0946 7.40992 10.2688 7.58419L14.3693 11.6847C14.5436 11.8589 14.5436 12.146 14.3693 12.3202L10.2688 16.4207C10.0946 16.595 9.80753 16.595 9.63326 16.4207C9.54613 16.3336 9.5 16.2157 9.5 16.1029Z"
      fill="currentColor"
    />
  </svg>
`;
export const PageLastIcon = ({ html = runeHtml, klass = '' }: IconProps = {}) => html`
  <svg
    class="${klass}"
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    height="100%"
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      d="M7 16.1029C7 15.9901 7.041 15.8723 7.13326 15.7851L10.9159 12.0024L7.13326 8.21977C6.95899 8.0455 6.95899 7.75846 7.13326 7.58419C7.30753 7.40992 7.59457 7.40992 7.76884 7.58419L11.8693 11.6847C12.0436 11.8589 12.0436 12.146 11.8693 12.3202L7.76884 16.4207C7.59457 16.595 7.30753 16.595 7.13326 16.4207C7.04613 16.3336 7 16.2157 7 16.1029Z"
      fill="currentColor"
    />
    <path
      d="M12 16.1029C12 15.9901 12.041 15.8723 12.1333 15.7851L15.9159 12.0024L12.1333 8.21977C11.959 8.0455 11.959 7.75846 12.1333 7.58419C12.3075 7.40992 12.5946 7.40992 12.7688 7.58419L16.8693 11.6847C17.0436 11.8589 17.0436 12.146 16.8693 12.3202L12.7688 16.4207C12.5946 16.595 12.3075 16.595 12.1333 16.4207C12.0461 16.3336 12 16.2157 12 16.1029Z"
      fill="currentColor"
    />
  </svg>
`;
export const DropdownDownIcon = ({ html = runeHtml, klass = '' }: IconProps = {}) => html`
  <svg
    class="${klass}"
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    height="100%"
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      d="M11.15 17.56C11.56 18.14 12.45 18.14 12.86 17.56L19.83 7.53C20.28 6.88 19.8 6 18.98 6H5.03003C4.21003 6 3.72003 6.88 4.18003 7.53L11.15 17.56Z"
      fill="currentColor"
    />
  </svg>
`;
export const DropdownUpIcon = ({ html = runeHtml, klass = '' }: IconProps = {}) => html`
  <svg
    class="${klass}"
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    height="100%"
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      d="M12.8558 6.435C12.4458 5.855 11.5558 5.855 11.1458 6.435L4.17583 16.465C3.72583 17.115 4.20583 17.995 5.02583 17.995L18.9758 17.995C19.7958 17.995 20.2858 17.115 19.8258 16.465L12.8558 6.435Z"
      fill="currentColor"
    />
  </svg>
`;
export const RefundIcon = ({ html = runeHtml, klass = '' }: IconProps = {}) => html`
  <svg
    class="${klass}"
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    height="100%"
    viewBox="0 0 24 24"
    fill="none"
  >
    <circle cx="12" cy="12" r="7" stroke="#A2A2A2" stroke-width="2" />
    <rect
      x="5.63623"
      y="7.05023"
      width="2"
      height="16"
      transform="rotate(-45 5.63623 7.05023)"
      fill="currentColor"
    />
  </svg>
`;
export const GuaranteeIcon = ({ html = runeHtml, klass = '' }: IconProps = {}) => html`
  <svg
    class="${klass}"
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    height="100%"
    viewBox="0 0 24 24"
    fill="none"
  >
    <g clip-path="url(#clip0_4261_212618)">
      <path
        d="M5.61396 5.63604L9.2226 5.34807L11.9779 3L14.7332 5.34807L18.3419 5.63604L18.6299 9.24468L20.9779 12L18.6299 14.7553L18.3419 18.364L14.7332 18.6519L11.9779 21L9.2226 18.6519L5.61396 18.364L5.32599 14.7553L2.97792 12L5.32599 9.24468L5.61396 5.63604Z"
        fill="currentColor"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M8.56066 10.9393L7.5 12L9.82812 14.3281L9.97487 14.4749L10.8888 15.3888L16.5456 9.73193L15.485 8.67127L10.8888 13.2675L8.56066 10.9393Z"
        fill="white"
      />
    </g>
    <defs>
      <clipPath id="clip0_4261_212618">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
`;
export const BoxIcon = ({ html = runeHtml, klass = '' }: IconProps = {}) => html`
  <svg
    class="${klass}"
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    height="100%"
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      d="M0.71 4.33401L9.2 0.134006C9.54 -0.0359943 9.94 -0.0459945 10.29 0.114005L13.29 1.48401L3.53 6.31401V11.114C3.53 11.234 3.6 11.344 3.71 11.394L5.66 12.354C5.87 12.454 6.12 12.304 6.12 12.074V7.45401L15.84 2.64401L18.65 3.93401C19.1 4.14401 19.39 4.59401 19.39 5.08401V14.534C19.39 15.014 19.12 15.454 18.68 15.674L10.21 19.864C9.86 20.044 9.44 20.044 9.08 19.864L0.71 15.734C0.28 15.524 0 15.074 0 14.594V5.47401C0 4.99401 0.27 4.55401 0.71 4.33401Z"
      fill="currentColor"
    />
  </svg>
`;
export const DotIcon = ({ html = runeHtml, klass = '' }: IconProps = {}) =>
  html` <svg
    class="${klass}"
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    height="100%"
    viewBox="0 0 4 4"
    fill="none"
  >
    <circle cx="2" cy="2" r="2" fill="#1C75FF" />
  </svg>`;
export const RankIcon = ({ html = runeHtml, klass = '' }: IconProps = {}) =>
  html` <svg
    class="${klass}"
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    height="100%"
    viewBox="0 0 32 21"
    fill="none"
  >
    <rect x="12" y="9.75" width="8" height="1.5" fill="#A2A2A2" />
  </svg>`;
export const SameRankIcon = ({ html = runeHtml, klass = '' }: IconProps = {}) => html`
  <svg
    class="${klass}"
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    height="100%"
    viewBox="0 0 12 3"
    fill="none"
  >
    <rect y="0.799805" width="12" height="2" fill="currentColor" />
  </svg>
`;
export const ShowIcon = ({ html = runeHtml, klass = '' }: IconProps = {}) => html`
  <svg
    class="${klass}"
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    height="100%"
    viewBox="0 0 20 20"
    fill="none"
  >
    <path
      d="M19.8365 9.68333C19.8068 9.60416 19.1042 7.74374 17.5604 5.88333C15.4922 3.39947 12.8797 2.08333 9.99999 2.08333C7.1203 2.08333 4.5078 3.39947 2.43957 5.88333C0.885927 7.74374 0.183323 9.60416 0.163531 9.68333C0.123948 9.78229 0.104156 9.89114 0.104156 9.99999C0.104156 10.1088 0.123948 10.2177 0.163531 10.3167C0.193219 10.3958 0.895823 12.2562 2.43957 14.1167C4.5078 16.6005 7.1203 17.9068 9.99999 17.9068C12.8797 17.9068 15.4922 16.5906 17.5604 14.1167C19.1141 12.2562 19.8068 10.3958 19.8365 10.3167C19.876 10.2177 19.8958 10.1088 19.8958 9.99999C19.8958 9.89114 19.876 9.78229 19.8365 9.68333ZM9.99999 13.9583C7.81301 13.9583 6.04166 12.187 6.04166 9.99999C6.04166 7.81302 7.81301 6.04166 9.99999 6.04166C12.187 6.04166 13.9583 7.81302 13.9583 9.99999C13.9583 12.187 12.187 13.9583 9.99999 13.9583Z"
      fill="currentColor"
    />
    <path
      d="M9.99999 12.9687C11.6396 12.9687 12.9687 11.6396 12.9687 10C12.9687 8.3604 11.6396 7.03125 9.99999 7.03125C8.3604 7.03125 7.03124 8.3604 7.03124 10C7.03124 11.6396 8.3604 12.9687 9.99999 12.9687Z"
      fill="currentColor"
    />
  </svg>
`;
export const ShowHiddenIcon = ({ html = runeHtml, klass = '' }: IconProps = {}) => html`
  <svg
    class="${klass}"
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    height="100%"
    viewBox="0 0 20 20"
    fill="none"
  >
    <path
      d="M3.62704 2.39999C3.29058 2.06354 2.73642 2.06354 2.39996 2.39999C2.0635 2.73645 2.0635 3.29062 2.39996 3.62708L3.51819 4.74531C3.14215 5.09166 2.7859 5.4677 2.43954 5.88333C0.885897 7.74375 0.183293 9.60416 0.163501 9.68333C0.123918 9.78229 0.104126 9.89114 0.104126 10C0.104126 10.1088 0.123918 10.2177 0.163501 10.3167C0.193188 10.3958 0.895793 12.2562 2.43954 14.1167C4.50777 16.6005 7.12027 17.9068 9.99996 17.9068C11.8406 17.9068 13.5625 17.3625 15.1062 16.3234L16.3729 17.5901C16.5411 17.7583 16.7588 17.8474 16.9864 17.8474C17.214 17.8474 17.4317 17.7682 17.6 17.5901C17.9364 17.2536 17.9364 16.6995 17.6 16.363L3.62704 2.39999ZM9.99996 13.9583C7.81298 13.9583 6.04163 12.187 6.04163 10C6.04163 9.21822 6.27913 8.49583 6.66506 7.89218L7.38746 8.61458C7.15985 9.0302 7.03121 9.49531 7.03121 10C7.03121 11.6427 8.35725 12.9687 9.99996 12.9687C10.5046 12.9687 10.9698 12.8401 11.3854 12.6125L12.1078 13.3349C11.4942 13.7208 10.7718 13.9583 9.99996 13.9583Z"
      fill="currentColor"
    />
    <path
      d="M19.8364 9.68333C19.8067 9.60416 19.1041 7.74375 17.5604 5.88333C15.4921 3.39947 12.8796 2.08333 9.99996 2.08333C8.76298 2.08333 7.57548 2.34062 6.45725 2.81562L17.6494 14.0078C19.1338 12.187 19.8067 10.4057 19.8364 10.3266C19.876 10.2276 19.8958 10.1187 19.8958 10.0099C19.8958 9.90104 19.876 9.79218 19.8364 9.69322V9.68333Z"
      fill="currentColor"
    />
  </svg>
`;

export const ShowPrivateIcon = ({ html = runeHtml, klass = '' }: IconProps = {}) =>
  html`<svg
    class="${klass}"
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_20618_39832)">
      <path
        d="M4.63366 3.59922C4.35033 3.31589 3.88366 3.31589 3.60033 3.59922C3.31699 3.88255 3.31699 4.34922 3.60033 4.63255L4.98366 6.01589C4.51699 6.34089 4.05866 6.69089 3.63366 7.10755C2.32533 8.41588 1.73366 9.72422 1.71699 9.77422C1.68366 9.84922 1.66699 9.92422 1.66699 9.99922C1.66699 10.0742 1.68366 10.1576 1.71699 10.2242C1.74199 10.2826 2.33366 11.5826 3.63366 12.8909C5.37533 14.6326 7.57533 15.5492 10.0003 15.5492C11.317 15.5492 12.5587 15.2576 13.7003 14.7326L15.3587 16.3909C15.5003 16.5326 15.6837 16.6076 15.8753 16.6076C16.067 16.6076 16.2503 16.5409 16.392 16.3909C16.6753 16.1076 16.6753 15.6409 16.392 15.3576L4.63366 3.59922ZM10.0003 12.7742C9.45033 12.7742 8.91699 12.6076 8.45866 12.3076C8.00033 11.9992 7.64199 11.5659 7.43366 11.0576C7.22533 10.5492 7.16699 9.99089 7.27533 9.44922C7.33366 9.15755 7.44199 8.87422 7.59199 8.61589L11.367 12.3909C10.9503 12.6242 10.4837 12.7659 10.0003 12.7659V12.7742Z"
        fill="white"
      />
      <path
        d="M18.2837 9.77422C18.2587 9.71588 17.667 8.41588 16.367 7.10755C14.6253 5.36589 12.4253 4.44089 10.0003 4.44089C9.24199 4.44089 8.51699 4.54089 7.80866 4.71589L16.1587 13.0659C16.2253 13.0076 16.3003 12.9492 16.3587 12.8909C17.667 11.5826 18.2503 10.2826 18.2753 10.2242C18.3087 10.1576 18.3253 10.0742 18.3253 9.99922C18.3253 9.92422 18.3087 9.84088 18.2753 9.77422H18.2837Z"
        fill="currentColor"
      />
    </g>
    <defs>
      <clipPath id="clip0_20618_39832">
        <rect width="20" height="20" fill="currentColor" />
      </clipPath>
    </defs>
  </svg> `;

export const MarppleShopPlusSVGText = ({ html = runeHtml, klass = '' }: IconProps = {}) => html`
  <svg
    class="${klass}"
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    height="100%"
    viewBox="0 0 246 35"
    fill="none"
  >
    <g clip-path="url(#clip0_52_57450)">
      <path
        d="M239.058 28.7999C234.698 28.7999 232.218 26.4799 232.218 22.5999V21.9599H236.418V22.6399C236.418 24.3599 237.338 25.1599 238.858 25.1599C240.298 25.1599 241.258 24.4799 241.258 22.8399C241.258 21.1999 239.698 20.5999 237.698 19.8799C235.138 18.9199 232.458 17.5999 232.458 13.5999C232.458 9.99993 234.658 7.67993 238.818 7.67993C242.698 7.67993 245.218 9.91993 245.218 13.5999V13.9999H241.098V13.5199C241.098 11.9999 240.298 11.2799 238.858 11.2799C237.698 11.2799 236.698 11.8799 236.698 13.3999C236.698 15.1199 238.258 15.7199 240.378 16.5199C242.938 17.4799 245.618 18.7199 245.618 22.5999C245.618 26.3999 243.378 28.7999 239.058 28.7999Z"
        fill="currentColor"
      />
      <path
        d="M224.76 8.08008H229.12V28.4001H225.32L225.24 25.4401C224.44 27.5601 222.72 28.8001 220.4 28.8001C217.12 28.8001 215.28 26.7601 215.28 22.4401V8.08008H219.68V21.8401C219.68 23.9601 220.32 24.9601 221.96 24.9601C223.68 24.9601 224.76 23.8001 224.76 21.1201V8.08008Z"
        fill="currentColor"
      />
      <path d="M207.12 28.3999V0.399902H211.52V28.3999H207.12Z" fill="currentColor" />
      <path
        d="M189.543 28.3999V0.399902H196.783C201.783 0.399902 204.143 2.7999 204.143 7.6799V9.7599C204.143 14.6399 201.783 17.0399 196.783 17.0399H194.103V28.3999H189.543ZM194.103 13.0399H196.783C198.743 13.0399 199.583 12.1599 199.583 9.8799V7.5199C199.583 5.2799 198.743 4.4399 196.783 4.4399H194.103V13.0399Z"
        fill="currentColor"
      />
      <path
        d="M173.968 7.67993C177.248 7.67993 179.088 9.71993 179.088 13.9999V22.4399C179.088 26.7599 177.248 28.7999 173.968 28.7999C172.008 28.7999 170.448 27.9199 169.528 26.3999V34.5999H165.128V8.07993H168.928L169.008 11.1999C169.808 8.95993 171.568 7.67993 173.968 7.67993ZM174.688 21.9199V14.5599C174.688 12.5599 174.088 11.5199 172.368 11.5199C170.648 11.5199 169.528 12.7199 169.528 15.3599V21.1199C169.528 23.7599 170.648 24.9599 172.368 24.9599C174.088 24.9599 174.688 23.8799 174.688 21.9199Z"
        fill="currentColor"
      />
      <path
        d="M154.694 28.7999C150.254 28.7999 147.734 26.2399 147.734 21.7599V14.7199C147.734 10.1999 150.254 7.67993 154.694 7.67993C159.174 7.67993 161.694 10.1999 161.694 14.7199V21.7599C161.694 26.2399 159.174 28.7999 154.694 28.7999ZM154.694 24.9599C156.494 24.9599 157.294 23.8399 157.294 22.1199V14.3599C157.294 12.6399 156.494 11.5199 154.694 11.5199C152.894 11.5199 152.134 12.6399 152.134 14.3599V22.1199C152.134 23.8399 152.934 24.9599 154.694 24.9599Z"
        fill="currentColor"
      />
      <path
        d="M139.357 7.6799C142.637 7.6799 144.437 9.7199 144.437 13.9999V28.3999H140.077V14.6399C140.077 12.4799 139.397 11.5199 137.757 11.5199C136.037 11.5199 134.997 12.6799 134.997 15.3599V28.3999H130.597V0.399902H134.997V9.9999C135.917 8.5199 137.397 7.6799 139.357 7.6799Z"
        fill="currentColor"
      />
      <path
        d="M120.085 28.8C115.285 28.8 112.805 26 112.805 21.52V20.12H117.085V21.68C117.085 23.68 118.125 24.84 120.045 24.84C121.805 24.84 122.965 23.76 122.965 21.64C122.965 19.2 121.965 18.08 118.525 15.84C114.205 13.04 112.885 10.72 112.885 7.2C112.885 2.8 115.445 0 120.165 0C124.925 0 127.325 2.76 127.325 7.28V8.24H123.045V7.16C123.045 5.12 122.085 3.96 120.205 3.96C118.445 3.96 117.405 5.04 117.405 7.04C117.405 9.24 118.485 10.36 121.925 12.56C126.325 15.36 127.525 17.72 127.525 21.44C127.525 25.96 124.885 28.8 120.085 28.8Z"
        fill="currentColor"
      />
      <path
        d="M103.25 7.67993C107.77 7.67993 110.25 10.1999 110.25 14.7199V19.1999H100.61V22.1999C100.61 24.1199 101.53 25.0399 103.33 25.0399C105.13 25.0399 106.05 24.1199 106.05 22.1599V21.7599H110.25V21.9599C110.25 26.2399 107.73 28.7999 103.25 28.7999C98.6904 28.7999 96.2104 26.2399 96.2104 21.7599V14.7199C96.2104 10.1999 98.6904 7.67993 103.25 7.67993ZM100.61 15.8799H105.97V14.2399C105.97 12.3199 105.01 11.3999 103.29 11.3999C101.57 11.3999 100.61 12.3199 100.61 14.2399V15.8799Z"
        fill="currentColor"
      />
      <path d="M88.3701 28.3999V0.399902H92.7701V28.3999H88.3701Z" fill="currentColor" />
      <path
        d="M79.6711 7.67993C82.9511 7.67993 84.7911 9.71993 84.7911 13.9999V22.4399C84.7911 26.7599 82.9511 28.7999 79.6711 28.7999C77.7111 28.7999 76.1511 27.9199 75.2311 26.3999V34.5999H70.8311V8.07993H74.6311L74.7111 11.1999C75.5111 8.95993 77.2711 7.67993 79.6711 7.67993ZM80.3911 21.9199V14.5599C80.3911 12.5599 79.7911 11.5199 78.0711 11.5199C76.3511 11.5199 75.2311 12.7199 75.2311 15.3599V21.1199C75.2311 23.7599 76.3511 24.9599 78.0711 24.9599C79.7911 24.9599 80.3911 23.8799 80.3911 21.9199Z"
        fill="currentColor"
      />
      <path
        d="M62.132 7.67993C65.412 7.67993 67.252 9.71993 67.252 13.9999V22.4399C67.252 26.7599 65.412 28.7999 62.132 28.7999C60.172 28.7999 58.612 27.9199 57.692 26.3999V34.5999H53.292V8.07993H57.092L57.172 11.1999C57.972 8.95993 59.732 7.67993 62.132 7.67993ZM62.852 21.9199V14.5599C62.852 12.5599 62.252 11.5199 60.532 11.5199C58.812 11.5199 57.692 12.7199 57.692 15.3599V21.1199C57.692 23.7599 58.812 24.9599 60.532 24.9599C62.252 24.9599 62.852 23.8799 62.852 21.9199Z"
        fill="currentColor"
      />
      <path
        d="M49.3111 7.67993C49.9111 7.67993 50.3511 7.75993 50.6711 7.91993V12.1599C50.3111 12.0799 49.8711 12.0399 49.4311 12.0399C46.6711 12.0399 45.2311 13.8399 45.2311 17.2799V28.3999H40.8311V8.07993H44.6311L44.7111 11.8399C45.3911 9.03993 46.9511 7.67993 49.3111 7.67993Z"
        fill="currentColor"
      />
      <path
        d="M37.5152 28.3999H33.4752C33.3152 28.1599 33.1552 26.9999 33.1152 25.3999C32.3552 27.5199 30.6352 28.7999 28.1152 28.7999C25.0352 28.7999 23.0752 26.7999 23.0752 23.5599C23.0752 20.4399 24.4352 18.4399 28.5552 16.9999C32.1152 15.7599 32.6352 15.3199 32.6352 14.0799V13.8799C32.6352 12.1599 31.9152 11.3599 30.3552 11.3599C28.6352 11.3599 27.8752 12.3599 27.8752 14.0799V14.4399H23.7952V14.1999C23.7952 10.0799 26.1152 7.67993 30.3952 7.67993C35.1552 7.67993 36.9952 10.1599 36.9952 14.7599V22.4799C36.9952 25.3999 37.1952 27.2399 37.5152 28.3999ZM29.6352 25.1199C31.3952 25.1199 32.6352 23.8799 32.6352 21.1999V18.4399C32.1952 18.8799 31.3552 19.2799 29.8752 19.8799C28.1152 20.5999 27.4352 21.5599 27.4352 22.8799C27.4352 24.3199 28.1552 25.1199 29.6352 25.1199Z"
        fill="currentColor"
      />
      <path
        d="M-0.339844 28.3999V0.399902H6.10016L9.86016 20.9599L13.5802 0.399902H20.0202V28.3999H15.7002V6.7199L11.5802 28.3999H7.78016L3.66016 6.7199V28.3999H-0.339844Z"
        fill="currentColor"
      />
    </g>
    <defs>
      <clipPath id="clip0_52_57450">
        <rect width="246" height="35" fill="white" />
      </clipPath>
    </defs>
  </svg>
`;
export const PlayIcon = ({ html = runeHtml, klass = '' }: IconProps = {}) => html`
  <svg
    class="${klass}"
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    height="100%"
    viewBox="0 0 100 100"
    fill="none"
  >
    <circle cx="50" cy="50" r="50" fill="#111111" fill-opacity="0.5" />
    <path
      d="M40.3205 36.4641C40.3205 34.9245 41.9872 33.9623 43.3205 34.7321L67.3205 48.5885C68.6538 49.3583 68.6538 51.2828 67.3205 52.0526L43.3205 65.909C41.9872 66.6788 40.3205 65.7165 40.3205 64.1769L40.3205 36.4641Z"
      fill="white"
    />
  </svg>
`;
export const InstagramFillIcon = ({ html = runeHtml, klass = '' }: IconProps = {}) => html`
  <svg
    class="${klass}"
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    height="100%"
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      d="M12 8.75C11.138 8.75 10.3114 9.09241 9.7019 9.7019C9.09241 10.3114 8.75 11.138 8.75 12C8.75 12.862 9.09241 13.6886 9.7019 14.2981C10.3114 14.9076 11.138 15.25 12 15.25C12.862 15.25 13.6886 14.9076 14.2981 14.2981C14.9076 13.6886 15.25 12.862 15.25 12C15.25 11.138 14.9076 10.3114 14.2981 9.7019C13.6886 9.09241 12.862 8.75 12 8.75Z"
      fill="currentColor"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M6.76982 3.08194C10.2458 2.69664 13.7538 2.69664 17.2298 3.08194C19.1288 3.29394 20.6598 4.78894 20.8828 6.69494C21.295 10.2196 21.295 13.7803 20.8828 17.3049C20.6598 19.2109 19.1288 20.7059 17.2308 20.9189C13.7545 21.3043 10.2462 21.3043 6.76982 20.9189C4.87082 20.7059 3.33982 19.2109 3.11682 17.3059C2.70455 13.781 2.70455 10.2199 3.11682 6.69494C3.33982 4.78894 4.87082 3.29394 6.76982 3.08194ZM16.9998 5.99994C16.7346 5.99994 16.4802 6.1053 16.2927 6.29284C16.1052 6.48037 15.9998 6.73473 15.9998 6.99994C15.9998 7.26516 16.1052 7.51951 16.2927 7.70705C16.4802 7.89459 16.7346 7.99994 16.9998 7.99994C17.265 7.99994 17.5194 7.89459 17.7069 7.70705C17.8945 7.51951 17.9998 7.26516 17.9998 6.99994C17.9998 6.73473 17.8945 6.48037 17.7069 6.29284C17.5194 6.1053 17.265 5.99994 16.9998 5.99994ZM7.24982 11.9999C7.24982 10.7402 7.75027 9.53198 8.64106 8.64119C9.53186 7.75039 10.74 7.24994 11.9998 7.24994C13.2596 7.24994 14.4678 7.75039 15.3586 8.64119C16.2494 9.53198 16.7498 10.7402 16.7498 11.9999C16.7498 13.2597 16.2494 14.4679 15.3586 15.3587C14.4678 16.2495 13.2596 16.7499 11.9998 16.7499C10.74 16.7499 9.53186 16.2495 8.64106 15.3587C7.75027 14.4679 7.24982 13.2597 7.24982 11.9999Z"
      fill="currentColor"
    />
  </svg>
`;
export const TwitterIcon = ({ html = runeHtml, klass = '' }: IconProps = {}) => html`
  <svg
    class="${klass}"
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    height="100%"
    viewBox="0 0 24 24"
    fill="none"
  >
    <g clip-path="url(#clip0_7507_220436)">
      <path
        d="M13.64 11.1081L19.28 5.02813L20.12 4.07812H18.58L12.93 10.1681L8.36 4.07812H3L9.97 13.3681L3.84 19.9681L3 20.9181H4.54L10.68 14.3081L15.64 20.9181H21.01L13.65 11.1081H13.64ZM7.79 5.23812L18.68 19.7581H16.21L5.32 5.23812H7.79Z"
        fill="currentColor"
      />
    </g>
    <defs>
      <clipPath id="clip0_7507_220436">
        <rect width="24" height="24" fill="white" transform="translate(0 0.5)" />
      </clipPath>
    </defs>
  </svg>
`;
export const AdultVerificationIcon19 = ({ html = runeHtml, klass = '' }: IconProps = {}) => html`
  <svg
    class="${klass}"
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    height="100%"
    viewBox="0 0 280 280"
    fill="none"
  >
    <rect x="3" y="3.40039" width="274" height="274" rx="137" />
    <rect x="3" y="3.40039" width="274" height="274" rx="137" stroke="currentColor" stroke-width="6" />
    <path
      d="M160.5 91.0293C177.094 91.0293 186.145 100.492 186.145 116.812V163.304C186.145 180.446 177.78 189.772 160.5 189.772C143.905 189.772 135.265 180.309 135.265 164.675V163.715H149.94V165.086C149.94 172.492 153.505 175.921 159.951 175.921C167.083 175.921 170.511 172.629 170.511 162.618V145.612C167.083 151.509 161.597 154.526 154.191 154.526C141.163 154.526 134.854 146.024 134.854 130.938V116.812C134.854 100.492 143.905 91.0293 160.5 91.0293ZM160.5 104.881C153.78 104.881 150.351 108.584 150.351 115.852V129.429C150.351 136.698 153.368 140.675 160.363 140.675C167.22 140.675 170.511 136.698 170.511 129.292V115.852C170.511 108.446 167.083 104.881 160.5 104.881Z"
      fill="currentColor"
    />
    <path
      d="M107.386 188.264V114.481C101.489 115.029 95.4544 115.304 89.283 115.304V104.332C103.272 104.195 108.62 101.589 112.323 92.2637H123.02V188.264H107.386Z"
      fill="currentColor"
    />
  </svg>
`;
export const AdultVerificationIcon18Plus = ({ html = runeHtml, klass = '' }: IconProps = {}) => html`
  <svg
    class="${klass}"
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    height="100%"
    viewBox="0 0 280 280"
    fill="none"
  >
    <rect x="3" y="3.40039" width="274" height="274" rx="137" />
    <rect x="3" y="3.40039" width="274" height="274" rx="137" stroke="currentColor" stroke-width="6" />
    <path
      d="M140.717 189.772C123.025 189.772 114.248 180.858 114.248 164.264V158.915C114.248 149.178 117.402 141.498 126.179 137.932V137.795C118.774 134.504 114.934 127.372 114.934 118.595V115.441C114.934 99.9436 123.574 91.0293 140.717 91.0293C157.859 91.0293 166.499 99.9436 166.499 115.441V118.595C166.499 127.372 162.522 134.504 155.254 137.795V137.932C164.168 141.498 167.048 149.178 167.048 158.915V164.264C167.048 180.858 158.408 189.772 140.717 189.772ZM140.717 131.486C146.751 131.486 151.139 128.195 151.139 120.515V115.852C151.139 108.584 147.574 104.881 140.717 104.881C133.997 104.881 130.431 108.584 130.431 115.852V120.515C130.431 128.195 134.682 131.486 140.717 131.486ZM140.717 175.921C148.259 175.921 151.688 172.081 151.688 163.304V157.544C151.688 149.452 147.848 145.338 140.717 145.338C133.585 145.338 129.882 149.452 129.882 157.544V163.304C129.882 172.081 133.174 175.921 140.717 175.921Z"
      fill="currentColor"
    />
    <path
      d="M87.0545 188.401V114.619C81.1574 115.167 75.1231 115.441 68.9517 115.441V104.47C82.9402 104.333 88.2888 101.727 91.9917 92.4014H102.689V188.401H87.0545Z"
      fill="currentColor"
    />
    <path
      d="M189.227 158.447V144.175H175.048V136.534H189.227V122.354H196.869V136.534H211.048V144.175H196.869V158.447H189.227Z"
      fill="currentColor"
    />
  </svg>
`;
export const InputErrorIcon = ({ html = runeHtml, klass = '' }: IconProps = {}) => html`
  <svg
    class="${klass}"
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    height="100%"
    viewBox="0 0 20 20"
    fill="none"
  >
    <g clip-path="url(#clip0_4908_39158)">
      <path
        d="M9.99984 1.66675C5.39984 1.66675 1.6665 5.40008 1.6665 10.0001C1.6665 14.6001 5.39984 18.3334 9.99984 18.3334C14.5998 18.3334 18.3332 14.6001 18.3332 10.0001C18.3332 5.40008 14.5998 1.66675 9.99984 1.66675ZM11.0415 14.0667C11.0415 14.6417 10.5748 15.1084 9.99984 15.1084C9.42484 15.1084 8.95817 14.6417 8.95817 14.0667V9.69175C8.95817 9.11675 9.42484 8.65008 9.99984 8.65008C10.5748 8.65008 11.0415 9.11675 11.0415 9.69175V14.0667ZM9.99984 6.98342C9.42484 6.98342 8.95817 6.51675 8.95817 5.94175C8.95817 5.36675 9.42484 4.90008 9.99984 4.90008C10.5748 4.90008 11.0415 5.36675 11.0415 5.94175C11.0415 6.51675 10.5748 6.98342 9.99984 6.98342Z"
        fill="#D92A0F"
      />
    </g>
    <defs>
      <clipPath id="clip0_4908_39158">
        <rect width="20" height="20" fill="white" />
      </clipPath>
    </defs>
  </svg>
`;
export const TrashBinIcon = ({ html = runeHtml, klass = '' }: IconProps = {}) => html`
  <svg
    class="${klass}"
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    height="100%"
    viewBox="0 0 14 14"
    fill="none"
  >
    <path
      d="M12.3203 2.80567H9.69533V2.55484C9.69533 1.79067 9.07116 1.1665 8.30699 1.1665H5.68199C4.91783 1.1665 4.29366 1.79067 4.29366 2.55484V2.80567H1.68033C1.40033 2.80567 1.16699 3.03317 1.16699 3.319C1.16699 3.60484 1.39449 3.83234 1.68033 3.83234H2.61949L3.47116 12.0573C3.51783 12.5007 3.87949 12.839 4.31699 12.839H9.68949C10.1212 12.839 10.4887 12.5007 10.5353 12.0573L11.387 3.83234H12.3262C12.6062 3.83234 12.8395 3.60484 12.8395 3.319C12.8395 3.03317 12.612 2.80567 12.3262 2.80567H12.3203ZM5.32616 2.55484C5.32616 2.3565 5.48949 2.19317 5.68783 2.19317H8.31283C8.51116 2.19317 8.67449 2.3565 8.67449 2.55484V2.80567H5.32033V2.55484H5.32616ZM5.85699 8.2365C5.85699 8.5165 5.62949 8.74984 5.34366 8.74984C5.05783 8.74984 4.83033 8.52234 4.83033 8.2365V5.75734C4.83033 5.47734 5.05783 5.244 5.34366 5.244C5.62949 5.244 5.85699 5.4715 5.85699 5.75734V8.2365ZM9.16449 8.2365C9.16449 8.5165 8.93699 8.74984 8.65116 8.74984C8.36533 8.74984 8.13783 8.52234 8.13783 8.2365V5.75734C8.13783 5.47734 8.36533 5.244 8.65116 5.244C8.93699 5.244 9.16449 5.4715 9.16449 5.75734V8.2365Z"
      fill="currentColor"
    />
  </svg>
`;
export const WriteIcon = ({ html = runeHtml, klass = '' }: IconProps = {}) =>
  html` <svg
    class="${klass}"
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    height="100%"
    viewBox="0 0 24 24"
    fill="none"
  >
    <g clip-path="url(#clip0_10213_31924)">
      <path
        d="M21.0898 7.60484L16.3837 2.89159C15.7292 2.23617 14.584 2.23617 13.9295 2.89159L7.70276 9.12774L2.90998 13.9277C2.58276 14.2554 2.3999 14.6892 2.3999 15.1518V19.8651C2.3999 20.8289 3.17945 21.6 4.13223 21.6H8.8384C9.30035 21.6 9.73344 21.4169 10.0703 21.0892L21.0898 10.053C21.417 9.72533 21.5999 9.29159 21.5999 8.8193C21.5999 8.34701 21.417 7.92292 21.0898 7.58557V7.60484ZM17.962 10.8048L13.1789 6.01448L15.1133 4.07713H15.1903L19.8964 8.86749L17.962 10.8048Z"
        fill="currentColor"
      />
    </g>
    <defs>
      <clipPath id="clip0_10213_31924">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>`;
export const LiveIcon = ({ html = runeHtml, klass = '' }: IconProps = {}) => html`
  <svg
    class="${klass}"
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    height="100%"
    viewBox="0 0 14 15"
    fill="none"
  >
    <g clip-path="url(#clip0_12928_13007)">
      <path
        d="M9.9573 5.82584C9.05313 5.07918 7.9798 4.28001 8.59813 2.22084C8.69146 1.91751 8.4348 1.61418 8.12563 1.67834C7.09313 1.88834 5.12146 3.15418 5.0223 5.38251C4.9523 6.95751 5.44813 7.72168 5.7923 8.67251C5.99063 9.22084 5.40146 9.62334 4.88813 9.34334C3.94896 8.83001 3.5173 8.04251 3.38896 6.88168C3.3598 6.59584 2.9748 6.51418 2.84646 6.77668C2.4673 7.57001 2.3098 8.49168 2.46146 9.45418C2.7648 11.4667 4.43896 13.065 6.4573 13.2983C9.23396 13.6133 11.5848 11.9917 11.5848 9.27918C11.5848 8.34001 11.439 7.05668 9.95146 5.83168L9.9573 5.82584Z"
        fill="currentColor"
      />
    </g>
    <defs>
      <clipPath id="clip0_12928_13007">
        <rect width="14" height="14" fill="white" transform="translate(0 0.5)" />
      </clipPath>
    </defs>
  </svg>
`;
// export const country_icon_urls = {
//   kr: 'https://s3.marpple.co/files/u_1165777/2024/3/original/14bf14174fa35987787cdfef90de80177098e1a13.png',
//   en: 'https://s3.marpple.co/files/u_1165777/2024/3/original/08682630ef6c18f64cd515fe168ea1ed1ae45f841.png',
//   jp: 'https://s3.marpple.co/files/u_1165777/2024/3/original/2dc5fc644b42f5e70eaf4a14db6e0d37cf0384872.png',
// };
export const NaverPayIcon = ({ html = runeHtml, klass = '' }: IconProps = {}) => html`
  <svg
    class="${klass}"
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    height="100%"
    viewBox="0 0 24 24"
    fill="none"
  >
    <rect width="24" height="24" rx="12" fill="#00DE5A" />
    <path
      d="M20.6861 10.31L19.7819 12.3699L18.759 10.31H17.9721L19.4215 13.168L18.8241 14.5025H19.5877L21.4496 10.31H20.6861ZM17.5366 13.495H16.7891V13.1977C16.5194 13.4308 16.196 13.56 15.8059 13.56C14.9112 13.56 14.2119 12.8321 14.2119 11.9025C14.2119 10.9729 14.9112 10.245 15.8059 10.245C16.196 10.245 16.5194 10.3742 16.7891 10.6073V10.31H17.5366V13.495ZM16.8769 11.9025C16.8769 11.302 16.4577 10.8462 15.9019 10.8462C15.346 10.8462 14.9269 11.302 14.9269 11.9025C14.9269 12.503 15.346 12.9588 15.9019 12.9588C16.4577 12.9588 16.8769 12.503 16.8769 11.9025ZM10.4971 14.5025H11.2771V13.225C11.5402 13.4409 11.8533 13.56 12.2278 13.56C13.1225 13.56 13.8219 12.8321 13.8219 11.9025C13.8219 10.9729 13.1225 10.245 12.2278 10.245C11.8378 10.245 11.5143 10.3742 11.2446 10.6073V10.31H10.4971V14.5025ZM12.1319 10.8462C12.6877 10.8462 13.1069 11.302 13.1069 11.9025C13.1069 12.503 12.6877 12.9588 12.1319 12.9588C11.576 12.9588 11.1569 12.503 11.1569 11.9025C11.1569 11.302 11.576 10.8462 12.1319 10.8462ZM9.09961 12C9.09961 13.7949 7.64453 15.25 5.84961 15.25C4.05468 15.25 2.59961 13.7949 2.59961 12C2.59961 10.2051 4.05468 8.75 5.84961 8.75C7.64454 8.75 9.09961 10.2051 9.09961 12ZM6.3934 10.4725V12.1069L5.25847 10.4725H4.32211V13.5275H5.30582V11.8931L6.44075 13.5275H7.37711V10.4725H6.3934Z"
      fill="black"
    />
  </svg>
`;
export const MoveIcon = ({ html = runeHtml, klass = '' }: IconProps = {}) => html`
  <svg
    class="${klass}"
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    height="100%"
    viewBox="0 0 20 20"
    fill="none"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M9.9804 0.0250247C9.98042 0.0250247 9.98045 0.0250247 9.98047 0.0250247C10.2335 0.0250247 10.4615 0.132451 10.6213 0.304187L13.8494 3.54226C14.1906 3.88449 14.1897 4.43851 13.8475 4.77969C13.5053 5.12088 12.9512 5.12003 12.6101 4.77779L10.8555 3.0178V9.125H16.9679L15.2016 7.35871C14.8599 7.017 14.8599 6.46298 15.2016 6.12127C15.5433 5.77956 16.0973 5.77956 16.439 6.12127L19.699 9.38127C20.0407 9.72298 20.0407 10.277 19.699 10.6187L16.439 13.8787C16.0973 14.2204 15.5433 14.2204 15.2016 13.8787C14.8599 13.537 14.8599 12.983 15.2016 12.6413L16.9679 10.875H10.8555V16.9822L12.6101 15.2222C12.9512 14.88 13.5053 14.8791 13.8475 15.2203C14.1897 15.5615 14.1906 16.1155 13.8494 16.4577L10.6221 19.695C10.4623 19.8672 10.234 19.975 9.98047 19.975C9.86256 19.975 9.75011 19.9517 9.64746 19.9094C9.5413 19.8658 9.44373 19.8014 9.36101 19.7187L6.10101 16.4587C5.7593 16.117 5.7593 15.563 6.10101 15.2212C6.44272 14.8795 6.99674 14.8795 7.33845 15.2212L9.10547 16.9883V10.875H2.98775L4.74955 12.6422C5.09073 12.9845 5.08988 13.5385 4.74765 13.8797C4.40542 14.2208 3.8514 14.22 3.51021 13.8778L0.262618 10.6202C0.254266 10.6119 0.24608 10.6034 0.238068 10.5947C0.0933516 10.4386 0.00488281 10.2296 0.00488281 10C0.00488281 9.88242 0.0280772 9.77025 0.0701387 9.66782C0.112689 9.56398 0.176047 9.46665 0.260215 9.38222L3.51021 6.12222C3.8514 5.77999 4.40542 5.77914 4.74765 6.12032C5.08988 6.46151 5.09073 7.01552 4.74955 7.35776L2.98773 9.125H9.10547V3.01172L7.33845 4.77874C6.99674 5.12045 6.44272 5.12045 6.10101 4.77874C5.7593 4.43703 5.7593 3.88301 6.10101 3.54131L9.36101 0.281306C9.45755 0.184762 9.57433 0.11311 9.70138 0.0704782C9.75313 0.0530712 9.80706 0.0403723 9.86263 0.0328912C9.90145 0.0276501 9.94079 0.0249943 9.9804 0.0250247Z"
      fill="#141414"
    />
  </svg>
`;
export const EditorTextFontIcon = ({ html = runeHtml, klass = '' }: IconProps = {}) => html`
  <svg
    class="${klass}"
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    height="100%"
    viewBox="0 0 20 20"
    fill="none"
  >
    <g clip-path="url(#clip0_10144_88894)">
      <path
        d="M16.3252 1.66663H3.67523C3.27523 1.66663 2.94189 1.99163 2.94189 2.39996V5.73329C2.94189 6.13329 3.26689 6.46663 3.67523 6.46663C4.08356 6.46663 4.40856 6.14163 4.40856 5.73329V3.13329H9.27523V16.8833H5.84189C5.44189 16.8833 5.10856 17.2083 5.10856 17.6166C5.10856 18.025 5.43356 18.35 5.84189 18.35H14.1752C14.5752 18.35 14.9086 18.025 14.9086 17.6166C14.9086 17.2083 14.5836 16.8833 14.1752 16.8833H10.7419V3.12496H15.6086V5.72496C15.6086 6.12496 15.9336 6.45829 16.3419 6.45829C16.7502 6.45829 17.0752 6.13329 17.0752 5.72496V2.39996C17.0752 1.99996 16.7502 1.66663 16.3419 1.66663H16.3252Z"
        fill="#141414"
      />
    </g>
    <defs>
      <clipPath id="clip0_10144_88894">
        <rect width="20" height="20" fill="white" />
      </clipPath>
    </defs>
  </svg>
`;
export const EditorCancellationIcon = ({ html = runeHtml, klass = '' }: IconProps = {}) => html`
  <svg
    class="${klass}"
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    height="100%"
    viewBox="0 0 20 20"
    fill="none"
  >
    <g clip-path="url(#clip0_10144_88897)">
      <path
        d="M17.0831 9.26663H2.91644C2.51644 9.26663 2.18311 9.59163 2.18311 9.99996C2.18311 10.4083 2.50811 10.7333 2.91644 10.7333H9.93311C12.4748 10.7333 14.6164 12.1416 14.6164 13.8083C14.6164 15.475 12.4664 16.8833 9.93311 16.8833C7.39977 16.8833 5.24977 15.475 5.24977 13.8083C5.24977 13.4083 4.92477 13.075 4.51644 13.075C4.10811 13.075 3.78311 13.4 3.78311 13.8083C3.78311 16.3083 6.54144 18.3416 9.93311 18.3416C13.3248 18.3416 16.0831 16.3083 16.0831 13.8083C16.0831 12.625 15.4581 11.5416 14.4414 10.7333H17.0831C17.4831 10.7333 17.8164 10.4083 17.8164 9.99996C17.8164 9.59163 17.4914 9.26663 17.0831 9.26663Z"
        fill="#141414"
      />
      <path
        d="M5.24977 6.19996C5.24977 4.53329 7.39977 3.12496 9.93311 3.12496C12.4664 3.12496 14.6164 4.53329 14.6164 6.19996C14.6164 6.59996 14.9414 6.93329 15.3498 6.93329C15.7581 6.93329 16.0831 6.60829 16.0831 6.19996C16.0831 3.69996 13.3248 1.66663 9.93311 1.66663C6.54144 1.66663 3.78311 3.69996 3.78311 6.19996C3.78311 6.58329 3.84977 6.95829 3.97477 7.31663C4.07477 7.61663 4.35811 7.81663 4.66644 7.81663C5.17477 7.81663 5.49977 7.31663 5.34144 6.83329C5.27477 6.63329 5.23311 6.41663 5.23311 6.19996H5.24977Z"
        fill="#141414"
      />
    </g>
    <defs>
      <clipPath id="clip0_10144_88897">
        <rect width="20" height="20" fill="white" />
      </clipPath>
    </defs>
  </svg>
`;
export const EditorListIcon = ({ html = runeHtml, klass = '' }: IconProps = {}) => html`
  <svg
    class="${klass}"
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    height="100%"
    viewBox="0 0 20 20"
    fill="none"
  >
    <g clip-path="url(#clip0_10144_88900)">
      <path
        d="M6.34984 4.9H17.5998C17.9998 4.9 18.3332 4.575 18.3332 4.16667C18.3332 3.75833 18.0082 3.43333 17.5998 3.43333H6.34984C5.94984 3.43333 5.6165 3.75833 5.6165 4.16667C5.6165 4.575 5.9415 4.9 6.34984 4.9Z"
        fill="#141414"
      />
      <path
        d="M2.70817 5.20833C3.28347 5.20833 3.74984 4.74196 3.74984 4.16667C3.74984 3.59137 3.28347 3.125 2.70817 3.125C2.13287 3.125 1.6665 3.59137 1.6665 4.16667C1.6665 4.74196 2.13287 5.20833 2.70817 5.20833Z"
        fill="#141414"
      />
      <path
        d="M17.5998 9.26667H6.34984C5.94984 9.26667 5.6165 9.59167 5.6165 10C5.6165 10.4083 5.9415 10.7333 6.34984 10.7333H17.5998C17.9998 10.7333 18.3332 10.4083 18.3332 10C18.3332 9.59167 18.0082 9.26667 17.5998 9.26667Z"
        fill="#141414"
      />
      <path
        d="M2.70817 11.0417C3.28347 11.0417 3.74984 10.5753 3.74984 10C3.74984 9.4247 3.28347 8.95833 2.70817 8.95833C2.13287 8.95833 1.6665 9.4247 1.6665 10C1.6665 10.5753 2.13287 11.0417 2.70817 11.0417Z"
        fill="#141414"
      />
      <path
        d="M17.5998 15.1H6.34984C5.94984 15.1 5.6165 15.425 5.6165 15.8333C5.6165 16.2417 5.9415 16.5667 6.34984 16.5667H17.5998C17.9998 16.5667 18.3332 16.2417 18.3332 15.8333C18.3332 15.425 18.0082 15.1 17.5998 15.1Z"
        fill="#141414"
      />
      <path
        d="M2.70817 16.875C3.28347 16.875 3.74984 16.4086 3.74984 15.8333C3.74984 15.258 3.28347 14.7917 2.70817 14.7917C2.13287 14.7917 1.6665 15.258 1.6665 15.8333C1.6665 16.4086 2.13287 16.875 2.70817 16.875Z"
        fill="#141414"
      />
    </g>
    <defs>
      <clipPath id="clip0_10144_88900">
        <rect width="20" height="20" fill="white" />
      </clipPath>
    </defs>
  </svg>
`;
export const EditorTextColorIcon = ({ html = runeHtml, klass = '' }: IconProps = {}) => html`
  <svg
    class="${klass}"
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    height="100%"
    viewBox="0 0 20 20"
    fill="none"
  >
    <g clip-path="url(#clip0_12729_25721)">
      <path
        d="M14.4795 2.53625H2.39616C1.99333 2.53625 1.66699 2.86259 1.66699 3.26542V5.34876C1.66699 5.75159 1.99333 6.07792 2.39616 6.07792C2.79899 6.07792 3.12533 5.75159 3.12533 5.34876V3.99459H7.70866V16.0055H6.14616C5.74333 16.0055 5.41699 16.3318 5.41699 16.7347C5.41699 17.1375 5.74333 17.4638 6.14616 17.4638H10.7295C11.1323 17.4638 11.4587 17.1375 11.4587 16.7347C11.4587 16.3318 11.1323 16.0055 10.7295 16.0055H9.16699V3.99459H13.7503V5.34876C13.7503 5.75159 14.0767 6.07792 14.4795 6.07792C14.8823 6.07792 15.2087 5.75159 15.2087 5.34876V3.26542C15.2087 2.86259 14.8823 2.53625 14.4795 2.53625Z"
        fill="#141414"
      />
      <path
        d="M17.083 12.4637H14.583C13.8927 12.4637 13.333 13.0234 13.333 13.7137V16.2137C13.333 16.9041 13.8927 17.4637 14.583 17.4637H17.083C17.7734 17.4637 18.333 16.9041 18.333 16.2137V13.7137C18.333 13.0234 17.7734 12.4637 17.083 12.4637Z"
        fill="#141414"
      />
    </g>
    <defs>
      <clipPath id="clip0_12729_25721">
        <rect width="20" height="20" fill="white" />
      </clipPath>
    </defs>
  </svg>
`;
export const EditorDividerIcon = ({ html = runeHtml, klass = '' }: IconProps = {}) => html`
  <svg
    class="${klass}"
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    height="100%"
    viewBox="0 0 20 20"
    fill="none"
  >
    <g clip-path="url(#clip0_12732_25765)">
      <path
        d="M16.8747 4.89583H3.12467C2.72184 4.89583 2.39551 4.5695 2.39551 4.16667C2.39551 3.76383 2.72184 3.4375 3.12467 3.4375H16.8747C17.2775 3.4375 17.6038 3.76383 17.6038 4.16667C17.6038 4.5695 17.2775 4.89583 16.8747 4.89583Z"
        fill="#141414"
      />
      <path
        d="M5.62467 10.7292H3.12467C2.72184 10.7292 2.39551 10.4029 2.39551 10C2.39551 9.59721 2.72184 9.27087 3.12467 9.27087H5.62467C6.02751 9.27087 6.35384 9.59721 6.35384 10C6.35384 10.4029 6.02751 10.7292 5.62467 10.7292Z"
        fill="#141414"
      />
      <path
        d="M11.4583 10.7292H8.54167C8.13883 10.7292 7.8125 10.4029 7.8125 10C7.8125 9.59721 8.13883 9.27087 8.54167 9.27087H11.4583C11.8612 9.27087 12.1875 9.59721 12.1875 10C12.1875 10.4029 11.8612 10.7292 11.4583 10.7292Z"
        fill="#141414"
      />
      <path
        d="M16.8747 10.7292H14.3747C13.9718 10.7292 13.6455 10.4029 13.6455 10C13.6455 9.59721 13.9718 9.27087 14.3747 9.27087H16.8747C17.2775 9.27087 17.6038 9.59721 17.6038 10C17.6038 10.4029 17.2775 10.7292 16.8747 10.7292Z"
        fill="#141414"
      />
      <path
        d="M16.8747 16.5625H3.12467C2.72184 16.5625 2.39551 16.2361 2.39551 15.8333C2.39551 15.4305 2.72184 15.1041 3.12467 15.1041H16.8747C17.2775 15.1041 17.6038 15.4305 17.6038 15.8333C17.6038 16.2361 17.2775 16.5625 16.8747 16.5625Z"
        fill="#141414"
      />
    </g>
    <defs>
      <clipPath id="clip0_12732_25765">
        <rect width="20" height="20" fill="white" />
      </clipPath>
    </defs>
  </svg>
`;
export const EditorAlignIcon = ({ html = runeHtml, klass = '' }: IconProps = {}) => html`
  <svg
    class="${klass}"
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    height="100%"
    viewBox="0 0 20 20"
    fill="none"
  >
    <g clip-path="url(#clip0_12722_25721)">
      <path
        d="M9.27116 1.66663H2.39616C1.99345 1.66663 1.66699 1.99309 1.66699 2.39579C1.66699 2.7985 1.99345 3.12496 2.39616 3.12496H9.27116C9.67387 3.12496 10.0003 2.7985 10.0003 2.39579C10.0003 1.99309 9.67387 1.66663 9.27116 1.66663Z"
        fill="black"
      />
      <path
        d="M14.2712 6.73857H2.39616C1.99345 6.73857 1.66699 7.06503 1.66699 7.46774C1.66699 7.87044 1.99345 8.1969 2.39616 8.1969H14.2712C14.6739 8.1969 15.0003 7.87044 15.0003 7.46774C15.0003 7.06503 14.6739 6.73857 14.2712 6.73857Z"
        fill="black"
      />
      <path
        d="M10.9378 11.8104H2.39616C1.99345 11.8104 1.66699 12.1369 1.66699 12.5396C1.66699 12.9423 1.99345 13.2688 2.39616 13.2688H10.9378C11.3405 13.2688 11.667 12.9423 11.667 12.5396C11.667 12.1369 11.3405 11.8104 10.9378 11.8104Z"
        fill="black"
      />
      <path
        d="M17.6045 16.8823H2.39616C1.99345 16.8823 1.66699 17.2088 1.66699 17.6115C1.66699 18.0142 1.99345 18.3406 2.39616 18.3406H17.6045C18.0072 18.3406 18.3337 18.0142 18.3337 17.6115C18.3337 17.2088 18.0072 16.8823 17.6045 16.8823Z"
        fill="black"
      />
    </g>
    <defs>
      <clipPath id="clip0_12722_25721">
        <rect width="20" height="20" fill="white" />
      </clipPath>
    </defs>
  </svg>
`;
export const EditorCodeIcon = ({ html = runeHtml, klass = '' }: IconProps = {}) => html`
  <svg
    class="${klass}"
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    height="100%"
    viewBox="0 0 20 20"
    fill="none"
  >
    <g clip-path="url(#clip0_10144_88904)">
      <path
        d="M12.7582 2.64998C12.3832 2.50831 11.9582 2.69998 11.8165 3.07498L6.81654 16.4083C6.67487 16.7833 6.86654 17.2083 7.24154 17.35C7.32487 17.3833 7.41654 17.4 7.49987 17.4C7.79154 17.4 8.07487 17.2166 8.1832 16.925L13.1832 3.59165C13.3249 3.21665 13.1332 2.79165 12.7582 2.64998Z"
        fill="#141414"
      />
      <path
        d="M5.84154 6.54998C5.5582 6.26665 5.09154 6.26665 4.8082 6.54998L1.87487 9.48331C1.74154 9.61665 1.6582 9.80831 1.6582 9.99998C1.6582 10.1916 1.7332 10.375 1.87487 10.5166L4.8082 13.45C4.94987 13.5916 5.14154 13.6666 5.32487 13.6666C5.5082 13.6666 5.69987 13.5916 5.84154 13.45C6.12487 13.1666 6.12487 12.7 5.84154 12.4166L3.42487 9.99998L5.84154 7.58331C6.12487 7.29998 6.12487 6.83331 5.84154 6.54998Z"
        fill="#141414"
      />
      <path
        d="M18.1165 9.48331L15.1832 6.54998C14.8999 6.26665 14.4332 6.26665 14.1499 6.54998C13.8665 6.83331 13.8665 7.29998 14.1499 7.58331L16.5665 9.99998L14.1499 12.4166C13.8665 12.7 13.8665 13.1666 14.1499 13.45C14.2915 13.5916 14.4832 13.6666 14.6665 13.6666C14.8499 13.6666 15.0415 13.5916 15.1832 13.45L18.1165 10.5166C18.2499 10.3833 18.3332 10.1916 18.3332 9.99998C18.3332 9.80831 18.2582 9.62498 18.1165 9.48331Z"
        fill="#141414"
      />
    </g>
    <defs>
      <clipPath id="clip0_10144_88904">
        <rect width="20" height="20" fill="white" />
      </clipPath>
    </defs>
  </svg>
`;
export const EditorMouseButtonIcon = ({ html = runeHtml, klass = '' }: IconProps = {}) => html`
  <svg
    class="${klass}"
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    height="100%"
    viewBox="0 0 20 20"
    fill="none"
  >
    <path
      d="M10.4167 1.66663H9.58333C6.35833 1.66663 3.75 4.27496 3.75 7.49996V12.5C3.75 15.725 6.35833 18.3333 9.58333 18.3333H10.4167C13.6417 18.3333 16.25 15.725 16.25 12.5V7.49996C16.25 4.27496 13.6417 1.66663 10.4167 1.66663ZM14.7917 12.5C14.7917 14.9083 12.825 16.875 10.4167 16.875H9.58333C7.175 16.875 5.20833 14.9083 5.20833 12.5V9.67496H14.7917V12.5ZM10 8.21663V3.12496H10.4167C12.825 3.12496 14.7917 5.09163 14.7917 7.49996V8.21663H10Z"
      fill="#141414"
    />
  </svg>
`;
export const EditorHandleBarIcon = ({ html = runeHtml, klass = '' }: IconProps = {}) => html`
  <svg
    class="${klass}"
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    height="100%"
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      d="M8.25 2.88C9.08 2.88 9.75 3.55 9.75 4.38C9.75 5.21 9.08 5.88 8.25 5.88C7.42 5.88 6.75 5.21 6.75 4.38C6.75 3.55 7.42 2.88 8.25 2.88Z"
      fill="currentColor"
    />
    <path
      d="M15.75 2.88C16.58 2.88 17.25 3.55 17.25 4.38C17.25 5.21 16.58 5.88 15.75 5.88C14.92 5.88 14.25 5.21 14.25 4.38C14.25 3.55 14.92 2.88 15.75 2.88Z"
      fill="currentColor"
    />
    <path
      d="M8.25 10.5C9.08 10.5 9.75 11.17 9.75 12C9.75 12.83 9.08 13.5 8.25 13.5C7.42 13.5 6.75 12.83 6.75 12C6.75 11.17 7.42 10.5 8.25 10.5Z"
      fill="currentColor"
    />
    <path
      d="M15.75 10.5C16.58 10.5 17.25 11.17 17.25 12C17.25 12.83 16.58 13.5 15.75 13.5C14.92 13.5 14.25 12.83 14.25 12C14.25 11.17 14.92 10.5 15.75 10.5Z"
      fill="currentColor"
    />
    <path
      d="M8.25 18.12C9.08 18.12 9.75 18.79 9.75 19.62C9.75 20.45 9.08 21.12 8.25 21.12C7.42 21.12 6.75 20.45 6.75 19.62C6.75 18.79 7.42 18.12 8.25 18.12Z"
      fill="currentColor"
    />
    <path
      d="M15.75 18.12C16.58 18.12 17.25 18.79 17.25 19.62C17.25 20.45 16.58 21.12 15.75 21.12C14.92 21.12 14.25 20.45 14.25 19.62C14.25 18.79 14.92 18.12 15.75 18.12Z"
      fill="currentColor"
    />
  </svg>
`;
export const MembershipIcon = ({ html = runeHtml, klass = '' }: IconProps = {}) => html`
  <svg
    class="${klass}"
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    height="100%"
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      d="M9.9508 3.04749H5.83514C5.69141 3.04749 5.55843 3.12359 5.48562 3.24751L2.05648 9.08381C1.8977 9.35404 2.09256 9.69456 2.406 9.69456H6.02129C6.15618 9.69456 6.28223 9.62747 6.35756 9.51558L10.2871 3.67928C10.4684 3.41001 10.2754 3.04749 9.9508 3.04749Z"
      fill="#141414"
    />
    <path
      d="M15.1687 9.69454C15.4933 9.69454 15.6862 9.33202 15.5049 9.06275L12.3363 4.35651C12.1756 4.11787 11.8244 4.11787 11.6637 4.35651L8.49506 9.06275C8.31376 9.33202 8.50671 9.69454 8.83133 9.69454H15.1687Z"
      fill="#141414"
    />
    <path
      d="M21.9435 9.08381L18.5144 3.24751C18.4416 3.12359 18.3086 3.04749 18.1649 3.04749H14.0492C13.7246 3.04749 13.5316 3.41001 13.7129 3.67928L17.6424 9.51558C17.7178 9.62747 17.8438 9.69456 17.9787 9.69456H21.594C21.9074 9.69456 22.1023 9.35405 21.9435 9.08381Z"
      fill="#141414"
    />
    <path
      d="M8.41019 11.2147C8.1191 11.2147 7.92288 11.5124 8.03764 11.78L11.6274 20.7071C11.7679 21.0345 12.2321 21.0345 12.3725 20.7071L15.9624 11.78C16.0771 11.5124 15.8809 11.2147 15.5898 11.2147H8.41019Z"
      fill="#141414"
    />
    <path
      d="M15.607 18.7927L21.8923 11.8944C22.1311 11.6345 21.9468 11.2147 21.5938 11.2147H18.1268C17.9647 11.2147 17.8182 11.3113 17.7543 11.4603L14.936 18.3586C14.7562 18.7777 15.2984 19.1285 15.607 18.7927Z"
      fill="#141414"
    />
    <path
      d="M8.39299 18.7927L2.10771 11.8944C1.86886 11.6346 2.05321 11.2147 2.40618 11.2147H5.87316C6.03527 11.2147 6.1818 11.3113 6.24571 11.4603L9.06401 18.3586C9.24383 18.7777 8.70162 19.1285 8.39299 18.7927Z"
      fill="#141414"
    />
  </svg>
`;
export const TrophyIcon = ({ html = runeHtml, klass = '' }: IconProps = {}) => html`
  <svg
    class="${klass}"
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    height="100%"
    viewBox="0 0 24 24"
    fill="none"
  >
    <g clip-path="url(#clip0_10144_89249)">
      <path
        d="M17.99 12.03C20.21 11.44 22 9.67001 22 5.04001C22 4.39001 21.58 3.84001 21 3.84001H18.29V3.07001C18.29 2.48001 17.81 2.01001 17.23 2.01001H6.77C6.18 2.01001 5.71 2.49001 5.71 3.07001V3.84001H3C2.42 3.84001 2 4.39001 2 5.04001C2 9.67001 3.79 11.45 6.01 12.03C6.74 14.24 8.73 15.87 11.13 16.07V20.25H7.88C7.4 20.25 7 20.64 7 21.13C7 21.62 7.39 22.01 7.88 22.01H16.13C16.61 22.01 17.01 21.62 17.01 21.13C17.01 20.64 16.62 20.25 16.13 20.25H12.88V16.07C15.28 15.87 17.27 14.24 18 12.03H17.99ZM20.24 5.58001C20.14 8.24001 19.35 9.47001 18.29 10.04V5.58001H20.24ZM3.76 5.58001H5.71V10.04C4.65 9.47001 3.86 8.24001 3.76 5.58001Z"
        fill="#141414"
      />
    </g>
    <defs>
      <clipPath id="clip0_10144_89249">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
`;
export const UnlinkIcon = ({ html = runeHtml, klass = '' }: IconProps = {}) => html`
  <svg
    class="${klass}"
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    height="100%"
    viewBox="0 0 24 24"
    fill="none"
  >
    <g clip-path="url(#clip0_10557_34914)">
      <path
        d="M11.2899 5.28C12.2799 4.29 13.5899 3.75 14.9899 3.75C16.3899 3.75 17.6999 4.29 18.6899 5.28L18.7299 5.32C20.7699 7.36 20.7699 10.68 18.7299 12.71C18.3899 13.05 18.3899 13.61 18.7299 13.95C19.0699 14.29 19.6299 14.29 19.9699 13.95C22.6999 11.22 22.6999 6.8 19.9699 4.08L19.9299 4.04C18.5699 2.68 16.7799 2 14.9899 2C13.1999 2 11.4199 2.68 10.0499 4.04C9.70992 4.38 9.70992 4.94 10.0499 5.28C10.3899 5.62 10.9499 5.62 11.2899 5.28Z"
        fill="black"
      />
      <path
        d="M12.7099 18.72C11.7199 19.71 10.4099 20.25 9.00992 20.25C7.60992 20.25 6.29992 19.71 5.30992 18.72L5.26992 18.68C3.22992 16.64 3.22992 13.32 5.26992 11.29C5.60992 10.95 5.60992 10.39 5.26992 10.05C4.92992 9.71 4.36992 9.71 4.02992 10.05C1.29992 12.78 1.29992 17.2 4.02992 19.92L4.06992 19.96C5.42992 21.32 7.21992 22 9.00992 22C10.7999 22 12.5799 21.32 13.9499 19.96C14.2899 19.62 14.2899 19.06 13.9499 18.72C13.6099 18.38 13.0499 18.38 12.7099 18.72Z"
        fill="black"
      />
      <path
        d="M4.59992 3.38C4.25992 3.04 3.69992 3.04 3.35992 3.38C3.01992 3.72 3.01992 4.28 3.35992 4.62L19.3699 20.63C19.5399 20.8 19.7599 20.89 19.9899 20.89C20.2199 20.89 20.4399 20.8 20.6099 20.63C20.9499 20.29 20.9499 19.73 20.6099 19.39L4.59992 3.38Z"
        fill="black"
      />
    </g>
    <defs>
      <clipPath id="clip0_10557_34914">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
`;
export const BankBookIcon = ({ html = runeHtml, klass = '' }: IconProps = {}) => html`
  <svg
    class="${klass}"
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    height="100%"
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      d="M21.9989 13.0291V20.4571C21.9989 21.1713 21.4199 21.7502 20.7057 21.7502H5.18754C4.47334 21.7502 3.89436 21.1713 3.89436 20.4571V20.1984H17.7365C19.0053 20.1982 20.1181 19.3519 20.4574 18.1293L21.9989 13.0291ZM21.8437 7.05972C21.6982 6.86306 21.4675 6.74771 21.223 6.74936H13.4747C13.4874 6.91501 13.5 7.08078 13.5 7.24967C13.5 10.8338 10.5841 13.7497 7 13.7497C5.65137 13.7497 4.39764 13.3363 3.35803 12.6304L2.05285 16.981C1.93713 17.375 2.01379 17.8005 2.25976 18.1294C2.50183 18.4576 2.88653 18.65 3.29431 18.6467H17.7779C18.3344 18.6301 18.8179 18.2591 18.978 17.7259L21.9678 7.75291C22.038 7.51518 21.992 7.25833 21.8437 7.05972ZM16 16.6393H12C11.5859 16.6393 11.25 16.3034 11.25 15.8893C11.25 15.4753 11.5859 15.1393 12 15.1393H16C16.4141 15.1393 16.75 15.4753 16.75 15.8893C16.75 16.3034 16.4141 16.6393 16 16.6393ZM11.9496 6.74935C11.8859 6.11812 11.711 5.5256 11.4347 4.98586C11.4328 4.98214 11.4306 4.97866 11.4287 4.97493C11.295 4.71529 11.1436 4.46931 10.9682 4.2386C10.9493 4.21345 10.9277 4.19081 10.9084 4.16603C10.7456 3.95998 10.5735 3.76436 10.3808 3.58644C10.3284 3.53749 10.2698 3.49654 10.2153 3.4499C10.0436 3.30439 9.87061 3.16249 9.68018 3.04096C9.5785 2.97535 9.46735 2.92573 9.36072 2.86756C9.20044 2.78095 9.04431 2.68922 8.87409 2.62018C8.70771 2.55213 8.53028 2.50897 8.35529 2.45911C8.22767 2.42298 8.10614 2.3739 7.97455 2.34784C7.65936 2.28503 7.33423 2.24963 7 2.24963C4.23859 2.24963 2 4.48822 2 7.24963C2 7.55926 2.03613 7.85894 2.09094 8.15191C2.10089 8.20635 2.10779 8.26129 2.1195 8.31512C2.17516 8.5653 2.2525 8.80639 2.34472 9.04052C2.3839 9.1422 2.42541 9.24108 2.47088 9.33941C2.55792 9.5238 2.65325 9.70361 2.76153 9.87493C2.85119 10.0193 2.95086 10.154 3.05438 10.2881C3.07483 10.3143 3.09674 10.339 3.11761 10.3647C3.32867 10.6274 3.56347 10.8655 3.82269 11.0807C3.82263 11.0807 3.82275 11.0808 3.82269 11.0807C4.03375 11.256 4.25616 11.414 4.49438 11.553C4.51709 11.5665 4.54095 11.5776 4.56384 11.5908C4.78039 11.7126 5.00116 11.8243 5.2362 11.9133C5.33221 11.9509 5.4342 11.974 5.53301 12.0055C5.71044 12.0602 5.88433 12.121 6.06951 12.1559C6.37072 12.2149 6.68059 12.2496 6.99999 12.2496C9.7614 12.2496 12 10.011 12 7.24962C12 7.07823 11.9664 6.91629 11.9496 6.74935ZM9.5 7.87466H9.1618L8.73974 8.91372C8.64404 9.14907 8.41503 9.30337 8.16064 9.30337C7.90625 9.30337 7.67724 9.14907 7.58154 8.91372L7 7.48208L6.41846 8.91372C6.22705 9.38442 5.45166 9.38442 5.26026 8.91372L4.8382 7.87466H4.5C4.15479 7.87466 3.875 7.59439 3.875 7.24966C3.875 6.96041 4.07605 6.72738 4.34332 6.65634L4.09961 6.0563C3.96973 5.73599 4.12354 5.37173 4.44336 5.24185C4.76123 5.11099 5.12744 5.26626 5.25781 5.5856L5.83935 7.01724L6.42089 5.5856C6.6123 5.1149 7.38769 5.1149 7.57909 5.5856L8.16063 7.01724L8.74217 5.5856C8.87205 5.26626 9.23729 5.11099 9.55662 5.24185C9.87644 5.37173 10.0303 5.73599 9.90037 6.0563L9.65666 6.65634C9.92393 6.72738 10.125 6.96042 10.125 7.24966C10.125 7.59439 9.84521 7.87466 9.5 7.87466Z"
      fill="#141414"
    />
  </svg>
`;
export const DaumBlogIcon = ({ html = runeHtml, klass = '' }: IconProps = {}) => html`
  <svg
    class="${klass}"
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    height="100%"
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      d="M20.7446 10.7303C20.4724 10.7159 20.1987 10.7263 19.9256 10.7263C19.5606 10.7263 19.3419 10.5495 19.2694 10.1958C18.3197 5.55994 13.7053 2.49047 9.07452 3.41425C4.33246 4.36042 1.27375 8.8743 2.14944 13.6336C2.9849 18.1743 7.29929 21.2936 11.8834 20.6709C15.6693 20.1568 18.6719 17.2744 19.3216 13.5251C19.3519 13.3513 19.4005 13.2583 19.5992 13.2797C19.779 13.2991 19.9628 13.2837 20.1446 13.2837C20.3348 13.2837 20.5256 13.2891 20.7153 13.2827C21.4425 13.2563 21.9884 12.7232 21.9998 12.0324C22.0117 11.3261 21.4798 10.7691 20.7436 10.7308L20.7446 10.7303ZM7.93706 13.6709C7.90875 13.76 7.8402 13.8272 7.7652 13.8779C7.23422 14.2348 6.04958 14.296 5.61198 13.3459C5.19971 12.4505 5.63483 11.4625 6.5592 11.2375C6.67046 11.2106 6.78719 11.2076 6.90143 11.1937C7.17313 11.1992 7.42893 11.2569 7.66089 11.3973C7.85163 11.5132 7.90626 11.7133 7.79699 11.886C7.68275 12.0662 7.53324 12.0772 7.34797 11.9851C6.9511 11.788 6.59446 11.8487 6.39081 12.1334C6.18567 12.4206 6.2125 12.996 6.44346 13.2548C6.66102 13.4982 7.04994 13.5196 7.44979 13.3021C7.58589 13.2279 7.71255 13.2005 7.83772 13.3105C7.94848 13.4076 7.98127 13.5325 7.93706 13.6709ZM10.6064 14.086C10.3605 14.1452 10.1653 14.0681 10.0789 13.8003C9.74358 14.0447 9.38397 14.1243 8.99355 14.0487C8.64487 13.9815 8.41539 13.764 8.35777 13.436C8.29568 13.0826 8.38111 12.7755 8.68907 12.5629C9.0318 12.3265 9.42271 12.2877 9.82603 12.2922C9.90799 12.2932 10.0436 12.3763 10.0729 12.229C10.1012 12.0876 10.0287 11.9672 9.88912 11.9114C9.69143 11.8318 9.4843 11.8348 9.27916 11.8771C9.15846 11.902 9.04124 11.9448 8.92302 11.9811C8.74818 12.0349 8.6101 11.9926 8.5336 11.8198C8.45512 11.6422 8.49635 11.467 8.66871 11.3953C9.2424 11.1574 9.83249 11.0757 10.4171 11.358C10.7519 11.5197 10.8686 11.8263 10.8726 12.1797C10.8776 12.6515 10.8696 13.1239 10.8761 13.5957C10.8791 13.8172 10.8627 14.0238 10.6064 14.086ZM13.3517 10.5143C13.2916 10.6935 13.1505 10.7283 12.9712 10.6965C12.5942 10.6293 12.4501 10.7607 12.4675 11.119C12.473 11.229 12.5092 11.2649 12.6135 11.2589C12.7208 11.2529 12.8286 11.2539 12.9359 11.2589C13.1515 11.2694 13.2508 11.4087 13.2464 11.6028C13.2419 11.79 13.1336 11.898 12.928 11.9064C12.4705 11.9249 12.471 11.9298 12.471 12.4007C12.471 12.8397 12.473 13.2782 12.47 13.7172C12.468 13.9884 12.3558 14.1014 12.099 14.1014C11.8392 14.1014 11.7225 13.9879 11.7195 13.7251C11.7165 13.4519 11.719 13.1786 11.719 12.9054C11.719 12.6237 11.7145 12.3425 11.721 12.0607C11.7235 11.9463 11.6946 11.895 11.5695 11.902C11.34 11.9149 11.2307 11.7785 11.2352 11.5665C11.2392 11.3619 11.3574 11.244 11.5715 11.2594C11.6981 11.2684 11.7254 11.2101 11.7205 11.0986C11.7145 10.9667 11.723 10.8358 11.7577 10.7049C11.9162 10.1111 12.6866 9.79111 13.2195 10.1027C13.3849 10.1992 13.4053 10.3545 13.3517 10.5143ZM14.3068 13.096C14.4022 13.3135 14.5696 13.4295 14.8045 13.4484C15.0663 13.4698 15.3141 13.4235 15.5436 13.2896C15.6916 13.203 15.8322 13.2065 15.934 13.3588C16.0413 13.5196 16.0269 13.6898 15.8729 13.8018C15.4115 14.1382 14.8909 14.1855 14.362 14.0203C13.8657 13.8655 13.6 13.4832 13.5151 12.982C13.3805 12.1872 13.669 11.568 14.2845 11.2952C15.1279 10.9209 16.0582 11.5093 16.0418 12.4067C16.0359 12.7277 15.8993 12.8765 15.5744 12.8934C15.3767 12.9039 15.1775 12.8954 14.9794 12.8954C14.7976 12.8954 14.6148 12.9074 14.434 12.8934C14.2418 12.8785 14.2502 12.9666 14.3068 13.096Z"
      fill="#141414"
    />
    <path
      d="M9.79971 12.7909C9.66609 12.7969 9.53347 12.8213 9.40781 12.8591C9.23396 12.9119 9.11475 13.0199 9.14157 13.2185C9.16988 13.429 9.33628 13.4713 9.47884 13.4713C9.71179 13.4608 9.89905 13.4136 10.0173 13.2249C10.0868 13.1139 10.1101 12.986 10.0635 12.8705C10.0327 12.7944 9.91345 12.7859 9.79971 12.7909Z"
      fill="#141414"
    />
    <path
      d="M15.1383 12.3066C15.3454 12.3066 15.338 12.2235 15.262 12.0891C15.1467 11.885 14.959 11.8188 14.739 11.8462C14.4931 11.8766 14.3441 12.0214 14.2775 12.3036C14.582 12.3036 14.8611 12.3071 15.1383 12.3066Z"
      fill="#141414"
    />
  </svg>
`;
export const SpoonCastIcon = ({ html = runeHtml, klass = '' }: IconProps = {}) => html`
  <svg
    class="${klass}"
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    height="100%"
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      d="M17.3871 5.75851C16.1177 5.58632 14.9021 5.79689 13.7488 6.35031C13.3593 6.53729 12.9949 6.77017 12.6041 6.95533C11.5103 7.474 10.3633 7.8088 9.15709 7.94754C8.17218 8.06087 7.18938 8.05205 6.21105 7.89256C5.64427 7.80024 5.07932 7.76419 4.51227 7.86793C2.09487 8.30957 0.560279 10.5927 1.11259 12.9576C1.61202 15.0961 3.71971 16.505 5.96529 16.1443C7.00519 15.9773 8.04483 15.9321 9.09262 16.0478C10.5967 16.2138 12.0016 16.6725 13.3106 17.4202C14.7166 18.2234 16.2214 18.4765 17.8163 18.18C20.821 17.6217 22.9994 15.0201 23 12.0012C23.0029 10.995 22.7868 10.0344 22.3056 9.14851C21.2493 7.20533 19.6087 6.0596 17.3871 5.75851ZM5.37508 13.5232C4.9767 13.7177 4.5549 13.7543 4.12178 13.732C3.81444 13.7161 3.51342 13.6651 3.2216 13.565C3.02531 13.4975 3.00478 13.4713 3.00478 13.2672C3.00478 13.1894 3.00478 13.1116 3.00478 13.0338C3.00478 12.9345 3.00294 12.8352 3.00531 12.7359C3.00847 12.5956 3.07635 12.551 3.21003 12.6041C3.52421 12.7286 3.84523 12.8256 4.18625 12.8412C4.38412 12.8502 4.58095 12.8396 4.76698 12.7618C5.05695 12.6404 5.09353 12.3935 4.84908 12.2006C4.68962 12.0751 4.50148 12.003 4.3136 11.9312C4.03205 11.8235 3.76076 11.6967 3.49605 11.5518C2.7748 11.1568 2.72218 9.92444 3.56183 9.46879C3.97127 9.24654 4.40938 9.21101 4.86118 9.24499C5.10642 9.2634 5.34587 9.31241 5.57901 9.39229C5.69295 9.43119 5.74847 9.49809 5.74294 9.62283C5.73505 9.7997 5.74189 9.97708 5.74057 10.1542C5.73952 10.3173 5.67768 10.3557 5.52822 10.2904C5.1501 10.1249 4.75698 10.0712 4.3486 10.1423C4.29755 10.1511 4.24729 10.1698 4.19967 10.1905C3.89259 10.3236 3.85654 10.6075 4.12467 10.8067C4.30808 10.9431 4.52227 11.0219 4.73409 11.1039C5.02801 11.2177 5.30482 11.3606 5.56664 11.5383C6.17395 11.9503 6.18711 13.1267 5.37508 13.5232ZM9.67072 12.559C9.51363 13.1983 9.08209 13.5585 8.44242 13.6889C8.14034 13.7504 7.83432 13.7626 7.52961 13.698C7.44988 13.6811 7.41541 13.6925 7.41804 13.7869C7.42515 14.0416 7.4212 14.2965 7.42015 14.5512C7.41936 14.713 7.36384 14.7683 7.19859 14.7701C7.01019 14.7722 6.82178 14.7716 6.63338 14.7701C6.45787 14.7688 6.40735 14.719 6.40682 14.5445C6.40603 13.9527 6.40656 13.3611 6.40656 12.7693C6.40656 12.1993 6.41077 11.629 6.40393 11.059C6.40209 10.8969 6.46077 10.7922 6.60233 10.7128C7.27674 10.3355 7.98404 10.231 8.7245 10.4781C9.22129 10.6438 9.53074 10.9929 9.66151 11.495C9.75387 11.8489 9.75756 12.2055 9.67072 12.559ZM13.5119 12.6537C13.332 13.2535 12.8159 13.6508 12.1471 13.7195C11.8168 13.7535 11.4913 13.7429 11.1724 13.6479C10.5299 13.4566 10.1801 13.0185 10.0799 12.3754C10.0354 12.0909 10.0457 11.8064 10.1165 11.5271C10.2799 10.8819 10.7704 10.46 11.4479 10.3765C11.574 10.3609 11.6997 10.3427 11.8042 10.3495C12.0523 10.3474 12.2736 10.3736 12.4883 10.439C13.0441 10.608 13.3993 10.9701 13.5375 11.5284C13.6306 11.9044 13.6235 12.282 13.5119 12.6537ZM17.3766 12.6596C17.2171 13.1814 16.8558 13.5079 16.3296 13.6542C15.8988 13.774 15.4641 13.7735 15.0344 13.6456C14.3911 13.4542 14.0458 13.0113 13.9466 12.3684C13.9032 12.0881 13.9161 11.8082 13.9822 11.5328C14.1361 10.8917 14.6429 10.4561 15.3223 10.3757C15.4441 10.3612 15.5654 10.3433 15.6501 10.3484C15.9804 10.3495 16.2646 10.3897 16.5351 10.5028C16.9456 10.6744 17.2261 10.9683 17.3637 11.3855C17.5026 11.8072 17.5063 12.2354 17.3766 12.6596ZM21.0478 13.4213C21.0478 13.5605 20.9917 13.6145 20.8483 13.6155C20.651 13.6171 20.4539 13.6166 20.2565 13.6155C20.0945 13.6147 20.0445 13.5665 20.0445 13.4081C20.0437 12.933 20.0445 12.4576 20.0445 11.9825C20.0445 11.948 20.0445 11.9133 20.0445 11.8788C20.0416 11.3611 19.8213 11.1392 19.2343 11.2203C18.8851 11.2686 18.8869 11.2818 18.8869 11.6215C18.8869 12.2048 18.8869 12.788 18.8869 13.3712C18.8869 13.5673 18.8377 13.6155 18.6396 13.6155C18.4599 13.6155 18.2802 13.6158 18.1004 13.6155C17.9207 13.6153 17.8699 13.5642 17.8697 13.3824C17.8691 12.9936 17.8697 12.6046 17.8697 12.2159C17.8697 11.8228 17.8707 11.4296 17.8691 11.0365C17.8686 10.9299 17.8989 10.8399 17.9939 10.7815C18.697 10.3508 19.4469 10.2146 20.2416 10.4753C20.7433 10.6397 21.0428 11.0785 21.0475 11.6062C21.0528 12.211 21.0486 12.8163 21.0478 13.4213Z"
      fill="#141414"
    />
    <path
      d="M7.8801 11.1944C7.76669 11.2019 7.65513 11.2232 7.54329 11.2444C7.44988 11.2621 7.41357 11.2981 7.41778 11.3977C7.42673 11.6132 7.42041 11.8292 7.42041 12.045V12.4854C7.42041 12.7207 7.53935 12.854 7.77722 12.8855C8.24875 12.948 8.57583 12.7473 8.67529 12.331C8.7066 12.2003 8.7166 12.0665 8.70424 11.9325C8.65845 11.433 8.3569 11.163 7.8801 11.1944Z"
      fill="#141414"
    />
    <path
      d="M11.7931 11.1931C11.4261 11.2045 11.1703 11.4301 11.1019 11.7999C11.0716 11.9633 11.0722 12.1251 11.1019 12.2888C11.1687 12.6552 11.4277 12.8832 11.795 12.8946C12.1784 12.9065 12.4528 12.7035 12.5415 12.3378C12.5649 12.2413 12.5791 12.1428 12.5836 12.0419C12.5707 11.948 12.5647 11.8526 12.5436 11.7605C12.4581 11.3863 12.1836 11.1812 11.7931 11.1931Z"
      fill="#141414"
    />
    <path
      d="M16.4138 11.7665C16.3398 11.4192 16.0848 11.2061 15.733 11.1931C15.3544 11.1794 15.0915 11.365 14.9902 11.7182C14.9368 11.9044 14.9355 12.0919 14.9692 12.282C15.0342 12.6498 15.2907 12.8806 15.6562 12.8941C16.0409 12.9083 16.3151 12.7092 16.4074 12.344C16.4319 12.2478 16.4472 12.1493 16.4432 12.0492C16.4488 11.9535 16.4335 11.8593 16.4138 11.7665Z"
      fill="#141414"
    />
  </svg>
`;
export const BrunchIcon = ({ html = runeHtml, klass = '' }: IconProps = {}) => html`
  <svg
    class="${klass}"
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    height="100%"
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      d="M16.9189 2.14384C14.9091 3.06275 12.5116 7.26275 10.9732 10.0634C10.0689 11.7097 8.5378 14.3719 7.42988 16.2859C7.42988 16.2859 6.96463 16.1231 6.72378 15.8908C6.71524 15.8737 6.63902 16.2652 6.63902 16.2652C6.63902 16.2652 6.86524 16.4926 7.2378 16.6182C6.56098 17.7859 6.08415 18.603 6.08415 18.603C6.08415 18.603 6.01524 18.8438 6.24512 18.7176C6.47439 18.5914 7.51341 18.0688 7.63415 17.9603C7.75488 17.8512 7.65122 17.6676 7.67988 17.4384C7.70854 17.2091 8.02439 16.8646 8.02439 16.8646C8.02439 16.8646 10.6585 16.9853 13.3098 15.4701C15.961 13.9548 16.5122 11.6993 15.8579 10.8902C15.2037 10.081 13.7061 10.5634 12.7933 11.114C11.8811 11.6652 11.2177 12.2414 10.1591 13.2835C11.261 11.1487 13.2927 8.91031 14.0329 8.22189C14.7732 7.53348 14.6884 6.82128 14.5207 6.54628C15.2671 6.23653 16.1634 5.43226 16.5726 4.98531C17.5884 3.87494 18.5951 1.37799 16.9189 2.14384ZM11.2372 12.967C12.8098 11.578 14.0951 10.878 14.7152 11.2451C15.3354 11.6121 14.4628 14.0798 12.1902 15.2506C9.91768 16.4213 8.33354 16.3871 8.33354 16.3871C8.33354 16.3871 9.66524 14.3554 11.2372 12.967ZM15.8628 4.73775C15.2317 5.4725 13.8659 6.57982 13.8659 6.57982C13.8659 6.57982 14.061 6.82128 14.0323 7.07921C13.9921 7.44079 13.0854 8.22555 12.4768 8.72067C12.4768 8.72067 13.6244 6.74628 14.497 5.52982C15.3695 4.31336 16.8726 2.8097 16.8726 2.8097C16.8726 2.8097 16.4939 4.0036 15.8628 4.73775Z"
      fill="#141414"
    />
    <path d="M19.3982 20.3243H4.5V21.9999H19.3982V20.3243Z" fill="#141414" />
  </svg>
`;
export const BehanceIcon = ({ html = runeHtml, klass = '' }: IconProps = {}) => html`
  <svg
    class="${klass}"
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    height="100%"
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      d="M20.3211 7.41667H14.4917V5.75H20.3211V7.41667ZM21.7618 15.75C21.3954 16.8333 20.0713 18.25 17.5147 18.25C14.958 18.25 12.8844 16.8083 12.8844 13.5167C12.8844 10.225 14.8165 8.58333 17.4397 8.58333C20.063 8.58333 21.5703 10.0667 21.9201 12.275C21.9867 12.7 22.0117 13.2667 21.995 14.0583H15.3078C15.4161 16.7333 18.2059 16.8167 19.1302 15.75H21.7702H21.7618ZM15.3578 12.4167H19.4967C19.4134 11.125 18.5473 10.5667 17.4314 10.5667C16.2072 10.5667 15.5326 11.2083 15.3578 12.4167ZM7.38807 18.2417H2V5.76667H7.78781C12.3514 5.83333 12.4347 10.3 10.053 11.525C12.9344 12.575 13.0343 18.2417 7.37975 18.2417H7.38807ZM4.49833 10.75H7.47968C9.56995 10.75 9.90306 8.25 7.22152 8.25H4.49833V10.75ZM7.32145 13.25H4.49833V15.7667H7.27981C9.82811 15.7667 9.66989 13.25 7.32145 13.25Z"
      fill="#141414"
    />
  </svg>
`;
export const NaverWebtoonIcon = ({ html = runeHtml, klass = '' }: IconProps = {}) => html`
  <svg
    class="${klass}"
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    height="100%"
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      d="M16.3987 10.0386H15.4774V10.6911H16.3987C16.5789 10.6911 16.725 10.5451 16.725 10.3648C16.725 10.1846 16.579 10.0386 16.3987 10.0386Z"
      fill="#141414"
    />
    <path
      d="M10.5417 15.0478C11.0035 15.0478 11.3779 14.6156 11.3779 14.0824C11.3779 13.5491 11.0035 13.1169 10.5417 13.1169C10.0798 13.1169 9.70545 13.5491 9.70545 14.0824C9.70545 14.6156 10.0798 15.0478 10.5417 15.0478Z"
      fill="#141414"
    />
    <path
      d="M14.5875 14.8743C14.9914 14.8743 15.3188 14.4965 15.3188 14.0304C15.3188 13.5643 14.9914 13.1864 14.5875 13.1864C14.1836 13.1864 13.8562 13.5643 13.8562 14.0304C13.8562 14.4965 14.1836 14.8743 14.5875 14.8743Z"
      fill="#141414"
    />
    <path
      d="M16.5621 8.78024C16.5619 8.60001 16.4157 8.45355 16.2354 8.45355H15.4313V9.10601H16.2354C16.4156 9.10626 16.5619 8.96047 16.5621 8.78024Z"
      fill="#141414"
    />
    <path
      d="M20.0392 2.59998L3.96083 5.34158L5.13706 10.4331H2L5.13706 19.8336L12.5883 18.6584V21.4L20.8234 17.8752L22 10.8248H19.255L20.0392 2.59998ZM14.4755 7.65495C14.4755 7.65495 16.3505 7.50808 16.8088 7.5355C17.3111 7.50034 17.7468 7.87853 17.7819 8.3802C17.7844 8.41679 17.7848 8.45346 17.7829 8.49014C17.7992 8.88986 17.6212 9.27284 17.3049 9.51846C17.6812 9.72253 17.9011 10.1293 17.8658 10.5555C17.8566 11.3462 16.9833 11.5127 16.9833 11.5127H14.4754L14.4755 7.65495ZM11.4337 7.91175L14.0716 7.70996V8.60967L12.3341 8.66459V9.07786H13.8692V10.0966H12.3154V10.611H14.0712V11.5107L11.4333 11.4275L11.4337 7.91175ZM7.38045 8.13231L7.75253 9.99128L8.25003 8.0799L9.17376 8.0566L9.65626 9.99128L10.1666 7.91049H11.1454L10.2354 11.3117H9.17199L8.73076 9.61124L8.24994 11.3129H7.13326L6.31994 8.13231H7.38045ZM8.47414 13.181L7.38036 13.1585V16.1003L6.23117 16.1644V13.1345L4.93535 13.1078V12L8.47414 12.144V13.181ZM10.5429 16.1261H10.5417C9.41135 16.1261 8.49503 15.2109 8.49503 14.082C8.49503 12.9531 9.41135 12.0379 10.5417 12.0379C11.672 12.0379 12.5877 12.9523 12.5883 14.0808C12.589 15.2097 11.6733 16.1255 10.5429 16.1261ZM16.375 14.0304C16.3747 15.0166 15.5749 15.8162 14.5875 15.8173C13.5993 15.8183 12.7975 15.019 12.7966 14.0321C12.7957 13.0451 13.5959 12.2443 14.5841 12.2434C15.5723 12.2425 16.3741 13.0418 16.375 14.0287V14.0304ZM19.6996 12.3845L19.5537 15.4956H18.6737L17.6462 14.089V15.6262H16.6249V12.3386H17.6449L18.7158 14.0324V12.3845H19.6996Z"
      fill="#141414"
    />
  </svg>
`;
export const DaumWebtoonIcon = ({ html = runeHtml, klass = '' }: IconProps = {}) => html`
  <svg
    class="${klass}"
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    height="100%"
    viewBox="0 0 24 24"
    fill="none"
  >
    <path d="M20 4H4V8.79431H20V4Z" fill="#141414" />
    <path d="M20 9.60285H4V14.3972H20V9.60285Z" fill="#141414" />
    <path d="M20 15.2057H4V20H20V15.2057Z" fill="#141414" />
  </svg>
`;
export const KakaoPageIcon = ({ html = runeHtml, klass = '' }: IconProps = {}) => html`
  <svg
    class="${klass}"
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    height="100%"
    viewBox="0 0 16 16"
    fill="none"
  >
    <g clip-path="url(#clip0_10144_89011)">
      <path
        d="M0.138184 15.8617V0.138428H15.8614V9.53342L9.53317 15.8617H0.138184Z"
        stroke="#141414"
        stroke-width="0.25"
        stroke-miterlimit="10"
        stroke-linejoin="round"
      />
      <path d="M15.9864 9.58519V0.0134277H0.0131836V15.9867H9.58495V9.58519H15.9864Z" fill="#141414" />
    </g>
    <defs>
      <clipPath id="clip0_10144_89011">
        <rect width="16" height="16" fill="white" />
      </clipPath>
    </defs>
  </svg>
`;
export const NaverCafeIcon = ({ html = runeHtml, klass = '' }: IconProps = {}) => html`
  <svg
    class="${klass}"
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    height="100%"
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M3 13.9664C3 17.8512 6.15644 21 10.0507 21C13.0914 21 15.6825 19.0805 16.6714 16.39H17.7311C19.5364 16.39 21 14.93 21 13.1291C21 11.3282 19.5364 9.86813 17.7311 9.86813H3V13.9675V13.9664ZM17.0381 14.9104C17.0796 14.6011 17.1014 14.2865 17.1014 13.9664V11.3456H17.7311C18.7178 11.3456 19.5178 12.1437 19.5178 13.128C19.5178 14.1123 18.7178 14.9104 17.7311 14.9104H17.037H17.0381Z"
      fill="#141414"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M5.9447 7.68945H11.2502C13.8456 7.68945 15.951 5.59025 15.951 3H10.6455C8.04899 3 5.9447 5.0992 5.9447 7.68945Z"
      fill="#141414"
    />
  </svg>
`;
export const KakaoIcon = ({ html = runeHtml, klass = '' }: IconProps = {}) => html`
  <svg
    class="${klass}"
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    height="100%"
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M12.0001 3.59998C7.02919 3.59998 3 6.71295 3 10.5523C3 12.94 4.55841 15.045 6.93154 16.297L5.93304 19.9445C5.84482 20.2668 6.21343 20.5237 6.49648 20.337L10.8734 17.4482C11.2427 17.4839 11.6181 17.5047 12.0001 17.5047C16.9705 17.5047 21 14.3918 21 10.5523C21 6.71295 16.9705 3.59998 12.0001 3.59998Z"
      fill="#141414"
    />
  </svg>
`;
export const CietyIcon = ({ html = runeHtml, klass = '' }: IconProps = {}) => html`
  <svg
    class="${klass}"
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    height="100%"
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      d="M16.5 3H7.5C5.016 3 3 5.016 3 7.5V16.5C3 18.984 5.016 21 7.5 21H16.5C18.984 21 21 18.984 21 16.5V7.5C21 5.016 18.984 3 16.5 3ZM17.028 10.716C16.554 10.173 15.957 9.759 15.234 9.471C14.511 9.183 13.749 9.03 12.942 9.015C12.135 8.997 11.376 9.096 10.668 9.312C9.855 9.549 9.216 9.885 8.748 10.32C8.28 10.755 8.007 11.229 7.929 11.742C7.851 12.255 7.974 12.744 8.301 13.206C8.607 13.635 8.769 14.073 8.793 14.517C8.817 15.003 8.742 15.525 8.742 15.525C8.946 15.357 9.174 15.204 9.426 15.069C9.681 14.934 9.963 14.841 10.272 14.79C10.581 14.739 10.896 14.742 11.211 14.799C11.82 14.922 12.462 14.982 13.14 14.976C13.818 14.97 14.502 14.841 15.195 14.586C15.888 14.331 16.5 13.902 17.031 13.29V15.321C16.308 15.828 15.456 16.173 14.469 16.353C13.482 16.533 12.48 16.551 11.466 16.404C10.452 16.257 9.543 15.963 8.742 15.525C8.019 15.129 7.449 14.634 7.026 14.037C6.603 13.44 6.387 12.762 6.375 12.006C6.396 10.641 7.044 9.552 8.313 8.739C9.582 7.926 11.064 7.515 12.762 7.503C14.46 7.491 15.882 7.887 17.034 8.688V10.719L17.028 10.716Z"
      fill="#141414"
    />
  </svg>
`;

export const ExcelIcon = ({ html = runeHtml, klass = '' }: IconProps = {}) => html`
  <svg
    class="${klass}"
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    height="100%"
    viewBox="0 0 16 16"
    fill="none"
  >
    <g clip-path="url(#clip0_10110_10856)">
      <path
        d="M9.12732 1.33301H3.51398C2.86065 1.33301 2.33398 1.85967 2.33398 2.51301V13.4863C2.33398 14.1397 2.86065 14.6663 3.51398 14.6663H12.4873C13.1407 14.6663 13.6673 14.1397 13.6673 13.4863V5.87301L9.12732 1.33301ZM10.0807 11.5263C10.3073 11.753 10.3073 12.1263 10.0807 12.353C9.96732 12.4663 9.82065 12.5263 9.66732 12.5263C9.51398 12.5263 9.36732 12.473 9.25398 12.353L8.00065 11.0997L6.74732 12.353C6.63398 12.4663 6.48732 12.5263 6.33398 12.5263C6.18065 12.5263 6.03398 12.473 5.92065 12.353C5.69398 12.1263 5.69398 11.753 5.92065 11.5263L7.17398 10.273L5.92065 9.01967C5.69398 8.79301 5.69398 8.41967 5.92065 8.19301C6.14732 7.96634 6.52065 7.96634 6.74732 8.19301L8.00065 9.44634L9.25398 8.19301C9.48065 7.96634 9.85398 7.96634 10.0807 8.19301C10.3073 8.41967 10.3073 8.79301 10.0807 9.01967L8.82732 10.273L10.0807 11.5263ZM9.12732 5.87301V2.97967L12.0207 5.87301H9.12732Z"
        fill="currentColor"
      />
    </g>
    <defs>
      <clipPath id="clip0_10110_10856">
        <rect width="16" height="16" fill="white" />
      </clipPath>
    </defs>
  </svg>
`;

export const CalendarIcon = ({ html = runeHtml, klass = '' }: IconProps = {}) => html`
  <svg
    class="${klass}"
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    height="100%"
    viewBox="0 0 20 20"
    fill="none"
  >
    <g clip-path="url(#clip0_10477_17828)">
      <path
        d="M17.0823 3.54166H14.6073V2.39166C14.6073 1.99166 14.2823 1.65833 13.874 1.65833C13.4656 1.65833 13.1406 1.98333 13.1406 2.39166V3.54166H6.83229V2.39166C6.83229 1.99166 6.50729 1.65833 6.09896 1.65833C5.69063 1.65833 5.36563 1.98333 5.36563 2.39166V3.54166H2.89062C2.19896 3.54166 1.64062 4.09999 1.64062 4.79166V17.15C1.64062 17.8083 2.19896 18.3333 2.89062 18.3333H17.0573C17.749 18.3333 18.3073 17.8 18.3073 17.15V4.79166C18.3073 4.09999 17.749 3.54166 17.0573 3.54166H17.0823ZM11.874 14.2667H8.12396C7.72396 14.2667 7.39062 13.9417 7.39062 13.5333C7.39062 13.125 7.71562 12.8 8.12396 12.8H11.874C12.274 12.8 12.6073 13.125 12.6073 13.5333C12.6073 13.9417 12.2823 14.2667 11.874 14.2667ZM16.874 8.74999H3.12396V5.41666C3.12396 5.18333 3.30729 4.99999 3.54062 4.99999H5.39062V6.14166C5.39062 6.54166 5.71562 6.87499 6.12396 6.87499C6.53229 6.87499 6.85729 6.54999 6.85729 6.14166V4.99999H13.1656V6.14166C13.1656 6.54166 13.4906 6.87499 13.899 6.87499C14.3073 6.87499 14.6323 6.54999 14.6323 6.14166V4.99999H16.4823C16.7156 4.99999 16.899 5.18333 16.899 5.41666V8.74999H16.874Z"
        fill="currentColor"
      />
    </g>
    <defs>
      <clipPath id="clip0_10477_17828">
        <rect width="20" height="20" fill="white" />
      </clipPath>
    </defs>
  </svg>
`;

export const CheckIcon = ({ html = runeHtml, klass = '' }: IconProps = {}) => html`
  <svg
    class="${klass}"
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    height="100%"
    viewBox="0 0 16 16"
    fill="none"
  >
    <path
      d="M3.87277 7.1743C3.53088 6.83241 2.97656 6.83241 2.63467 7.1743C2.29278 7.5162 2.29278 8.07051 2.63467 8.4124L5.98754 11.7653C6.30091 12.0786 6.809 12.0786 7.12237 11.7653L13.3645 5.52316C13.7064 5.18127 13.7064 4.62695 13.3645 4.28506C13.0226 3.94317 12.4683 3.94317 12.1264 4.28506L6.96761 9.44384C6.73971 9.67174 6.3702 9.67174 6.1423 9.44384L3.87277 7.1743Z"
      fill="currentColor"
    />
  </svg>
`;

export const sortInActiveIcon = ({ html = runeHtml, klass = '' }: IconProps = {}) => html`
  <svg
    class="${klass}"
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    height="100%"
    viewBox="0 0 16 16"
    fill="none"
  >
    <path
      d="M5.31538 1.389C5.38871 1.41567 5.44871 1.46233 5.50204 1.51567L7.67538 3.689C7.90204 3.91567 7.90204 4.289 7.67538 4.51567C7.44871 4.74233 7.07538 4.74233 6.84871 4.51567L5.67538 3.34233L5.67538 14.089C5.67538 14.409 5.41538 14.6757 5.08871 14.6757C4.76204 14.6757 4.50204 14.4157 4.50204 14.089L4.50204 3.329L3.32871 4.50233C3.10204 4.729 2.72871 4.729 2.50204 4.50233C2.38871 4.389 2.32871 4.24233 2.32871 4.089C2.32871 3.93567 2.38871 3.789 2.50204 3.67567L4.67538 1.50233C4.72871 1.449 4.79538 1.40233 4.86871 1.37567C5.00871 1.31566 5.16871 1.31566 5.31538 1.37567L5.31538 1.389Z"
      fill="currentColor"
    />
    <path
      d="M10.702 14.629C10.6287 14.6023 10.5687 14.5557 10.5087 14.5023L8.33538 12.329C8.22204 12.2157 8.16204 12.069 8.16204 11.9157C8.16204 11.7623 8.22204 11.6157 8.33538 11.5023C8.56204 11.2757 8.93538 11.2757 9.16204 11.5023L10.3354 12.6757L10.3354 1.91567C10.3354 1.59567 10.5954 1.329 10.922 1.329C11.2487 1.329 11.5087 1.589 11.5087 1.91567L11.5087 12.6823L12.682 11.509C12.9087 11.2823 13.282 11.2823 13.5087 11.509C13.7354 11.7357 13.7354 12.109 13.5087 12.3357L11.3354 14.509C11.282 14.5623 11.2154 14.609 11.1487 14.6357C11.0087 14.6957 10.8487 14.6957 10.702 14.6357L10.702 14.629Z"
      fill="currentColor"
    />
  </svg>
`;

export const sortDescActiveIcon = ({ html = runeHtml, klass = '' }: IconProps = {}) => html`
  <svg
    class="${klass}"
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    height="100%"
    viewBox="0 0 17 16"
    fill="none"
  >
    <g clip-path="url(#clip0_10197_30773)">
      <path
        d="M12.8289 8.97005C12.6011 8.74219 12.2313 8.74219 12.0034 8.97005L8.99951 11.9745V2.58333C8.99951 2.26107 8.73844 2 8.41618 2C8.09391 2 7.83284 2.26107 7.83284 2.58333V11.9745L4.82894 8.97005C4.60107 8.74219 4.23128 8.74219 4.00342 8.97005C3.7762 9.19792 3.7762 9.56771 4.00342 9.79557L8.00342 13.7956C8.01388 13.806 8.02783 13.8096 8.03886 13.8191C8.08557 13.8595 8.13497 13.8971 8.19283 13.9211C8.26432 13.9506 8.34017 13.9662 8.41618 13.9662C8.49218 13.9662 8.56803 13.9506 8.63952 13.9211C8.69738 13.8971 8.74678 13.8595 8.7935 13.8191C8.80452 13.8096 8.81848 13.806 8.82894 13.7956L12.8289 9.79557C13.0562 9.56771 13.0562 9.19792 12.8289 8.97005Z"
        fill="currentColor"
      />
    </g>
    <defs>
      <clipPath id="clip0_10197_30773">
        <rect width="16" height="16" fill="white" transform="translate(0.5)" />
      </clipPath>
    </defs>
  </svg>
`;

export const sortAscActiveIcon = ({ html = runeHtml, klass = '' }: IconProps = {}) => html`
  <svg
    class="${klass}"
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    height="100%"
    viewBox="0 0 17 16"
    fill="none"
  >
    <g clip-path="url(#clip0_10197_30778)">
      <path
        d="M12.9128 6.17005L8.91276 2.17005C8.90711 2.1644 8.89941 2.16264 8.89355 2.15727C8.84359 2.11109 8.78768 2.07109 8.72387 2.04456C8.58089 1.98515 8.41979 1.98515 8.27681 2.04456C8.21289 2.07113 8.1569 2.11121 8.10685 2.15747C8.10107 2.1628 8.09347 2.16447 8.08789 2.17004L4.08789 6.17004C3.86003 6.39791 3.86003 6.76769 4.08789 6.99556C4.31576 7.22343 4.6849 7.22343 4.91276 6.99556L7.91699 3.99105V13.3823C7.91699 13.7045 8.17806 13.9656 8.50033 13.9656C8.82259 13.9656 9.08366 13.7045 9.08366 13.3823V3.99106L12.0879 6.99557C12.2018 7.1095 12.3509 7.16614 12.5003 7.16614C12.6497 7.16614 12.7988 7.1095 12.9128 6.99557C13.1406 6.7677 13.1406 6.39792 12.9128 6.17005Z"
        fill="currentColor"
      />
    </g>
    <defs>
      <clipPath id="clip0_10197_30778">
        <rect width="16" height="16" fill="white" transform="translate(0.5)" />
      </clipPath>
    </defs>
  </svg>
`;

export const typeFilterIcon = ({ html = runeHtml, klass = '' }: IconProps = {}) => html`
  <svg
    class="${klass}"
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    height="100%"
    viewBox="0 0 16 16"
    fill="none"
  >
    <g clip-path="url(#clip0_10197_27977)">
      <path
        d="M13.4008 2H2.60077C2.12677 2 1.84477 2.516 2.09077 2.918L6.38077 8.774C6.45877 8.876 6.49477 9.002 6.49477 9.128V14L9.49477 12.422V9.128C9.49477 9.002 9.53677 8.876 9.60877 8.774L13.8988 2.918C14.1508 2.516 13.8628 2 13.3888 2H13.4008Z"
        fill="currentColor"
      />
    </g>
    <defs>
      <clipPath id="clip0_10197_27977">
        <rect width="16" height="16" fill="white" />
      </clipPath>
    </defs>
  </svg>
`;

export const receiptIcon = ({ html = runeHtml, klass = '' }: IconProps = {}) => html`
  <svg
    class="${klass}"
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    height="100%"
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      d="M20.97 5.10002C20.91 4.83002 20.78 4.58002 20.59 4.39002C20.53 4.33002 20.46 4.27002 20.38 4.22002C20.16 4.07002 19.89 3.98002 19.6 3.98002H17.84C17.69 2.88002 16.74 2.02002 15.6 2.02002H8.4C7.25 2.02002 6.31 2.88002 6.16 3.98002H4.4C3.63 3.98002 3 4.61002 3 5.38002V20.58C3 21.35 3.63 21.98 4.4 21.98H19.6C20.37 21.98 21 21.35 21 20.58V5.38002C21 5.28002 21 5.19002 20.97 5.10002ZM7.88 4.29002C7.88 4.00002 8.12 3.77002 8.41 3.77002H15.61C15.9 3.77002 16.14 4.01002 16.14 4.29002V5.49002C16.14 5.78002 15.9 6.01002 15.61 6.01002H8.41C8.12 6.01002 7.88 5.77002 7.88 5.49002V4.29002ZM15.63 14.33L11.96 18.13C11.8 18.3 11.57 18.4 11.33 18.4C11.09 18.4 10.87 18.3 10.7 18.13L8.37 15.72C8.03 15.37 8.04 14.82 8.39 14.48C8.74 14.15 9.29 14.15 9.63 14.5L11.33 16.26L14.37 13.11C14.7 12.76 15.26 12.75 15.61 13.09C15.96 13.43 15.97 13.98 15.63 14.33ZM19.25 9.83002C19.25 10.05 19.07 10.23 18.85 10.23H5.15C4.93 10.23 4.75 10.05 4.75 9.83002V6.13002C4.75 6.07002 4.76 6.02002 4.78 5.97002C4.84 5.83002 4.98 5.73002 5.15 5.73002H6.15C6.27 6.87002 7.23 7.77002 8.4 7.77002H15.6C16.77 7.77002 17.73 6.87002 17.85 5.73002H18.85C19.07 5.73002 19.25 5.91002 19.25 6.13002V9.83002Z"
      fill="currentColor"
    />
  </svg>
`;

export const productPreparingIcon = ({ html = runeHtml, klass = '' }: IconProps = {}) => html`
  <svg
    class="${klass}"
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    height="100%"
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      d="M20.89 6.28L12.89 2.21C12.61 2.07 12.31 2 12 2C11.69 2 11.39 2.07 11.11 2.21L3.11 6.28C2.43 6.63 2 7.34 2 8.11V15.89C2 16.67 2.43 17.38 3.11 17.72L11.11 21.78C11.39 21.92 11.69 21.99 12 21.99C12.31 21.99 12.61 21.92 12.89 21.78L20.89 17.72C21.57 17.37 22 16.66 22 15.89V8.11C22 7.33 21.57 6.62 20.89 6.28ZM11.9 3.77C11.9 3.77 11.96 3.75 12 3.75C12.04 3.75 12.07 3.75 12.1 3.77L19.21 7.38L16.63 8.68L9.81 4.83L11.9 3.77ZM4.79 7.39L7.94 5.79L14.75 9.64L12 11.02L4.79 7.39ZM20.25 15.89C20.25 16.01 20.19 16.12 20.1 16.16L12.88 19.83V12.54L15.73 11.1V14.09C15.73 14.57 16.12 14.97 16.61 14.97C17.1 14.97 17.49 14.58 17.49 14.09V10.22L20.26 8.82V15.89H20.25Z"
      fill="currentColor"
    />
  </svg>
`;

export const deliveryIcon = ({ html = runeHtml, klass = '' }: IconProps = {}) => html`
  <svg
    class="${klass}"
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    height="100%"
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      d="M21.84 13.0801L19.21 7.99012C18.97 7.53012 18.49 7.23012 17.97 7.23012H17V4.77012C17 4.00012 16.37 3.37012 15.6 3.37012H3.4C2.63 3.37012 2 4.00012 2 4.77012V15.9701C2 16.7401 2.63 17.3701 3.4 17.3701H3.75C3.75 19.1601 5.21 20.6201 7 20.6201C7.45 20.6201 7.88 20.5301 8.27 20.3601C8.66 20.2001 9.01 19.9601 9.3 19.6601C9.89 19.0701 10.25 18.2601 10.25 17.3601H13.35C13.35 19.1501 14.81 20.6101 16.6 20.6101C17.05 20.6101 17.48 20.5201 17.87 20.3501C18.26 20.1901 18.61 19.9501 18.9 19.6501C19.49 19.0601 19.85 18.2501 19.85 17.3501H20.6C21.37 17.3501 22 16.7201 22 15.9501V13.7001C22 13.4801 21.95 13.2601 21.84 13.0601V13.0801ZM7 18.8801C6.17 18.8801 5.5 18.2101 5.5 17.3801C5.5 16.5501 6.17 15.8801 7 15.8801C7.83 15.8801 8.5 16.5501 8.5 17.3801C8.5 18.2101 7.83 18.8801 7 18.8801ZM14.12 7.15012H4.88C4.4 7.15012 4 6.76012 4 6.27012C4 5.78012 4.39 5.39012 4.88 5.39012H14.13C14.61 5.39012 15.01 5.78012 15.01 6.27012C15.01 6.76012 14.62 7.15012 14.13 7.15012H14.12ZM16.6 18.8801C15.77 18.8801 15.1 18.2101 15.1 17.3801C15.1 16.5501 15.77 15.8801 16.6 15.8801C17.43 15.8801 18.1 16.5501 18.1 17.3801C18.1 18.2101 17.43 18.8801 16.6 18.8801ZM19.15 12.4401H17V8.99012H17.34C17.34 8.99012 17.74 8.96012 17.97 9.41012L19.36 12.1001C19.44 12.2601 19.33 12.4401 19.15 12.4401Z"
      fill="currentColor"
    />
  </svg>
`;

export const deliveryCompletedIcon = ({ html = runeHtml, klass = '' }: IconProps = {}) => html`
  <svg
    class="${klass}"
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    height="100%"
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      d="M20.89 6.28L12.89 2.21C12.61 2.07 12.31 2 12 2C11.69 2 11.39 2.07 11.11 2.21L3.11 6.28C2.43 6.63 2 7.34 2 8.11V13.71C2 14.04 2.37 14.22 2.64 14.02C3.79 13.16 5.3 12.77 6.91 13.11C8.85 13.53 10.43 15.09 10.87 17.03C11.19 18.44 10.86 19.74 10.29 20.87C10.1 21.26 10.42 21.42 10.42 21.42L11.12 21.77C11.4 21.91 11.7 21.98 12.01 21.98C12.32 21.98 12.62 21.91 12.9 21.77L20.9 17.71C21.58 17.36 22.01 16.65 22.01 15.88V8.1C22.01 7.32 21.58 6.61 20.9 6.27L20.89 6.28ZM11.9 3.77C11.9 3.77 11.96 3.75 12 3.75C12.04 3.75 12.07 3.75 12.1 3.77L19.21 7.38L16.63 8.68L9.81 4.83L11.9 3.77ZM4.79 7.39L7.94 5.79L14.75 9.64L12 11.02L4.79 7.39ZM20.26 15.89H20.25C20.25 16.01 20.19 16.12 20.1 16.16L12.88 19.83V12.54L15.73 11.1V14.09C15.73 14.57 16.12 14.97 16.61 14.97C17.1 14.97 17.49 14.58 17.49 14.09V10.22L20.26 8.82V15.89Z"
      fill="currentColor"
    />
    <path
      d="M5.75 14.5C3.68 14.5 2 16.18 2 18.25C2 20.32 3.68 22 5.75 22C7.82 22 9.5 20.32 9.5 18.25C9.5 16.18 7.82 14.5 5.75 14.5ZM7.7 17.96L5.85 19.84C5.73 19.96 5.57 20.03 5.4 20.03C5.23 20.03 5.07 19.96 4.95 19.84L3.78 18.65C3.54 18.4 3.54 18.01 3.78 17.77C4.03 17.53 4.42 17.53 4.66 17.77L5.38 18.51L6.78 17.08C7.02 16.83 7.42 16.83 7.66 17.08C7.91 17.32 7.91 17.72 7.66 17.96H7.7Z"
      fill="currentColor"
    />
  </svg>
`;

export const confirmationIcon = ({ html = runeHtml, klass = '' }: IconProps = {}) => html`
  <svg
    class="${klass}"
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    height="100%"
    viewBox="0 0 24 24"
    fill="none"
  >
    <g clip-path="url(#clip0_3434_9978)">
      <path
        d="M20.74 9.75C20.4 9.4 20.06 9.04 19.92 8.72C19.8 8.43 19.79 7.94 19.78 7.48C19.77 6.61 19.75 5.62 19.07 4.93C18.39 4.24 17.4 4.23 16.52 4.22C16.05 4.22 15.57 4.21 15.28 4.08C14.96 3.95 14.6 3.6 14.25 3.26C13.63 2.67 12.93 2 12 2C11.07 2 10.37 2.67 9.75 3.26C9.4 3.6 9.04 3.94 8.72 4.08C8.43 4.2 7.94 4.21 7.48 4.22C6.61 4.23 5.62 4.25 4.93 4.93C4.24 5.61 4.23 6.6 4.22 7.48C4.22 7.95 4.21 8.43 4.08 8.72C3.95 9.04 3.6 9.4 3.26 9.75C2.67 10.37 2 11.07 2 12C2 12.93 2.67 13.63 3.26 14.25C3.6 14.6 3.94 14.96 4.08 15.28C4.2 15.57 4.21 16.06 4.22 16.52C4.23 17.39 4.25 18.38 4.93 19.07C5.62 19.76 6.6 19.77 7.48 19.78C7.95 19.78 8.43 19.79 8.72 19.92C9.04 20.05 9.4 20.4 9.75 20.74C10.37 21.33 11.07 22 12 22C12.93 22 13.63 21.33 14.25 20.74C14.6 20.4 14.96 20.06 15.28 19.92C15.57 19.8 16.06 19.79 16.52 19.78C17.39 19.77 18.38 19.75 19.07 19.07C19.76 18.38 19.77 17.4 19.78 16.52C19.78 16.05 19.79 15.57 19.92 15.28C20.05 14.96 20.4 14.6 20.74 14.25C21.33 13.63 22 12.93 22 12C22 11.07 21.33 10.37 20.74 9.75ZM16.74 10.09L11.77 15.29C11.58 15.49 11.32 15.6 11.05 15.6C10.78 15.6 10.52 15.49 10.33 15.29L7.26 12.08C6.88 11.68 6.89 11.05 7.29 10.67C7.69 10.29 8.32 10.3 8.7 10.7L11.05 13.15L15.3 8.71C15.68 8.31 16.32 8.3 16.71 8.68C17.11 9.06 17.12 9.69 16.74 10.09Z"
        fill="currentColor"
      />
    </g>
    <defs>
      <clipPath id="clip0_3434_9978">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
`;

export const smallXIcon = ({ html = runeHtml, klass = '' }: IconProps = {}) => html`
  <svg
    class="${klass}"
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    height="100%"
    viewBox="0 0 7 8"
    fill="none"
  >
    <rect
      x="0.332031"
      y="1.62939"
      width="1.3"
      height="8"
      rx="0.65"
      transform="rotate(-45 0.332031 1.62939)"
      fill="currentColor"
    />
    <rect
      x="0.332031"
      y="6.36719"
      width="8"
      height="1.3"
      rx="0.65"
      transform="rotate(-45 0.332031 6.36719)"
      fill="currentColor"
    />
  </svg>
`;

export const smallReturnIcon = ({ html = runeHtml, klass = '' }: IconProps = {}) => html`
  <svg
    class="${klass}"
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    height="100%"
    viewBox="0 0 11 10"
    fill="none"
  >
    <path
      d="M2.62109 7.35C2.26211 7.35 1.97109 7.64102 1.97109 8C1.97109 8.35898 2.26211 8.65 2.62109 8.65V7.35ZM1.62109 3.65H7.12109V2.35H1.62109V3.65ZM7.12109 7.35H2.62109V8.65H7.12109V7.35ZM8.97109 5.5C8.97109 6.52173 8.14282 7.35 7.12109 7.35V8.65C8.86079 8.65 10.2711 7.2397 10.2711 5.5H8.97109ZM7.12109 3.65C8.14282 3.65 8.97109 4.47827 8.97109 5.5H10.2711C10.2711 3.7603 8.86079 2.35 7.12109 2.35V3.65Z"
      fill="currentColor"
    />
    <path
      d="M3.62109 1L1.62109 3L3.62109 5"
      stroke="currentColor"
      stroke-width="1.3"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
`;

export const returnIcon = ({ html = runeHtml, klass = '' }: IconProps = {}) => html`
  <svg
    class="${klass}"
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    height="100%"
    viewBox="0 0 21 21"
    fill="none"
  >
    <g clip-path="url(#clip0_12603_12808)">
      <path
        d="M12.878 6.17074H4.59466L6.36966 4.39574C6.653 4.1124 6.653 3.64574 6.36966 3.3624C6.08633 3.07907 5.61966 3.07907 5.33633 3.3624L2.38633 6.3124C2.06133 6.6374 2.06133 7.1624 2.38633 7.4874L5.33633 10.4374C5.61966 10.7207 6.08633 10.7207 6.36966 10.4374C6.653 10.1541 6.653 9.6874 6.36966 9.40407L4.59466 7.62907H12.878C15.3447 7.62907 17.3613 9.6374 17.3613 12.1124C17.3613 14.5874 15.353 16.5957 12.878 16.5957H6.34466C5.94466 16.5957 5.61133 16.9207 5.61133 17.3291C5.61133 17.7374 5.93633 18.0624 6.34466 18.0624H12.878C16.153 18.0624 18.8113 15.3957 18.8113 12.1291C18.8113 8.8624 16.1447 6.19574 12.878 6.19574V6.17074Z"
        fill="currentColor"
      />
    </g>
    <defs>
      <clipPath id="clip0_12603_12808">
        <rect width="20" height="20" fill="white" transform="translate(0.478516 0.595703)" />
      </clipPath>
    </defs>
  </svg>
`;

export const checkCircleIcon = ({ html = runeHtml, klass = '' }: IconProps = {}) =>
  html`<svg
    class="${klass}"
    width="100%"
    height="100%"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM16.74 10.09L11.77 15.29C11.58 15.49 11.32 15.6 11.05 15.6C10.78 15.6 10.52 15.49 10.33 15.29L7.26 12.08C6.88 11.68 6.89 11.05 7.29 10.67C7.69 10.29 8.32 10.3 8.7 10.7L11.05 13.15L15.3 8.71C15.68 8.31 16.32 8.3 16.71 8.68C17.11 9.06 17.12 9.69 16.74 10.09Z"
      fill="currentColor"
    />
  </svg> `;

export const warningTriangleIcon = ({ html = runeHtml, klass = '' }: IconProps = {}) =>
  html`<svg
    class="${klass}"
    width="100%"
    height="100%"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_20540_166353)">
      <path
        d="M21.7508 17.8097L13.3008 4.46969C12.6908 3.49969 11.3008 3.49969 10.6808 4.46969L2.25081 17.8197C1.59081 18.8697 2.33081 20.2497 3.56081 20.2497H20.4408C21.6708 20.2497 22.4108 18.8697 21.7508 17.8097ZM12.0008 17.9197C11.5208 17.9197 11.1208 17.5297 11.1208 17.0397C11.1208 16.5497 11.5108 16.1597 12.0008 16.1597C12.4908 16.1597 12.8808 16.5497 12.8808 17.0397C12.8808 17.5297 12.4908 17.9197 12.0008 17.9197ZM12.8808 13.8297C12.8808 14.3097 12.4908 14.7097 12.0008 14.7097C11.5108 14.7097 11.1208 14.3197 11.1208 13.8297V9.33969C11.1208 8.85969 11.5108 8.45969 12.0008 8.45969C12.4908 8.45969 12.8808 8.84969 12.8808 9.33969V13.8297Z"
        fill="currentColor"
      />
    </g>
    <defs>
      <clipPath id="clip0_20540_166353">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg> `;

export const refundAcceptedIcon = ({ html = runeHtml, klass = '' }: IconProps = {}) => html`
  <svg
    class="${klass}"
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    height="100%"
    viewBox="0 0 21 21"
    fill="none"
  >
    <path
      d="M9.20289 16.2791C8.97789 16.2791 8.75289 16.1874 8.60289 16.0207L2.87789 10.0374C2.56123 9.70405 2.56956 9.17905 2.90289 8.85405C3.23623 8.53738 3.76123 8.54572 4.08623 8.87905L9.20289 14.2374L17.8696 5.17072C18.1862 4.83738 18.7196 4.82905 19.0529 5.14572C19.3862 5.46238 19.3946 5.99572 19.0779 6.32905L9.80289 16.0291C9.64456 16.1957 9.42789 16.2874 9.20289 16.2874V16.2791Z"
      fill="currentColor"
    />
  </svg>
`;

export const refundXIcon = ({ html = runeHtml, klass = '' }: IconProps = {}) => html`
  <svg
    class="${klass}"
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    height="100%"
    viewBox="0 0 21 21"
    fill="none"
  >
    <path
      d="M11.5271 10.5958L17.7601 4.35417C18.0513 4.0625 18.0513 3.59583 17.7601 3.3125C17.4688 3.02083 17.0028 3.02083 16.7115 3.3125L10.4785 9.54583L4.24551 3.3125C3.95424 3.02083 3.48822 3.02083 3.19696 3.3125C2.9057 3.60417 2.9057 4.07083 3.19696 4.35417L9.42997 10.5958L3.19696 16.8375C2.9057 17.1292 2.9057 17.5958 3.19696 17.8792C3.33843 18.0208 3.52983 18.0958 3.72123 18.0958C3.91263 18.0958 4.09571 18.0208 4.24551 17.8792L10.4785 11.6458L16.7115 17.8792C16.853 18.0208 17.0444 18.0958 17.2358 18.0958C17.4272 18.0958 17.6103 18.0208 17.7601 17.8792C18.0513 17.5875 18.0513 17.1208 17.7601 16.8375L11.5271 10.5958Z"
      fill="currentColor"
    />
  </svg>
`;
export const lightBulbIcon = ({ html = runeHtml, klass = '' }: IconProps = {}) => html`
  <svg
    class="${klass}"
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    height="100%"
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      d="M15.4104 20.2499H8.59045C8.11045 20.2499 7.71045 20.6399 7.71045 21.1299C7.71045 21.6199 8.10045 22.0099 8.59045 22.0099H15.4104C15.8904 22.0099 16.2905 21.6199 16.2905 21.1299C16.2905 20.6399 15.9004 20.2499 15.4104 20.2499Z"
      fill="currentColor"
    />
    <path
      d="M10.4604 2.14986C7.42045 2.73986 5.00045 5.20986 4.45045 8.24986C3.92045 11.1599 5.04045 13.8499 7.03045 15.5399C7.47045 15.9199 7.73045 16.4699 7.73045 17.0499V17.4999C7.73045 18.0499 8.18045 18.4999 8.73045 18.4999H15.3004C15.8504 18.4999 16.3004 18.0499 16.3004 17.4999V17.0499C16.3004 16.4699 16.5504 15.9199 17.0004 15.5399C18.6504 14.1299 19.7004 12.0299 19.7004 9.68986C19.7004 4.93986 15.3904 1.19986 10.4704 2.14986H10.4604ZM16.8304 8.59986C16.7204 8.64986 16.6004 8.66986 16.4904 8.66986C16.1504 8.66986 15.8204 8.46986 15.6804 8.13986C15.0504 6.65986 13.6104 5.69986 12.0004 5.69986C11.5204 5.69986 11.1204 5.30986 11.1204 4.81986C11.1204 4.32986 11.5104 3.93986 12.0004 3.93986C14.3104 3.93986 16.3904 5.31986 17.3004 7.44986C17.4904 7.88986 17.2804 8.40986 16.8404 8.59986H16.8304Z"
      fill="currentColor"
    />
  </svg>
`;

export const warningIcon = ({ html = runeHtml, klass = '' }: IconProps = {}) => html`
  <svg
    class="${klass}"
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    height="100%"
    viewBox="0 0 25 24"
    fill="none"
  >
    <g clip-path="url(#clip0_6784_6309)">
      <path
        d="M22.0828 17.8102L13.6328 4.47018C13.0228 3.50018 11.6328 3.50018 11.0128 4.47018L2.58284 17.8202C1.92284 18.8702 2.66284 20.2502 3.89284 20.2502H20.7728C22.0028 20.2502 22.7428 18.8702 22.0828 17.8102ZM12.3328 17.9202C11.8528 17.9202 11.4528 17.5302 11.4528 17.0402C11.4528 16.5502 11.8428 16.1602 12.3328 16.1602C12.8228 16.1602 13.2128 16.5502 13.2128 17.0402C13.2128 17.5302 12.8228 17.9202 12.3328 17.9202ZM13.2128 13.8302C13.2128 14.3102 12.8228 14.7102 12.3328 14.7102C11.8428 14.7102 11.4528 14.3202 11.4528 13.8302V9.34018C11.4528 8.86018 11.8428 8.46018 12.3328 8.46018C12.8228 8.46018 13.2128 8.85018 13.2128 9.34018V13.8302Z"
        fill="currentColor"
      />
    </g>
    <defs>
      <clipPath id="clip0_6784_6309">
        <rect width="24" height="24" fill="none" transform="translate(0.333008)" />
      </clipPath>
    </defs>
  </svg>
`;

export const clockIcon = ({ html = runeHtml, klass = '' }: IconProps = {}) => html`
  <svg
    class="${klass}"
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    height="100%"
    viewBox="0 0 25 24"
    fill="none"
  >
    <g clip-path="url(#clip0_6784_6320)">
      <path
        d="M12.667 2C7.14699 2 2.66699 6.48 2.66699 12C2.66699 17.52 7.14699 22 12.667 22C18.187 22 22.667 17.52 22.667 12C22.667 6.48 18.187 2 12.667 2ZM13.547 12.46L8.93699 15.69C8.78699 15.8 8.60699 15.85 8.43699 15.85C8.15699 15.85 7.88699 15.72 7.71699 15.48C7.43699 15.08 7.53699 14.54 7.92699 14.26L11.787 11.55V6.83C11.787 6.35 12.177 5.95 12.667 5.95C13.157 5.95 13.547 6.34 13.547 6.83V12.46Z"
        fill="currentColor"
      />
    </g>
    <defs>
      <clipPath id="clip0_6784_6320">
        <rect width="24" height="24" fill="none" transform="translate(0.666992)" />
      </clipPath>
    </defs>
  </svg>
`;

export const designThemeIcon = ({ html = runeHtml, klass = '' }: IconProps = {}) => html`
  <svg
    class="${klass}"
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    height="100%"
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 12.515 21.685 12.8866 21.3024 13.0619C20.9305 13.2324 20.4688 13.2356 20.0706 13.0347C19.3628 12.6776 18.5628 12.4762 17.7143 12.4762C14.8214 12.4762 12.4762 14.8214 12.4762 17.7143C12.4762 18.5628 12.6776 19.3628 13.0347 20.0706C13.2356 20.4688 13.2324 20.9305 13.0619 21.3024C12.8866 21.685 12.515 22 12 22C6.47715 22 2 17.5228 2 12ZM12 2.95238C7.00314 2.95238 2.95238 7.00314 2.95238 12C2.95238 16.9969 7.00314 21.0476 12 21.0476C12.0811 21.0476 12.1486 21.0093 12.1961 20.9056C12.2486 20.7912 12.252 20.6336 12.1844 20.4996C11.7617 19.6619 11.5238 18.7152 11.5238 17.7143C11.5238 14.2954 14.2954 11.5238 17.7143 11.5238C18.7152 11.5238 19.6619 11.7617 20.4996 12.1844C20.6336 12.252 20.7912 12.2486 20.9056 12.1961C21.0093 12.1486 21.0476 12.0811 21.0476 12C21.0476 7.00314 16.9969 2.95238 12 2.95238ZM12.4762 7.71429C12.4762 6.66231 13.329 5.80952 14.381 5.80952C15.4329 5.80952 16.2857 6.66231 16.2857 7.71429C16.2857 8.76626 15.4329 9.61905 14.381 9.61905C13.329 9.61905 12.4762 8.76626 12.4762 7.71429ZM14.381 6.7619C13.855 6.7619 13.4286 7.1883 13.4286 7.71429C13.4286 8.24027 13.855 8.66667 14.381 8.66667C14.9069 8.66667 15.3333 8.24027 15.3333 7.71429C15.3333 7.1883 14.9069 6.7619 14.381 6.7619ZM6.7619 8.66667C6.7619 7.6147 7.6147 6.7619 8.66667 6.7619C9.71864 6.7619 10.5714 7.6147 10.5714 8.66667C10.5714 9.71864 9.71864 10.5714 8.66667 10.5714C7.6147 10.5714 6.7619 9.71864 6.7619 8.66667ZM8.66667 7.71429C8.14068 7.71429 7.71429 8.14068 7.71429 8.66667C7.71429 9.19265 8.14068 9.61905 8.66667 9.61905C9.19265 9.61905 9.61905 9.19265 9.61905 8.66667C9.61905 8.14068 9.19265 7.71429 8.66667 7.71429ZM7.71429 13.4286C7.1883 13.4286 6.7619 13.855 6.7619 14.381C6.7619 14.9069 7.1883 15.3333 7.71429 15.3333C8.24027 15.3333 8.66667 14.9069 8.66667 14.381C8.66667 13.855 8.24027 13.4286 7.71429 13.4286ZM5.80952 14.381C5.80952 13.329 6.66231 12.4762 7.71429 12.4762C8.76626 12.4762 9.61905 13.329 9.61905 14.381C9.61905 15.4329 8.76626 16.2857 7.71429 16.2857C6.66231 16.2857 5.80952 15.4329 5.80952 14.381Z"
      fill="currentColor"
    />
  </svg>
`;

export const rightArrowIcon = ({ html = runeHtml, klass = '' }: IconProps = {}) => html`
  <svg
    class="${klass}"
    width="17"
    height="8"
    viewBox="0 0 17 8"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_19290_142528)">
      <path
        d="M11.7896 6.96002C11.9496 6.54402 12.1256 6.16002 12.3176 5.80802C12.5096 5.44002 12.7256 5.09602 12.9656 4.77602H0.101562V2.80802H12.9656C12.7416 2.48802 12.5336 2.15202 12.3416 1.80002C12.1496 1.43202 11.9736 1.04002 11.8136 0.624023H13.6376C14.6296 1.79202 15.7176 2.68002 16.9016 3.28802V4.32002C15.7176 4.89602 14.6296 5.77602 13.6376 6.96002H11.7896Z"
        fill="#141414"
      />
    </g>
    <defs>
      <clipPath id="clip0_19290_142528">
        <rect width="17" height="7" fill="white" transform="translate(0 0.25)" />
      </clipPath>
    </defs>
  </svg>
`;

export const linkArrowIcon = ({ html = runeHtml, klass = '' }: IconProps = {}) => html`
  <svg
    class="${klass}"
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect
      x="3.22656"
      y="11.7109"
      width="11"
      height="1.5"
      transform="rotate(-45 3.22656 11.7109)"
      fill="#1C75FF"
    />
    <rect x="4.23828" y="3.75586" width="8" height="1.5" fill="#1C75FF" />
    <path d="M10.7393 3.7627H12.2393V11.7627H10.7393V3.7627Z" fill="#1C75FF" />
  </svg>
`;

export const goodsPartnerLogoIcon = ({ html = runeHtml, klass = '' }: IconProps = {}) =>
  html`<svg
    class="${klass}"
    width="215"
    height="24"
    viewBox="0 0 215 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12.0997 0.00819439C11.9859 0.00819439 11.8869 0.0901383 11.8652 0.203494L8.80508 16.4338C8.78069 16.5636 8.59637 16.5636 8.57062 16.4338L5.51182 0.203494C5.49013 0.0901383 5.39255 0.00819439 5.27736 0.00819439H0.238525C0.107065 0.00819439 0 0.116087 0 0.248563V23.7596C0 23.8921 0.107065 24 0.238525 24H3.33392C3.46538 24 3.57245 23.8921 3.57245 23.7596V8.417C3.57245 8.27224 3.7798 8.25175 3.80826 8.39379L6.86707 23.8061C6.88875 23.9181 6.98769 23.9986 7.10017 23.9986H10.281C10.3948 23.9986 10.4924 23.9181 10.5141 23.8061L13.5729 8.39379C13.6013 8.25175 13.8087 8.27224 13.8087 8.417V23.7596C13.8087 23.8921 13.9157 24 14.0472 24H17.1426C17.2741 24 17.3811 23.8921 17.3811 23.7596V0.248563C17.3811 0.116087 17.2741 0.00819439 17.1426 0.00819439H12.0997Z"
      fill="white"
    />
    <path
      d="M45.4118 4.33347C44.2355 1.41353 41.6402 0 39.0503 0C36.6935 0 34.3421 1.16907 33.0682 3.43618C33.0438 3.47988 33.018 3.52222 32.9923 3.56866C32.9733 3.60143 32.9394 3.61782 32.9056 3.61782C32.8717 3.61782 32.8378 3.60143 32.8188 3.56866C32.7917 3.52222 32.766 3.47988 32.7429 3.43618C31.4663 1.16907 29.1149 0 26.7581 0C24.1682 0 21.5716 1.41353 20.3966 4.33347C19.6146 6.27417 19.6661 8.2736 20.2163 10.273C20.4061 10.9627 20.65 11.6224 20.9373 12.2574C21.2748 13.0045 21.6746 13.7174 22.1259 14.4016C22.1354 14.4153 22.1747 14.4754 22.1855 14.4904C22.4593 14.9001 22.7493 15.2989 23.0556 15.6909C25.743 19.1161 29.0756 21.7575 32.7632 23.959C32.7985 23.9795 32.8608 23.9973 32.9028 23.9973C32.9449 23.9973 33.0085 23.9795 33.0424 23.959C36.7301 21.7575 40.064 19.1161 42.7501 15.6909C43.0564 15.3003 43.3478 14.9001 43.6202 14.4904C43.631 14.474 43.6703 14.4153 43.6798 14.4016C44.1311 13.7174 44.5309 13.0045 44.8684 12.2574C45.1557 11.6224 45.3996 10.9614 45.5894 10.273C46.1396 8.27224 46.1911 6.27417 45.4091 4.33347H45.4118ZM37.7872 1.82462C38.1924 1.73038 38.6139 1.67985 39.0489 1.67985C40.0667 1.67985 41.0398 1.95982 41.8651 2.48836C42.7637 3.0647 43.4372 3.8978 43.8668 4.96443V4.9658C43.917 5.09145 43.9305 5.23212 43.898 5.36323C43.7042 6.12667 42.6498 6.93928 40.991 7.58254C40.5492 7.75326 40.0762 7.90759 39.5788 8.04689C39.5151 8.06464 39.4514 8.01684 39.4501 7.94992C39.4379 7.02942 39.3471 6.11711 39.1573 5.21709C38.847 3.74347 38.3374 2.67274 37.7357 1.98987C37.6855 1.93251 37.7126 1.84101 37.7872 1.82462ZM29.8318 2.75878C30.0758 2.75878 30.767 3.28185 31.225 4.83879C31.2427 4.90024 31.3118 5.12422 31.3118 5.12422C31.5273 5.82894 32.1737 6.30968 32.9056 6.30968C33.6374 6.30968 34.2838 5.82894 34.4993 5.12422C34.4993 5.12422 34.5684 4.90024 34.5861 4.83879C35.0441 3.28322 35.734 2.75878 35.9793 2.75878C36.2801 2.75878 37.0865 3.46623 37.5297 5.56672C37.7153 6.44898 37.8007 7.37905 37.7872 8.3733C37.7872 8.42247 37.7519 8.4648 37.7031 8.473C36.2219 8.73658 34.5942 8.87589 32.9069 8.87589C31.2196 8.87589 29.5906 8.73658 28.1107 8.473C28.0632 8.4648 28.028 8.42247 28.0266 8.3733C28.0131 7.37905 28.0985 6.44898 28.2841 5.56672C28.7273 3.46623 29.5337 2.75878 29.8345 2.75878H29.8318ZM37.6435 10.3058C37.63 10.4192 37.6137 10.5339 37.5974 10.6486C37.3616 12.2889 36.932 13.8512 36.2869 15.4218C36.2571 15.4942 36.1893 15.5448 36.1121 15.5543C35.0889 15.6868 34.0101 15.7564 32.9028 15.7564C31.7956 15.7564 30.7182 15.6868 29.6936 15.5543C29.6164 15.5448 29.5486 15.4942 29.5188 15.4218C28.8737 13.8499 28.4454 12.2889 28.2082 10.6486C28.192 10.5339 28.1771 10.4192 28.1622 10.3058C28.154 10.2389 28.211 10.1829 28.2774 10.1938C29.7695 10.4328 31.347 10.5544 32.9015 10.5544C34.456 10.5544 36.0335 10.4328 37.5256 10.1938C37.592 10.1829 37.6503 10.2389 37.6408 10.3058H37.6435ZM21.9402 4.9658V4.96443C22.3698 3.8978 23.0434 3.0647 23.9419 2.48836C24.7673 1.95982 25.7403 1.67985 26.7581 1.67985C27.1932 1.67985 27.616 1.72902 28.0199 1.82462C28.093 1.84237 28.1215 1.93388 28.0714 1.98987C27.4696 2.67274 26.9601 3.74484 26.6497 5.21709C26.46 6.11711 26.3692 7.03079 26.357 7.94992C26.357 8.01684 26.2933 8.06464 26.2282 8.04689C25.7308 7.90759 25.2565 7.75326 24.816 7.58254C23.1586 6.93928 22.1028 6.12667 21.909 5.36323C21.8751 5.23212 21.8887 5.09145 21.9402 4.9658ZM25.3121 14.4481C25.3039 14.4453 25.2972 14.4412 25.289 14.4385C24.1059 13.9387 23.1504 13.0113 22.588 11.8491C22.569 11.8108 22.3793 11.3957 22.3766 11.3888C22.1516 10.8726 21.9673 10.3522 21.8223 9.82507C21.6298 9.12445 21.5174 8.45798 21.4835 7.82291C21.4794 7.73414 21.5783 7.68224 21.6475 7.73687C22.7588 8.64235 24.4298 9.33751 26.3637 9.81142C26.4058 9.82098 26.4356 9.85648 26.4396 9.90019C26.4708 10.2307 26.5115 10.5612 26.5589 10.8917C26.7757 12.394 27.1308 13.7516 27.5781 15.0121C27.6052 15.0886 27.5374 15.1651 27.4588 15.146C26.6836 14.9548 25.9612 14.7226 25.3107 14.4494L25.3121 14.4481ZM29.592 19.7881C28.337 18.8157 27.2013 17.7996 26.1754 16.7316C26.1035 16.6565 26.1754 16.5335 26.2757 16.5622C26.9329 16.7548 27.6295 16.9173 28.3573 17.0484C28.3898 17.0539 28.417 17.0757 28.4305 17.1058C28.8425 18.014 29.2802 18.8608 29.741 19.6556C29.7966 19.7526 29.68 19.855 29.592 19.7867V19.7881ZM35.3409 17.4855C34.6538 18.8416 33.8746 20.1063 32.9855 21.2945C32.9449 21.3491 32.8635 21.3491 32.8229 21.2945C31.9338 20.1049 31.1532 18.8403 30.4675 17.4855C30.4309 17.4144 30.4878 17.3311 30.5664 17.338C31.328 17.4035 32.1114 17.439 32.9042 17.439C33.697 17.439 34.4804 17.4035 35.242 17.338C35.3206 17.3311 35.3775 17.4144 35.3409 17.4855ZM39.6317 16.7316C38.6057 17.7996 37.47 18.8157 36.2151 19.7881C36.127 19.8564 36.0091 19.7526 36.066 19.657C36.5268 18.8621 36.9645 18.0154 37.3765 17.1072C37.3901 17.0771 37.4172 17.0553 37.4497 17.0498C38.1775 16.9187 38.8754 16.7562 39.5314 16.5636C39.6317 16.5349 39.7035 16.6565 39.6317 16.7329V16.7316ZM43.9847 9.82507C43.8397 10.3522 43.6554 10.8726 43.4305 11.3888C43.4277 11.3957 43.238 11.8095 43.219 11.8491C42.658 13.0113 41.7011 13.9387 40.518 14.4385C40.5099 14.4412 40.5031 14.4453 40.495 14.4481C39.8445 14.7212 39.1221 14.9534 38.3469 15.1446C38.2683 15.1637 38.2005 15.0872 38.2276 15.0108C38.6749 13.7502 39.0299 12.3926 39.2468 10.8903C39.2942 10.5598 39.3349 10.2293 39.366 9.89882C39.3701 9.85649 39.4013 9.82098 39.4419 9.81005C41.3759 9.33614 43.0469 8.64098 44.1582 7.7355C44.226 7.67951 44.3263 7.73277 44.3222 7.82154C44.2883 8.45798 44.1758 9.12309 43.9834 9.82371L43.9847 9.82507Z"
      fill="white"
    />
    <path
      d="M209.996 23C206.669 23 204.777 21.2278 204.777 18.2639V17.775H207.982V18.2945C207.982 19.6083 208.683 20.2194 209.843 20.2194C210.942 20.2194 211.674 19.7 211.674 18.4472C211.674 17.1945 210.484 16.7361 208.958 16.1861C207.005 15.4528 204.961 14.4445 204.961 11.3889C204.961 8.63891 206.639 6.8667 209.812 6.8667C212.772 6.8667 214.695 8.5778 214.695 11.3889V11.6945H211.552V11.3278C211.552 10.1667 210.942 9.61669 209.843 9.61669C208.958 9.61669 208.195 10.075 208.195 11.2361C208.195 12.55 209.385 13.0084 211.003 13.6195C212.956 14.3528 215 15.3 215 18.2639C215 21.1667 213.291 23 209.996 23Z"
      fill="white"
    />
    <path
      d="M202.441 6.8667C202.899 6.8667 203.234 6.92781 203.479 7.05003V10.2889C203.204 10.2278 202.868 10.1972 202.533 10.1972C200.427 10.1972 199.328 11.5722 199.328 14.2V22.6944H195.972V7.17225H198.871L198.932 10.0445C199.451 7.90558 200.641 6.8667 202.441 6.8667Z"
      fill="white"
    />
    <path
      d="M188.073 6.8667C191.521 6.8667 193.413 8.79169 193.413 12.2445V15.6667H186.059V17.9583C186.059 19.425 186.761 20.1278 188.134 20.1278C189.507 20.1278 190.209 19.425 190.209 17.9278V17.6222H193.413V17.775C193.413 21.0444 191.491 23 188.073 23C184.594 23 182.702 21.0444 182.702 17.6222V12.2445C182.702 8.79169 184.594 6.8667 188.073 6.8667ZM186.059 13.1306H190.148V11.8778C190.148 10.4111 189.416 9.70836 188.103 9.70836C186.791 9.70836 186.059 10.4111 186.059 11.8778V13.1306Z"
      fill="white"
    />
    <path
      d="M176.312 6.8667C178.814 6.8667 180.187 8.42503 180.187 11.6945V22.6944H176.861V12.1834C176.861 10.5334 176.342 9.80002 175.091 9.80002C173.779 9.80002 172.985 10.6861 172.985 12.7334V22.6944H169.629V7.17225H172.558L172.589 9.46391C173.199 7.81392 174.511 6.8667 176.312 6.8667Z"
      fill="white"
    />
    <path
      d="M167.356 9.95274H164.518V18.3555C164.518 19.5472 164.945 20.0361 166.044 20.0361C166.441 20.0361 166.868 19.9749 167.356 19.7916V22.6333C166.715 22.9083 166.136 22.9999 165.373 22.9999C162.535 22.9999 161.192 21.5944 161.192 18.7833V9.95274H159.117V7.17219H161.314L161.589 3.01664H164.518V7.17219H167.356V9.95274Z"
      fill="white"
    />
    <path
      d="M156.818 6.8667C157.275 6.8667 157.611 6.92781 157.855 7.05003V10.2889C157.58 10.2278 157.245 10.1972 156.909 10.1972C154.804 10.1972 153.705 11.5722 153.705 14.2V22.6944H150.348V7.17225H153.247L153.308 10.0445C153.827 7.90558 155.017 6.8667 156.818 6.8667Z"
      fill="white"
    />
    <path
      d="M147.819 22.6944H144.737C144.615 22.5111 144.493 21.625 144.462 20.4028C143.882 22.0222 142.57 23 140.648 23C138.298 23 136.803 21.4722 136.803 18.9972C136.803 16.6139 137.84 15.0861 140.983 13.9861C143.699 13.0389 144.096 12.7028 144.096 11.7556V11.6028C144.096 10.2889 143.547 9.6778 142.357 9.6778C141.044 9.6778 140.465 10.4417 140.465 11.7556V12.0306H137.352V11.8472C137.352 8.70002 139.122 6.8667 142.387 6.8667C146.018 6.8667 147.422 8.76114 147.422 12.275V18.1722C147.422 20.4028 147.575 21.8083 147.819 22.6944ZM141.807 20.1889C143.15 20.1889 144.096 19.2417 144.096 17.1945V15.0861C143.76 15.4222 143.119 15.7278 141.99 16.1861C140.648 16.7361 140.129 17.4695 140.129 18.4778C140.129 19.5778 140.678 20.1889 141.807 20.1889Z"
      fill="white"
    />
    <path
      d="M124.304 22.6944V1.30554H129.827C133.642 1.30554 135.442 3.13887 135.442 6.86664V8.45553C135.442 12.1833 133.642 14.0166 129.827 14.0166H127.783V22.6944H124.304ZM127.783 10.9611H129.827C131.323 10.9611 131.963 10.2889 131.963 8.5472V6.74442C131.963 5.03331 131.323 4.39165 129.827 4.39165H127.783V10.9611Z"
      fill="white"
    />
    <path
      d="M111.776 23C108.449 23 106.557 21.2278 106.557 18.2639V17.775H109.762V18.2945C109.762 19.6083 110.463 20.2194 111.623 20.2194C112.721 20.2194 113.454 19.7 113.454 18.4472C113.454 17.1945 112.264 16.7361 110.738 16.1861C108.785 15.4528 106.741 14.4445 106.741 11.3889C106.741 8.63891 108.419 6.8667 111.592 6.8667C114.552 6.8667 116.475 8.5778 116.475 11.3889V11.6945H113.332V11.3278C113.332 10.1667 112.721 9.61669 111.623 9.61669C110.738 9.61669 109.975 10.075 109.975 11.2361C109.975 12.55 111.165 13.0084 112.783 13.6195C114.735 14.3528 116.78 15.3 116.78 18.2639C116.78 21.1667 115.071 23 111.776 23Z"
      fill="white"
    />
    <path
      d="M104.591 22.6944H101.509C101.356 22.5111 101.234 21.6555 101.204 20.4333C100.593 22.0527 99.2506 22.9999 97.4502 22.9999C94.948 22.9999 93.5138 21.4416 93.5138 18.1416V11.6944C93.5138 8.42497 94.948 6.86664 97.4502 6.86664C98.9149 6.86664 100.105 7.50831 100.807 8.63886V1.30554H104.164V18.1722C104.164 20.4027 104.347 21.8083 104.591 22.6944ZM98.6708 20.0666C99.983 20.0666 100.807 19.15 100.807 17.1333V12.7333C100.807 10.7166 99.983 9.79997 98.6708 9.79997C97.3587 9.79997 96.8704 10.5944 96.8704 12.1222V17.7444C96.8704 19.2416 97.3587 20.0666 98.6708 20.0666Z"
      fill="white"
    />
    <path
      d="M85.8285 23C82.4414 23 80.5189 21.0444 80.5189 17.6222V12.2445C80.5189 8.79169 82.4414 6.8667 85.8285 6.8667C89.2462 6.8667 91.1686 8.79169 91.1686 12.2445V17.6222C91.1686 21.0444 89.2462 23 85.8285 23ZM85.8285 20.0667C87.2017 20.0667 87.812 19.2111 87.812 17.8972V11.9695C87.812 10.6556 87.2017 9.80002 85.8285 9.80002C84.4553 9.80002 83.8756 10.6556 83.8756 11.9695V17.8972C83.8756 19.2111 84.4859 20.0667 85.8285 20.0667Z"
      fill="white"
    />
    <path
      d="M72.9252 23C69.5381 23 67.6156 21.0444 67.6156 17.6222V12.2445C67.6156 8.79169 69.5381 6.8667 72.9252 6.8667C76.3429 6.8667 78.2653 8.79169 78.2653 12.2445V17.6222C78.2653 21.0444 76.3429 23 72.9252 23ZM72.9252 20.0667C74.2984 20.0667 74.9087 19.2111 74.9087 17.8972V11.9695C74.9087 10.6556 74.2984 9.80002 72.9252 9.80002C71.5521 9.80002 70.9723 10.6556 70.9723 11.9695V17.8972C70.9723 19.2111 71.5826 20.0667 72.9252 20.0667Z"
      fill="white"
    />
    <path
      d="M59.6148 23C56.014 23 54 20.9222 54 17.2861V6.74443C54 3.07777 55.9835 1 59.6148 1C63.2155 1 65.2295 3.07777 65.2295 6.74443V8.24165H61.9644V6.5611C61.9644 4.88055 61.1405 4.08611 59.7063 4.08611C58.2721 4.08611 57.4787 4.88055 57.4787 6.5611V17.4389C57.4787 19.1194 58.2721 19.9139 59.7063 19.9139C61.1405 19.9139 61.9644 19.1194 61.9644 17.4389V13.8028H59.8284V10.6555H65.2295V17.2861C65.2295 20.9222 63.2155 23 59.6148 23Z"
      fill="white"
    />
  </svg> `;
export const key_visual_3d_icon_urls = {
  malove: '//s3.marpple.co/files/u_4648126/2025/1/original/473ecd80ccba9526ee479968e59e170610ac8bb939.webp',
  malove_popular_creator:
    '//s3.marpple.co/files/u_4648126/2025/1/original/46bd8d341ead5e681b5bb71588c3b01848ea478136.webp',
  malove_search:
    '//s3.marpple.co/files/u_4648126/2025/1/original/bae97ba5d61368ba9bff0a71f2f54a59dd32af3a37.webp',
  malove_clover:
    '//s3.marpple.co/files/u_4648126/2025/1/original/42bfd21fb67082b8e7425b96d33e924fb7cd26ba38.webp',
  malove_puzzle:
    '//s3.marpple.co/files/u_4648126/2025/1/original/b93c890d1bb9e913781b04badb1721947a7fcd6823.webp',
  malove_furry:
    '//s3.marpple.co/files/u_4648126/2025/1/original/de5bedce8bca0b8180bfdf7ded548f25cba94f7c22.webp',
  malove_cs:
    '//s3.marpple.co/files/u_4648126/2025/1/original/ead4dcaba248b7bf56e3d542ea3b76039d90563f12.webp',
  malove_youtube:
    '//s3.marpple.co/files/u_4648126/2025/1/original/def472ecd517844f85017d59eb0be9e715256b4c11.webp',
  malove_creative_1:
    '//s3.marpple.co/files/u_4648126/2025/1/original/c315519b603aa313e58ff8e479b8ed4b89c0f2b55.webp',
  malove_creative_5:
    '//s3.marpple.co/files/u_4648126/2025/1/original/e6384b88abee475a77d0813d903355ff266da6f56.webp',
  malove_creative_6:
    '//s3.marpple.co/files/u_4648126/2025/1/original/0b40014e4d91744768fc22b23c2c86fed8219b9e7.webp',
  malove_creative_7:
    '//s3.marpple.co/files/u_4648126/2025/1/original/3a265ffb055068c3572957188897df0651ce36428.webp',
  malove_creative_8:
    '//s3.marpple.co/files/u_4648126/2025/1/original/6a3d4bb1da07c585d64b9385f053355a840aaf1e9.webp',
  malove_virtual:
    '//s3.marpple.co/files/u_4648126/2025/1/original/e900409f560d3957c5eab61687265b0d3cea707e10.webp',
  malove_thankyou:
    '//s3.marpple.co/files/u_4648126/2025/1/original/5b0167c9af203161a0156d4c4a5acc55d9246cab4.webp',
  malove_congratulation:
    '//s3.marpple.co/files/u_4648126/2025/1/original/7aef402e0d4dce1bdc63eb1d9fce406c175f4cf43.webp',
  malove_birthday:
    '//s3.marpple.co/files/u_4648126/2025/1/original/7ab52927cf9f673efa732db285c0163cf4c724c91.webp',
  malove_cheerup:
    '//s3.marpple.co/files/u_4648126/2025/1/original/56599b51645630bc672fa5b339393e0b498a46be2.webp',
  malove_enterprise_1:
    '//s3.marpple.co/files/u_4648126/2025/1/original/7706ad09ffc4ee4815c9b4661e63be0d42b792a621.webp',
  malove_enterprise_2:
    '//s3.marpple.co/files/u_4648126/2025/1/original/59492c7462849b9accd4e1ebf312984fc3e3b8bf20.webp',
  keyring: '//s3.marpple.co/files/u_4648126/2025/1/original/e6de94b6dc0a007bd9d5373d89f4ecbff160253533.webp',
  cousion: '//s3.marpple.co/files/u_4648126/2025/1/original/4401243d5ef8ea7f89e30f46128e0339f9b5b6a629.webp',
  cousion_square:
    '//s3.marpple.co/files/u_4648126/2025/1/original/781761a559b443f9d6c0a5692bada1a98e61a59630.webp',
  cup: '//s3.marpple.co/files/u_4648126/2025/1/original/bb9b67f8d38297bf9afb2b01fb0ab4ee0d71459431.webp',
  cup_2: '//s3.marpple.co/files/u_4648126/2025/1/original/e1dfbaceb69d4cb275cbc67b1bf5ffade1eab14a32.webp',
  phonecase:
    '//s3.marpple.co/files/u_4648126/2025/1/original/59ce7fc5ae20bf81899e51031e6cf74ff349719134.webp',
  sticker: '//s3.marpple.co/files/u_4648126/2025/1/original/0e4d38d44b84be100190268b950cfb2f255c14a535.webp',
  present_box:
    '//s3.marpple.co/files/u_4648126/2025/1/original/0bafc6903af8a8efeafd0cd41429c3702e0c8bee15.webp',
  delivery_box:
    '//s3.marpple.co/files/u_4648126/2025/1/original/47edaa56949ad28ae8e84534fbebb818383cb7d613.webp',
  pod_product:
    '//s3.marpple.co/files/u_4648126/2025/1/original/db1ff86768761ce62710e51d446c002d557ee90127.webp',
  pod_shirt:
    '//s3.marpple.co/files/u_4648126/2025/1/original/a10521bc832d32a626f5573fe154c93a09b09efd28.webp',
  pod_design_1:
    '//s3.marpple.co/files/u_4648126/2025/1/original/181760e1efdce320c22cf3795fd4afdc84ae6e0e25.webp',
  pod_design_2:
    '//s3.marpple.co/files/u_4648126/2025/1/original/ee45963555fd998c7334c3e94bcde0d0c131ceef26.webp',
  delivery: '//s3.marpple.co/files/u_4648126/2025/1/original/181760e1efdce320c22cf3795fd4afdc84ae6e0e25.webp',
  like_product:
    '//s3.marpple.co/files/u_4648126/2025/1/original/b141a895b9af559447d885f3cfc994819c61bfed17.webp',
  like_creator:
    '//s3.marpple.co/files/u_4648126/2025/1/original/571463e6162157d0ddf3f74b559a7a90353c8de916.webp',
  limited_edition_1:
    '//s3.marpple.co/files/u_4648126/2025/1/original/0783312a539d3d3461e1e83a11df3a76b4eeca1c18.webp',
  limited_edition_2:
    '//s3.marpple.co/files/u_4648126/2025/1/original/85a1cb7267f0ad27048baf24c01a2f43d48914b519.webp',
  note: '//s3.marpple.co/files/u_4648126/2025/1/original/18aab258c0d01adbe37e23385df62b04ef4fedae24.webp',
  popup_store:
    '//s3.marpple.co/files/u_4648126/2025/1/original/7f76f76c5a724aa833e3d7ff56059f79fdc308211.webp',
  wiki_1: '//s3.marpple.co/files/u_4648126/2025/1/original/3901fe3c61a5c53e766c309c03d8f6bff4dd13e32.webp',
  wili_2: '//s3.marpple.co/files/u_4648126/2025/1/original/db2eff76c260dfe407b45a31d419ea3afabb321a3.webp',
  wiki_3: '//s3.marpple.co/files/u_4648126/2025/1/original/6d059d143d0e73c8f6d021d6fcf4ede403467cac4.webp',
  newpost: '//s3.marpple.co/files/u_4648126/2025/1/original/b909d26ad621afe03c061a8a3a5998ec44c4536b5.webp',
  book_red: '//s3.marpple.co/files/u_4648126/2025/1/original/f2ee99fa5820a0e9f77139c111ad7d90e165fcd76.webp',
  book_blue: '//s3.marpple.co/files/u_4648126/2025/1/original/0cb49675501f22f20f89334e47fb1df55be8475a7.webp',
  cart: '//s3.marpple.co/files/u_4648126/2025/1/original/ce894b9a5bbd37d8594ef61e2515390d8b48cd0e8.webp',
  ranking_star:
    '//s3.marpple.co/files/u_4648126/2025/1/original/3612e0f005b9b4e13a05936aabe5de5e9ec8d94e9.webp',
  ranking_trophy:
    '//s3.marpple.co/files/u_4648126/2025/1/original/f19efb4409a3f66b95069aa04f27939dab58c86510.webp',
  payment: '//s3.marpple.co/files/u_4648126/2025/1/original/2df8d8b29a1113ba75e35b2780acb014adde65f21.webp',
  chart: '//s3.marpple.co/files/u_4648126/2025/1/original/ff3ab385f3c851556df1d9ae8ae2f5f0a5a7a6a511.webp',
  review: '//s3.marpple.co/files/u_4648126/2025/1/original/b97af745bf86b623b30e0a9d1967fd07343d90a312.webp',
  like_tag: '//s3.marpple.co/files/u_4648126/2025/1/original/4ae7500eae2d661b8ff63503ca4a6f149bba58b313.webp',
  like_btn: '//s3.marpple.co/files/u_4648126/2025/1/original/0fc23ecb50cb3d27ba97fc1cd68cead0a5a158ed14.webp',
  qna: '//s3.marpple.co/files/u_4648126/2025/1/original/e530823ed1f3256d920a57c6dc544e5c2c81834f15.webp',
  product_empty:
    '//s3.marpple.co/files/u_4648126/2025/5/original/0a65f8b3255876902b0d8d06c353435835de0e601.png',
  ticket_creator:
    '//s3.marpple.co/files/u_4648126/2025/1/original/6d9fbda8836976ce765f3fa82e1d73302db2b39c17.webp',
  ticket_m_pluse:
    '//s3.marpple.co/files/u_4648126/2025/1/original/28f0b66498e1fb1281f335d8e242dc84b521096318.webp',
  ticket_enterprise:
    '//s3.marpple.co/files/u_4648126/2025/1/original/e990367497d73bab643ab73fbdd4e0ffcdef117019.webp',
  coin: '//s3.marpple.co/files/u_4648126/2025/1/original/3897d7de25a08f6dde061be8324a6ce70ec9cbec20.webp',
  clip: '//s3.marpple.co/files/u_4648126/2025/1/original/ce8d395c38568257c3ca9d25951b61f84f62113b21.webp',
  notice: '//s3.marpple.co/files/u_4648126/2025/1/original/b35554fa365a678fd6b434dff8b408c1056f203122.webp',
  timer: '//s3.marpple.co/files/u_4648126/2025/1/original/d56e67865015deacf10ae990a2c8045f146931e223.webp',
  sns: '//s3.marpple.co/files/u_4648126/2025/1/original/26c49e33ada564efb51ba2d0e5bd27b22b2f8ff624.webp',
  payment_2:
    '//s3.marpple.co/files/u_4648126/2025/1/original/bff2ae39454c704af5e3bd25325d86c27bb6258225.webp',
  money: '//s3.marpple.co/files/u_4648126/2025/1/original/dc520d9180829ff967077adfe0e9299dd3a1f52a26.webp',
  coins: '//s3.marpple.co/files/u_4648126/2025/1/original/c23392ecbe8a4fbcb2e094969a715bb5f484e8c927.webp',
  no_image: '//s3.marpple.co/files/u_4648126/2025/1/original/69c4810f248ad7897fea6432385ef69659e0d5db28.webp',
  sale: '//s3.marpple.co/files/u_4648126/2025/1/original/f6f1d88a1f80030ba2637a169789a098dc2ed87929.webp',
  time_limit:
    '//s3.marpple.co/files/u_4648126/2025/1/original/b23866c35aaac71222d361d4238b1ad4bf3bfccb30.webp',
  truck_1: '//s3.marpple.co/files/u_4648126/2025/1/original/cc0384ec16763bfc42abd2c48fcec66bbfb6769431.webp',
  truck_2: '//s3.marpple.co/files/u_4648126/2025/1/original/7755df1a7ecdcad7637e8071141ea740e0d171f832.webp',
  bouquet_mini:
    '//s3.marpple.co/files/u_4648126/2025/1/original/65e71db14d23a04efdcb50f537521152158cbdf833.webp',
  bouquet: '//s3.marpple.co/files/u_4648126/2025/1/original/c66a96c3141fea6c264ac779d03e56206105c47634.webp',
  ballons: '//s3.marpple.co/files/u_4648126/2025/1/original/5213544e6753a7813b18a5dd71e1f7c64e9b868f35.webp',
  present_boxed:
    '//s3.marpple.co/files/u_4648126/2025/1/original/977461a1eb3e261c2bd3f9cb931ff03805588c7436.webp',
  cup_cake: '//s3.marpple.co/files/u_4648126/2025/1/original/8616c8c85c09b7e53fc8b4c19b1e168a2ef1eff837.webp',
  letter_ballon_heart_1:
    '//s3.marpple.co/files/u_4648126/2025/1/original/de8a0674f7ac302b24f155295a337ea6b24ab53a38.webp',
  letter_ballon_heart_2:
    '//s3.marpple.co/files/u_4648126/2025/1/original/baf04cffd136a33f8ff5e05acbf04c74af2b474239.webp',
  letter_ballon_m_1:
    '//s3.marpple.co/files/u_4648126/2025/1/original/4b5aa19878ab9428dd609e23fdefefcb9ac850de40.webp',
  letter_ballon_m_2:
    '//s3.marpple.co/files/u_4648126/2025/1/original/66b212e26613917c0e92759dc40393997e681e2c41.webp',
  wine_glass_1:
    '//s3.marpple.co/files/u_4648126/2025/1/original/66386b8dad90dad8f7ef14bea02cb4d3e0f142d642.webp',
  wine_glass_2:
    '//s3.marpple.co/files/u_4648126/2025/1/original/aba7718bc01ee07fae01dc77f87450c028fa6dcd43.webp',
  ballon_birthday:
    '//s3.marpple.co/files/u_4648126/2025/1/original/4128ab954d925319f1fd573ce48c314835f1295144.webp',
  cake_cutted:
    '//s3.marpple.co/files/u_4648126/2025/1/original/ed741149650860b8583240d3a4a9865861f56c2845.webp',
  cake_piece:
    '//s3.marpple.co/files/u_4648126/2025/1/original/d1f6129e9aae094fedfbf1bcd426d0cb940cc46646.webp',
  cake_whole:
    '//s3.marpple.co/files/u_4648126/2025/1/original/868054ff99e1851bd492e9c609a90c17dc06e2eb47.webp',
  garlands_1:
    '//s3.marpple.co/files/u_4648126/2025/1/original/86dbdaf912bb849d6596914bd9e1c103cadc2ec948.webp',
  garlands_2:
    '//s3.marpple.co/files/u_4648126/2025/1/original/72e9f390de920c85e21873d87057813ce6277ffd49.webp',
  garlands_3:
    '//s3.marpple.co/files/u_4648126/2025/1/original/9d4709bec0bdfb562075d7d930785eef5e87bca850.webp',
  vase_clover:
    '//s3.marpple.co/files/u_4648126/2025/1/original/f313564ef668b44dff4ea2ed0967d4fb8b9c01ed51.webp',
  cheerup_trophy:
    '//s3.marpple.co/files/u_4648126/2025/1/original/0810e4718385ab12766bac7cc3342b9f13ddfa7f1.webp',
  loud_speaker:
    '//s3.marpple.co/files/u_4648126/2025/1/original/a6c12b501206309d3cadb4ded6028469cfc7418126.webp',
  cheerup_stick:
    '//s3.marpple.co/files/u_4648126/2025/1/original/20cd4d472de8cf4d28c96ebf5267796eb963119225.webp',
  good_luck_card:
    '//s3.marpple.co/files/u_4648126/2025/1/original/f036bde9528890be7ff157474c331ef3b5cffa9924.webp',
  collection:
    '//s3.marpple.co/files/u_4648126/2025/1/original/c8bf4145cac154209503a96abce3fb39ad08927623.webp',
  check_out:
    '//s3.marpple.co/files/u_4648126/2025/1/original/074e863deef68efdb5bc054815a97ec8238c518522.webp',
  party_balloon:
    '//s3.marpple.co/files/u_4648126/2025/1/original/4bd5851ca0540f4efbf0da466ae3bb5ed0f7be3121.webp',
  party_balloon_2:
    '//s3.marpple.co/files/u_4648126/2025/1/original/5cc447418e3c786d71b8ce2088e816b2bba0c6b620.webp',
  party_balloon_3:
    '//s3.marpple.co/files/u_4648126/2025/1/original/65c6a7f5d3a30e12653b27477aec4b6886f7c73819.webp',
  party_balloon_3_1:
    '//s3.marpple.co/files/u_4648126/2025/1/original/7c149ec67bfc795aa4373d58a18d2214f8bf849d18.webp',
  party_balloon_4:
    '//s3.marpple.co/files/u_4648126/2025/1/original/d9e8656a7d2375362c15c55409d52cd75a98d5eb17.webp',
  party_balloon_5:
    '//s3.marpple.co/files/u_4648126/2025/1/original/58129a1aadc134536df1aba76984c3d89df43b4f16.webp',
  '500_error':
    '//s3.marpple.co/files/u_4648126/2025/1/original/870ed5b26a7bf2a268d3ed5d81ce497c45343a5815.webp',
  delivery_complete:
    '//s3.marpple.co/files/u_4648126/2025/1/original/6305794d49712163ce4d5f5f86ff18423a31d4c114.webp',
  '404_error':
    '//s3.marpple.co/files/u_4648126/2025/1/original/964e3655346b6c5d128e347f0245cc18260e8c8013.webp',
  explorer_error:
    '//s3.marpple.co/files/u_4648126/2025/1/original/6305794d49712163ce4d5f5f86ff18423a31d4c114.webp',
  explorer_error_2:
    '//s3.marpple.co/files/u_4648126/2025/1/original/78f9c46b13697c04a03b8662c26990947919ed0f11.webp',
  prepare_store:
    '//s3.marpple.co/files/u_4648126/2025/1/original/870aeddd964fca140e389842dc89afc33dc5ee569.webp',
  prepare_store_2:
    '//s3.marpple.co/files/u_4648126/2025/1/original/b9eb13fd78bd4dc3818825df96e9f714c260816f10.webp',
  siren_1: '//s3.marpple.co/files/u_4648126/2025/1/original/6cd753583b538e5e1991e720076f5f9a7a44a26e8.webp',
  email: '//s3.marpple.co/files/u_4648126/2025/1/original/89b1b7b2bb722bca2b922eddad75a102958bac467.webp',
  store: '//s3.marpple.co/files/u_4648126/2025/1/original/20c1054a78c5640d9b2bfb9195170c4592f759756.webp',
  digital: '//s3.marpple.co/files/u_4648126/2025/1/original/31bcef3ec9ae88dade90ed53d3c3e6fa88f4cd815.webp',
  siren_2: '//s3.marpple.co/files/u_4648126/2025/1/original/53137da265bcbd073857a2b9d8db25978dc7727b4.webp',
  cancel_1: '//s3.marpple.co/files/u_4648126/2025/1/original/af731909ffcb1acbee87b16e05f8b0a81e01f5113.webp',
  cancel_2: '//s3.marpple.co/files/u_4648126/2025/1/original/e5f6a48889b8b2ef00b85693d53055cbaea60b512.webp',
  cancel_3: '//s3.marpple.co/files/u_4648126/2025/1/original/2e093335832d38de2570775bce82b57431fadc0757.webp',
  popup: '//s3.marpple.co/files/u_4648126/2025/1/original/edfc8808eabc58a7539dceac84933d00afb5d4591.webp',
  membership_goods_blue:
    '//s3.marpple.co/files/u_4648126/2025/1/original/03683088126dc986864bcdb0df38f7f69e1f273556.webp',
  membership_goods_white:
    '//s3.marpple.co/files/u_4648126/2025/1/original/05177e033d17ca3b3c599968168373cf3fd147f155.webp',
  membership_meet_fan:
    '//s3.marpple.co/files/u_4648126/2025/1/original/cb426b0135ef442ccf20dcaa4f5ed1499096bc2c54.webp',
  membership_special_myluv:
    '//s3.marpple.co/files/u_4648126/2025/1/original/7bdf0237343858f865ac898d3a1e2ccab7368aca53.webp',
  membership_diamond_blue:
    '//s3.marpple.co/files/u_4648126/2025/1/original/a134b7ad73abd1df83dc674be9a42174b92db71152.webp',
  membership_diamond_sliver:
    '//s3.marpple.co/files/u_4648126/2025/1/original/3d1937a249db34e4cff240515ca315a53e9477df51.webp',
  membership_badge_2:
    '//s3.marpple.co/files/u_4648126/2025/1/original/1289a778461da70ab9f7c995377839790ceacc9350.webp',
  membership_badge_blue:
    '//s3.marpple.co/files/u_4648126/2025/1/original/01e46e426fb796773896d8ec20e646bb19f96e8a49.webp',
  membership_badge_silver:
    '//s3.marpple.co/files/u_4648126/2025/1/original/a190ae23f6831569da1b490f8ee3b8a27f726ae148.webp',
  membership_comission_blue:
    '//s3.marpple.co/files/u_4648126/2025/1/original/0d89287f63b37cf789ac79efce89bed4d2f2d2d047.webp',
  membership_comission_white:
    '//s3.marpple.co/files/u_4648126/2025/1/original/7506650cf3922fa492e69e8280f71579a15bc0da46.webp',
  membership_community:
    '//s3.marpple.co/files/u_4648126/2025/1/original/b488907074d2a4e590abb82c52835504588f502845.webp',
  membership_donation_silver:
    '//s3.marpple.co/files/u_4648126/2025/1/original/5fcd62ae82498fdb98d65d21c05f2c638ac0057344.webp',
  membership_donation_blue:
    '//s3.marpple.co/files/u_4648126/2025/1/original/e9ceddf2fa01a5e7ecd138bac9388d5e62e1340143.webp',
  membership_donation_completed:
    '//s3.marpple.co/files/u_4648126/2025/1/original/05086bae4f1e3eb27cc48c523a2b2b7a2e45ed6842.webp',
  membership_fan_cafe_ciety:
    '//s3.marpple.co/files/u_4648126/2025/1/original/6fa16873cdb22c0b6127ab6745f2862f42fdc6f541.webp',
  membership_fan_cafe:
    '//s3.marpple.co/files/u_4648126/2025/1/original/2112ac48e01409ae51d7872364f30eeb6d55f6da40.webp',
  membership_subscribe:
    '//s3.marpple.co/files/u_4648126/2025/1/original/3860cc6536429882bc7a1517092547896772d24f39.webp',
  myluv_sad:
    '//s3.marpple.co/files/u_4648126/2025/1/original/e026946bbe479cc69683733fa3bd24f30f91884538.webp',
  myluv_sad_2:
    '//s3.marpple.co/files/u_4648126/2025/1/original/9a271e0fda187aacfea75723bf91758211ab66a337.webp',
  handcraft_wood:
    '//s3.marpple.co/files/u_4648126/2025/1/original/67ee666bce0024f84f7a244b615fc868c32d702336.webp',
  handcraft_emboridery:
    '//s3.marpple.co/files/u_4648126/2025/1/original/cdebd2757f50f0c7618d0773ed67c976c2d4d7c135.webp',
  handcraft_paper_comb:
    '//s3.marpple.co/files/u_4648126/2025/1/original/08716abc8adaa20605cc2b2e7f47456ff31dc01534.webp',
  handcraft_paper:
    '//s3.marpple.co/files/u_4648126/2025/1/original/0e0bb112157ee197440aef84c690438eac9590e133.webp',
  handcraft_paper_2:
    '//s3.marpple.co/files/u_4648126/2025/1/original/f77a2dc9cb8bfba2631a5fa31a32c23653aa038532.webp',
  handcraft_glass_comb:
    '//s3.marpple.co/files/u_4648126/2025/1/original/07bde95c75d6ce630f9236cd6fd130381ac8f8ed31.webp',
  handcraft_glass:
    '//s3.marpple.co/files/u_4648126/2025/1/original/f09f83936789d54ecd31343fc5968b360343262630.webp',
  handcraft_glass_2:
    '//s3.marpple.co/files/u_4648126/2025/1/original/4d15f072bf01b1e2e2c2b168667dac6ad0c6176f29.webp',
  handcraft_food_comb:
    '//s3.marpple.co/files/u_4648126/2025/1/original/0833f193f85b5134bb725913eea947220c0f8e8d28.webp',
  handcraft_food_blue:
    '//s3.marpple.co/files/u_4648126/2025/1/original/caef705155361d222dab43b2c6cfbd949c52a31127.webp',
  handcraft_food_yellow:
    '//s3.marpple.co/files/u_4648126/2025/1/original/099f313edfe0a29bef24f35a6baa40c3c46ad9b426.webp',
  handcraft_fluffy_flower:
    '//s3.marpple.co/files/u_4648126/2025/1/original/a45ebd0516ca644770bb704d9de4456169ebf22325.webp',
  handcraft_cosmetic_violet:
    '//s3.marpple.co/files/u_4648126/2025/1/original/2f29f15d4b06081476f7db524d53cf71af154c1824.webp',
  handcraft_cosmetic_green:
    '//s3.marpple.co/files/u_4648126/2025/1/original/a30428ba124c9ecd8f60e7d367db3fbf9cf4847623.webp',
  handcraft_clay_comb:
    '//s3.marpple.co/files/u_4648126/2025/1/original/ac092125e5a101da2fde6328a7c805495534325e22.webp',
  handcraft_clay:
    '//s3.marpple.co/files/u_4648126/2025/1/original/9b4c520b49c6ef6ebddb539ce441364f5401034621.webp',
  handcraft_clay_2:
    '//s3.marpple.co/files/u_4648126/2025/1/original/794a7f34ca2384017d79ed578e99ba8ee59249e620.webp',
  handcraft_clay_3:
    '//s3.marpple.co/files/u_4648126/2025/1/original/25cbe2816eccd3297a95101b23fad96e961d020b19.webp',
  handcraft_candle_comb:
    '//s3.marpple.co/files/u_4648126/2025/1/original/919873e6d76d1abae572e6950b4bb9040afcebbb18.webp',
  handcraft_candle_1:
    '//s3.marpple.co/files/u_4648126/2025/1/original/9e7816678ced74f771d12712c087563e826dbe5f17.webp',
  handcraft_candle_2:
    '//s3.marpple.co/files/u_4648126/2025/1/original/8d414e10848c870ce9b02fe2906e75862e96288e16.webp',
  handcraft_candle_3:
    '//s3.marpple.co/files/u_4648126/2025/1/original/48af960a5206704d3474e0fff848d6fed37fd5da15.webp',
  handcraft_myluv:
    '//s3.marpple.co/files/u_4648126/2025/1/original/f1cad05e6438ddb69f0fcc6e2e9fcc16f10a0c3414.webp',
  handcraft_myluv_2:
    '//s3.marpple.co/files/u_4648126/2025/1/original/b8995f2c0c37d2aad332980765a59abef9ad79fa13.webp',
  product_ex_chip:
    '//s3.marpple.co/files/u_4648126/2025/1/original/08de558b28af5bb18259a0a79d03fb83c245020d12.webp',
  product_ex_chip_R:
    '//s3.marpple.co/files/u_4648126/2025/1/original/d633f55c88ab4cdb420aa86624f6f112d0b317f111.webp',
  product_ex_icecream:
    '//s3.marpple.co/files/u_4648126/2025/1/original/31459a127c1db5a87c66b1c8cb1f2e30fbed6df210.webp',
  product_ex_icecream_R:
    '//s3.marpple.co/files/u_4648126/2025/1/original/e701e975a701416ad37ba83a1f6b7cf8d304cd589.webp',
  myluv_partner:
    '//s3.marpple.co/files/u_4648126/2025/1/original/16fea23b9149b9204f1e93a8650268573094e3088.webp',
  myluv_ludolf_santa:
    '//s3.marpple.co/files/u_4648126/2025/1/original/d9107d03ba6789aba3903cb13695dc79778358267.webp',
  myluv_santa:
    '//s3.marpple.co/files/u_4648126/2025/1/original/85a500d85b0248732d16f6de4f5c526e0bc2ff266.webp',
  myluv_ludolf:
    '//s3.marpple.co/files/u_4648126/2025/1/original/e9db44ed255ef8329a5ab05a1f2ae4bc11bd9f465.webp',
  myluv_ludolf_2:
    '//s3.marpple.co/files/u_4648126/2025/1/original/59159d0d0e22d926a1bc5f147441bf23b03b392e4.webp',
  myluv_ludolf_santa_2:
    '//s3.marpple.co/files/u_4648126/2025/1/original/e2a06fa9b7f3359b4161b49b2d9c45ab6539cac13.webp',
  myluv_santa_box:
    '//s3.marpple.co/files/u_4648126/2025/1/original/5f9bbe0802c139060f1b926514f49d2246be46292.webp',
};
